/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** File in Base64 string */
  Base64File: string;
  /** Pagination cursor */
  Cursor: string;
  /** date ISO_8601 UTC YYYY-MM-DDTHH:MM:SS.MMZ */
  Datetime: string;
  /** format YYYY-MM-DD */
  Day: string;
  /** DebitInstructionDay */
  DebitInstructionDay: any;
  /** Encoded ID */
  EncodedID: string;
  /** Long integer supporting values beyond Int32 range (safe up to 2^53-1) */
  Long: any;
  /** PageOptions */
  PageOptions: any;
  /** URL */
  URL: string;
  /** File upload */
  Upload: File;
};

export type Account = {
  accounting: Accounting;
  bankingInformation: DebitCreditBankingInformation;
  branch?: Maybe<Branch>;
  count: AccountStat;
  customer: Customer;
  documentCategories: Array<DocumentCategory>;
  documents: DocumentConnection;
  hasRestrictedAccess: Scalars['Boolean'];
  manager?: Maybe<Manager>;
  missionTargets: Array<Housing>;
  number: Scalars['String'];
  quality: AccountQualityEnum;
  showEdenredHeadband: Scalars['Boolean'];
  uuid: Scalars['EncodedID'];
};


export type AccountDocumentCategoriesArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  customerPortalCategories?: InputMaybe<Array<CustomerPortalFileCategoryEnum>>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type AccountDocumentsArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  customerPortalCategory: CustomerPortalFileCategoryEnum;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['String']>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
  originalFilename?: InputMaybe<Scalars['String']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  subCategories?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['String']>;
};

/** Feature flags of one customer account: those its managing agency has, none of them repeated from the global ones */
export type AccountFeatureFlags = {
  __typename: 'AccountFeatureFlags';
  accountId: Scalars['ID'];
  specificFeatures: Array<FeatureFlagNamesEnum>;
};

export enum AccountQualityEnum {
  CoOwner = 'CO_OWNER',
  Landlord = 'LANDLORD',
  Tenant = 'TENANT'
}

export type AccountStat = {
  __typename: 'AccountStat';
  buildings: Scalars['Int'];
  units: Scalars['Int'];
};

export type Accounting = {
  __typename: 'Accounting';
  currentBalance: Amount;
  debits: AccountingDebitConnection;
  exportedData: Scalars['String'];
  lines: AccountingLineConnection;
  payments: AccountingPaymentConnection;
  projectedBalance: Amount;
};


export type AccountingDebitsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
};


export type AccountingExportedDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
};


export type AccountingLinesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
};


export type AccountingPaymentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
};

export type AccountingDebit = Node & {
  __typename: 'AccountingDebit';
  amount: Amount;
  chargeKind?: Maybe<BudgetKindEnum>;
  createdAt: Scalars['Datetime'];
  id: Scalars['ID'];
  instructionDate: Scalars['Datetime'];
  isAuto?: Maybe<Scalars['Boolean']>;
  motive: Scalars['String'];
  status: MediaPaymentStatusEnum;
};

export type AccountingDebitConnection = {
  __typename: 'AccountingDebitConnection';
  edges: Array<AccountingDebitNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AccountingDebitNode = {
  __typename: 'AccountingDebitNode';
  node: AccountingDebit;
};

export type AccountingLine = Node & {
  __typename: 'AccountingLine';
  amount: CreditDebit;
  dueDate: Scalars['Datetime'];
  id: Scalars['ID'];
  invoiceId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  valueDate: Scalars['Datetime'];
};

export type AccountingLineConnection = {
  __typename: 'AccountingLineConnection';
  edges: Array<AccountingLineNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AccountingLineNode = {
  __typename: 'AccountingLineNode';
  node: AccountingLine;
};

export type AccountingPayment = Node & {
  __typename: 'AccountingPayment';
  amount: Amount;
  chargeKind?: Maybe<BudgetKindEnum>;
  createdAt: Scalars['Datetime'];
  id: Scalars['ID'];
  instructionDate?: Maybe<Scalars['Datetime']>;
  isAuto?: Maybe<Scalars['Boolean']>;
  motive: Scalars['String'];
  paymentUrl?: Maybe<Scalars['String']>;
  status: MediaPaymentStatusEnum;
};

export type AccountingPaymentConnection = {
  __typename: 'AccountingPaymentConnection';
  edges: Array<AccountingPaymentNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AccountingPaymentNode = {
  __typename: 'AccountingPaymentNode';
  node: AccountingPayment;
};

export type AccountingPeriod = {
  __typename: 'AccountingPeriod';
  closingDate: Scalars['Datetime'];
  id: Scalars['String'];
  name: Scalars['String'];
  openingDate: Scalars['Datetime'];
  status?: Maybe<AccountingPeriodStatusEnum>;
};

export type AccountingPeriodConnection = {
  __typename: 'AccountingPeriodConnection';
  edges: Array<AccountingPeriodNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type AccountingPeriodNode = {
  __typename: 'AccountingPeriodNode';
  node: AccountingPeriod;
};

export enum AccountingPeriodStatusEnum {
  AccountsApproved = 'ACCOUNTS_APPROVED',
  AccountsApprovedWithReservation = 'ACCOUNTS_APPROVED_WITH_RESERVATION',
  AccountsNotVoted = 'ACCOUNTS_NOT_VOTED',
  AccountsRefused = 'ACCOUNTS_REFUSED',
  AllocationProjectDone = 'ALLOCATION_PROJECT_DONE',
  Approved = 'APPROVED',
  Divided = 'DIVIDED',
  Open = 'OPEN',
  Refused = 'REFUSED',
  ToAllocate = 'TO_ALLOCATE',
  ToBeValidatedByPropertyManager = 'TO_BE_VALIDATED_BY_PROPERTY_MANAGER',
  ToValidateByAccountant = 'TO_VALIDATE_BY_ACCOUNTANT',
  ToValidateByTrustee = 'TO_VALIDATE_BY_TRUSTEE',
  ValidatedByTrustee = 'VALIDATED_BY_TRUSTEE'
}

export type ActivityMetadata = {
  __typename: 'ActivityMetadata';
  associateAfter?: Maybe<Scalars['String']>;
  associateBefore?: Maybe<Scalars['String']>;
  categoryAfter?: Maybe<TicketCategoryEnum>;
  categoryBefore?: Maybe<TicketCategoryEnum>;
};

export type Address = {
  __typename: 'Address';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<CountryCodeEnum>;
  zipCode?: Maybe<Scalars['String']>;
};

export type Agency = {
  __typename: 'Agency';
  id: Scalars['String'];
};

export type Allocation = {
  __typename: 'Allocation';
  code: Scalars['String'];
  expenseTypes: Array<ExpenseType>;
  id: Scalars['String'];
  name: Scalars['String'];
  recoverable: Amount;
  toAllocate: Amount;
  vat: Amount;
};

export type Amount = {
  __typename: 'Amount';
  currency: CurrencyEnum;
  value: Scalars['Long'];
};

export type AmountInput = {
  currency?: InputMaybe<CurrencyEnum>;
  value?: InputMaybe<Scalars['Int']>;
};

export enum AnalyticsCustomEventNameEnum {
  AutomaticPaymentSubscription = 'AUTOMATIC_PAYMENT_SUBSCRIPTION',
  DashboardNewTicket = 'DASHBOARD_NEW_TICKET',
  ErecoSubscription = 'ERECO_SUBSCRIPTION',
  EstateNewTicket = 'ESTATE_NEW_TICKET',
  HeaderNewTicket = 'HEADER_NEW_TICKET',
  HeaderTicketsPage = 'HEADER_TICKETS_PAGE',
  MyDemandsNewTicket = 'MY_DEMANDS_NEW_TICKET',
  NatixisPayment = 'NATIXIS_PAYMENT',
  NoSnailMailSubscription = 'NO_SNAIL_MAIL_SUBSCRIPTION',
  OnDemandPayment = 'ON_DEMAND_PAYMENT',
  PaymentNewTicket = 'PAYMENT_NEW_TICKET',
  PostalVote = 'POSTAL_VOTE',
  SaleAgreementSubscription = 'SALE_AGREEMENT_SUBSCRIPTION',
  SidebarTicketsPage = 'SIDEBAR_TICKETS_PAGE',
  TicketMessagesNewTicket = 'TICKET_MESSAGES_NEW_TICKET'
}

export type BankingInformation = {
  __typename: 'BankingInformation';
  detail?: Maybe<BankingInformationDetail>;
  isOutdated?: Maybe<Scalars['Boolean']>;
  sepaMandate?: Maybe<Document>;
};

export type BankingInformationDetail = Node & {
  __typename: 'BankingInformationDetail';
  bic: Scalars['String'];
  iban: Scalars['String'];
  ics?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastPaymentDate?: Maybe<Scalars['Datetime']>;
  mandate: BankingInformationDetailMandate;
  name: Scalars['String'];
};

export type BankingInformationDetailMandate = {
  __typename: 'BankingInformationDetailMandate';
  mandateReferenceNumber: Scalars['String'];
  signatureDate: Scalars['Datetime'];
};

export type BoilerContract = {
  __typename: 'BoilerContract';
  /** Date de fin du contrat du système de chauffage */
  endDate?: Maybe<Scalars['Datetime']>;
  /** Indique si une attestation d entretien chauffage est nécessaire */
  needHeatingCertificate: Scalars['Boolean'];
};

export type Branch = Node & {
  __typename: 'Branch';
  address: Address;
  agency: Agency;
  commercialName: Scalars['String'];
  contact: BranchContact;
  id: Scalars['ID'];
  schedule: Array<BranchHour>;
};

export type BranchContact = {
  __typename: 'BranchContact';
  coOwnerSinisterPhone?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  telephone?: Maybe<Scalars['String']>;
  tenantSinisterPhone?: Maybe<Scalars['String']>;
};

export type BranchHour = {
  __typename: 'BranchHour';
  day?: Maybe<Scalars['String']>;
  endHourAm?: Maybe<Scalars['String']>;
  endHourPm?: Maybe<Scalars['String']>;
  onAppointmentAm?: Maybe<Scalars['Boolean']>;
  onAppointmentPm?: Maybe<Scalars['Boolean']>;
  startHourAm?: Maybe<Scalars['String']>;
  startHourPm?: Maybe<Scalars['String']>;
};

export enum BrandCodeEnum {
  Esset = 'esset',
  Foncia = 'foncia'
}

export enum BudgetKindEnum {
  CashAdvance = 'CASH_ADVANCE',
  CashAdvanceArt186 = 'CASH_ADVANCE_ART186',
  CurrentExpenses = 'CURRENT_EXPENSES',
  OthersCashAdvance = 'OTHERS_CASH_ADVANCE',
  RepairToDo = 'REPAIR_TO_DO',
  WorkFundReserve = 'WORK_FUND_RESERVE'
}

export type Building = Node & {
  __typename: 'Building';
  address: Address;
  conciergeOffice?: Maybe<BuildingConciergeOffice>;
  id: Scalars['ID'];
  name?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  numberOfElevators?: Maybe<Scalars['Int']>;
  physicalBuildings: Array<PhysicalBuilding>;
  shareBase?: Maybe<Scalars['Int']>;
  units: Array<Unit>;
};

export type BuildingAccountingCurrent = {
  __typename: 'BuildingAccountingCurrent';
  allocations: Array<BuildingAccountingCurrentAllocation>;
  closingDate: Scalars['Datetime'];
  id: Scalars['String'];
  nextVotedTotal: Amount;
  openingDate: Scalars['Datetime'];
  previousTotal: Amount;
  total: Amount;
  votedTotal: Amount;
};

export type BuildingAccountingCurrentAllocation = {
  __typename: 'BuildingAccountingCurrentAllocation';
  code: Scalars['String'];
  expenseTypes: Array<BuildingAccountingCurrentExpenseType>;
  id: Scalars['String'];
  name: Scalars['String'];
  nextVotedTotal: Amount;
  previousTotal: Amount;
  total: Amount;
  votedTotal: Amount;
};

export type BuildingAccountingCurrentExpense = {
  __typename: 'BuildingAccountingCurrentExpense';
  amount: CreditDebit;
  date: Scalars['Datetime'];
  invoiceId?: Maybe<Scalars['String']>;
  isFromPreviousPeriod: Scalars['Boolean'];
  label: Scalars['String'];
  piece?: Maybe<Document>;
};

export type BuildingAccountingCurrentExpenseType = {
  __typename: 'BuildingAccountingCurrentExpenseType';
  allocationId: Scalars['String'];
  code: Scalars['String'];
  expenses: Array<BuildingAccountingCurrentExpense>;
  id: Scalars['String'];
  name: Scalars['String'];
  nextVotedTotal: Amount;
  previousTotal: Amount;
  total: Amount;
  votedTotal: Amount;
};

export type BuildingBalance = {
  __typename: 'BuildingBalance';
  buildingId: Scalars['String'];
  total: Amount;
};

export type BuildingConciergeOffice = {
  __typename: 'BuildingConciergeOffice';
  exist: Scalars['Boolean'];
  hours?: Maybe<Scalars['String']>;
  openingDays?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type BuildingInput = {
  areAllUnitsManagedByAgency: Scalars['Boolean'];
  buildingId?: InputMaybe<Scalars['ID']>;
  totalContributionFees: AmountInput;
  wasteContributionFees: AmountInput;
};

export type BuildingRepairBudget = {
  __typename: 'BuildingRepairBudget';
  allocations: Array<Allocation>;
  budgetId: Scalars['String'];
  totalRecoverable: Amount;
  totalToAllocate: Amount;
  totalVat: Amount;
};

export type BuildingRepairBudgetType = {
  __typename: 'BuildingRepairBudgetType';
  id: Scalars['String'];
  label: Scalars['String'];
  validatedAmount: Amount;
};

export enum CivilityEnum {
  Admi = 'ADMI',
  Aful = 'AFUL',
  Agen = 'AGEN',
  Asl = 'ASL',
  Asso = 'ASSO',
  Cbt = 'CBT',
  Cie = 'CIE',
  Coop = 'COOP',
  Crts = 'CRTS',
  Doct = 'DOCT',
  Entr = 'ENTR',
  Ets = 'ETS',
  Etud = 'ETUD',
  Eurl = 'EURL',
  Fond = 'FOND',
  Gie = 'GIE',
  Grp = 'GRP',
  Hoir = 'HOIR',
  Ind = 'IND',
  LadiesGentlemens = 'LADIES_GENTLEMENS',
  Mmes = 'MMES',
  Mr = 'MR',
  Mrs = 'MRS',
  MrAndMrs = 'MR_AND_MRS',
  MrOrMrs = 'MR_OR_MRS',
  Sa = 'SA',
  Sarl = 'SARL',
  Sas = 'SAS',
  Sc = 'SC',
  Sci = 'SCI',
  Scp = 'SCP',
  Scpi = 'SCPI',
  Sdc = 'SDC',
  Selarl = 'SELARL',
  Selas = 'SELAS',
  Sirs = 'SIRS',
  Snc = 'SNC',
  Ste = 'STE',
  Trib = 'TRIB'
}

export type ComputeExpectedLessorPropertyTaxRequest = {
  fiscalYear: Scalars['Int'];
};

export type Config = {
  __typename: 'Config';
  errorCodes: ErrorCodes;
  mobile: MobileConfig;
  mockConfig: MockConfig;
};

export type ConfirmBankingInformationUpdateRequest = {
  verificationCode: Scalars['Int'];
  verifyToken: Scalars['String'];
};

export type ConfirmPasswordUpdateRequest = {
  verificationCode: Scalars['Int'];
  verifyToken: Scalars['String'];
};

export type CoownerAccount = Account & {
  __typename: 'CoownerAccount';
  accounting: Accounting;
  bankingInformation: DebitBankingInformation;
  branch?: Maybe<Branch>;
  building: Building;
  coOwnershipMandateId: Scalars['String'];
  count: AccountStat;
  customer: Customer;
  documentAccountingPeriods: Array<DocumentAccountingPeriod>;
  documentCategories: Array<DocumentCategory>;
  documents: DocumentConnection;
  eReco: CoownerAccountEReco;
  hasAccessToGeneralAssembly: Scalars['Boolean'];
  hasActiveCoOwnershipMandate: Scalars['Boolean'];
  hasEReleve: Scalars['Boolean'];
  hasRestrictedAccess: Scalars['Boolean'];
  isTrusteeCouncilMember: Scalars['Boolean'];
  manager?: Maybe<Manager>;
  missionGeneralAssemblyPerYear: Array<MissionGeneralAssemblyPerYear>;
  missionTargets: Array<Housing>;
  nextGeneralAssemblies: Array<MissionGeneralAssembly>;
  nextGeneralAssembly?: Maybe<MissionGeneralAssembly>;
  number: Scalars['String'];
  pastGeneralAssembly?: Maybe<MissionGeneralAssembly>;
  quality: AccountQualityEnum;
  showDalenysHeadband: Scalars['Boolean'];
  showEdenredHeadband: Scalars['Boolean'];
  suspendedFlow: SuspendedFlow;
  trusteeCouncil: TrusteeCouncil;
  units: Array<CoownerAccountUnits>;
  uuid: Scalars['EncodedID'];
};


export type CoownerAccountDocumentCategoriesArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  customerPortalCategories?: InputMaybe<Array<CustomerPortalFileCategoryEnum>>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type CoownerAccountDocumentsArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  customerPortalCategory: CustomerPortalFileCategoryEnum;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['String']>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
  originalFilename?: InputMaybe<Scalars['String']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  subCategories?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type CoownerAccountEReco = {
  __typename: 'CoownerAccountEReco';
  documents: CoownerAccountERecoDocumentConnection;
  hasHistory: Scalars['Boolean'];
  isSubscribed: Scalars['Boolean'];
};


export type CoownerAccountERecoDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
};

export type CoownerAccountERecoDocument = Node & {
  __typename: 'CoownerAccountERecoDocument';
  createdAt: Scalars['Datetime'];
  document: Document;
  /** @deprecated use status instead */
  hasBeenRead: Scalars['Boolean'];
  id: Scalars['ID'];
  status: MailStatusEnum;
  typeDocument: FileCategoryEnum;
  updatedAt: Scalars['Datetime'];
  url: Scalars['URL'];
  urlDepositCertificate?: Maybe<Scalars['URL']>;
};

export type CoownerAccountERecoDocumentConnection = {
  __typename: 'CoownerAccountERecoDocumentConnection';
  edges: Array<CoownerAccountERecoDocumentNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type CoownerAccountERecoDocumentNode = {
  __typename: 'CoownerAccountERecoDocumentNode';
  node: CoownerAccountERecoDocument;
};

export type CoownerAccountUnits = {
  __typename: 'CoownerAccountUnits';
  saleDate?: Maybe<Scalars['Datetime']>;
  unit: Scalars['String'];
};

export enum CountryCodeEnum {
  Abw = 'ABW',
  Afg = 'AFG',
  Ago = 'AGO',
  Aia = 'AIA',
  Alb = 'ALB',
  And = 'AND',
  Ant = 'ANT',
  Are = 'ARE',
  Arg = 'ARG',
  Arm = 'ARM',
  Asm = 'ASM',
  Ata = 'ATA',
  Atf = 'ATF',
  Atg = 'ATG',
  Aus = 'AUS',
  Aut = 'AUT',
  Aze = 'AZE',
  Bdi = 'BDI',
  Bel = 'BEL',
  Ben = 'BEN',
  Bfa = 'BFA',
  Bgd = 'BGD',
  Bgr = 'BGR',
  Bhr = 'BHR',
  Bhs = 'BHS',
  Bih = 'BIH',
  Blm = 'BLM',
  Blr = 'BLR',
  Blz = 'BLZ',
  Bmu = 'BMU',
  Bol = 'BOL',
  Bra = 'BRA',
  Brb = 'BRB',
  Brn = 'BRN',
  Btn = 'BTN',
  Bvt = 'BVT',
  Bwa = 'BWA',
  Caf = 'CAF',
  Can = 'CAN',
  Cck = 'CCK',
  Che = 'CHE',
  Chl = 'CHL',
  Chn = 'CHN',
  Civ = 'CIV',
  Cmr = 'CMR',
  Cod = 'COD',
  Cog = 'COG',
  Cok = 'COK',
  Col = 'COL',
  Com = 'COM',
  Cpv = 'CPV',
  Cri = 'CRI',
  Cub = 'CUB',
  Cuw = 'CUW',
  Cxr = 'CXR',
  Cym = 'CYM',
  Cyp = 'CYP',
  Cze = 'CZE',
  Deu = 'DEU',
  Dji = 'DJI',
  Dma = 'DMA',
  Dnk = 'DNK',
  Dom = 'DOM',
  Dza = 'DZA',
  Ecu = 'ECU',
  Egy = 'EGY',
  Eri = 'ERI',
  Esh = 'ESH',
  Esp = 'ESP',
  Est = 'EST',
  Eth = 'ETH',
  Fin = 'FIN',
  Fji = 'FJI',
  Flk = 'FLK',
  Fra = 'FRA',
  Fro = 'FRO',
  Fsm = 'FSM',
  Fxx = 'FXX',
  Gab = 'GAB',
  Gbr = 'GBR',
  Geo = 'GEO',
  Ggy = 'GGY',
  Gha = 'GHA',
  Gib = 'GIB',
  Gin = 'GIN',
  Glp = 'GLP',
  Gmb = 'GMB',
  Gnb = 'GNB',
  Gnq = 'GNQ',
  Grc = 'GRC',
  Grd = 'GRD',
  Grl = 'GRL',
  Gtm = 'GTM',
  Guf = 'GUF',
  Gum = 'GUM',
  Guy = 'GUY',
  Hkg = 'HKG',
  Hmd = 'HMD',
  Hnd = 'HND',
  Hrv = 'HRV',
  Hti = 'HTI',
  Hun = 'HUN',
  Idn = 'IDN',
  Imn = 'IMN',
  Ind = 'IND',
  Iot = 'IOT',
  Irl = 'IRL',
  Irn = 'IRN',
  Irq = 'IRQ',
  Isl = 'ISL',
  Isr = 'ISR',
  Ita = 'ITA',
  Jam = 'JAM',
  Jey = 'JEY',
  Jor = 'JOR',
  Jpn = 'JPN',
  Kaz = 'KAZ',
  Ken = 'KEN',
  Kgz = 'KGZ',
  Khm = 'KHM',
  Kir = 'KIR',
  Kna = 'KNA',
  Kor = 'KOR',
  Kwt = 'KWT',
  Lao = 'LAO',
  Lbn = 'LBN',
  Lbr = 'LBR',
  Lby = 'LBY',
  Lca = 'LCA',
  Lie = 'LIE',
  Lka = 'LKA',
  Lso = 'LSO',
  Ltu = 'LTU',
  Lux = 'LUX',
  Lva = 'LVA',
  Mac = 'MAC',
  Maf = 'MAF',
  Mar = 'MAR',
  Mco = 'MCO',
  Mda = 'MDA',
  Mdg = 'MDG',
  Mdv = 'MDV',
  Mex = 'MEX',
  Mhl = 'MHL',
  Mkd = 'MKD',
  Mli = 'MLI',
  Mlt = 'MLT',
  Mmr = 'MMR',
  Mne = 'MNE',
  Mng = 'MNG',
  Mnp = 'MNP',
  Moz = 'MOZ',
  Mrt = 'MRT',
  Msr = 'MSR',
  Mtq = 'MTQ',
  Mus = 'MUS',
  Mwi = 'MWI',
  Mys = 'MYS',
  Myt = 'MYT',
  Nam = 'NAM',
  Ncl = 'NCL',
  Ner = 'NER',
  Nfk = 'NFK',
  Nga = 'NGA',
  Nic = 'NIC',
  Niu = 'NIU',
  Nld = 'NLD',
  Nor = 'NOR',
  Npl = 'NPL',
  Nru = 'NRU',
  Nzl = 'NZL',
  Omn = 'OMN',
  Pak = 'PAK',
  Pan = 'PAN',
  Pcn = 'PCN',
  Per = 'PER',
  Phl = 'PHL',
  Plw = 'PLW',
  Png = 'PNG',
  Pol = 'POL',
  Pri = 'PRI',
  Prk = 'PRK',
  Prt = 'PRT',
  Pry = 'PRY',
  Pse = 'PSE',
  Pyf = 'PYF',
  Qat = 'QAT',
  Reu = 'REU',
  Rou = 'ROU',
  Rus = 'RUS',
  Rwa = 'RWA',
  Sau = 'SAU',
  Sdn = 'SDN',
  Sen = 'SEN',
  Sgp = 'SGP',
  Sgs = 'SGS',
  Shn = 'SHN',
  Sjm = 'SJM',
  Slb = 'SLB',
  Sle = 'SLE',
  Slv = 'SLV',
  Smr = 'SMR',
  Som = 'SOM',
  Spm = 'SPM',
  Srb = 'SRB',
  Ssd = 'SSD',
  Stp = 'STP',
  Sur = 'SUR',
  Svk = 'SVK',
  Svn = 'SVN',
  Swe = 'SWE',
  Swz = 'SWZ',
  Sxm = 'SXM',
  Syc = 'SYC',
  Syr = 'SYR',
  Tca = 'TCA',
  Tcd = 'TCD',
  Tgo = 'TGO',
  Tha = 'THA',
  Tjk = 'TJK',
  Tkl = 'TKL',
  Tkm = 'TKM',
  Tls = 'TLS',
  Ton = 'TON',
  Tto = 'TTO',
  Tun = 'TUN',
  Tur = 'TUR',
  Tuv = 'TUV',
  Twn = 'TWN',
  Tza = 'TZA',
  Uga = 'UGA',
  Ukr = 'UKR',
  Umi = 'UMI',
  Ury = 'URY',
  Usa = 'USA',
  Uzb = 'UZB',
  Vat = 'VAT',
  Vct = 'VCT',
  Ven = 'VEN',
  Vgb = 'VGB',
  Vir = 'VIR',
  Vnm = 'VNM',
  Vut = 'VUT',
  Wlf = 'WLF',
  Wsm = 'WSM',
  Xks = 'XKS',
  Yem = 'YEM',
  Zaf = 'ZAF',
  Zmb = 'ZMB',
  Zwe = 'ZWE'
}

export type CreateDebitRequest = {
  amount: AmountInput;
  instructionDay: Scalars['DebitInstructionDay'];
};

export type CreateErecoSubscriptionResponse = {
  __typename: 'CreateErecoSubscriptionResponse';
  docapostSignUrl: Scalars['String'];
  docapostSignatureId: Scalars['String'];
  docapostTransactionId: Scalars['String'];
};

export type CreateMissionWithSaleAgreementDalenysParameters = {
  __typename: 'CreateMissionWithSaleAgreementDalenysParameters';
  AMOUNT: Scalars['Int'];
  CLIENTEMAIL: Scalars['String'];
  CLIENTIDENT: Scalars['String'];
  DESCRIPTION: Scalars['String'];
  EXTRADATA: Scalars['String'];
  HIDECLIENTEMAIL: Scalars['String'];
  IDENTIFIER: Scalars['String'];
  OPERATIONTYPE: Scalars['String'];
  ORDERID: Scalars['String'];
  VERSION: Scalars['String'];
};

export type CreateMissionWithSaleAgreementRequest = {
  /** Client requested early execution of the DPV, waiving the withdrawal right once the service is fully performed */
  earlyExecutionRequested?: InputMaybe<Scalars['Boolean']>;
  /** Timestamp in ms */
  expectedSaleAt?: InputMaybe<Scalars['Float']>;
  recipientEmailAddress?: InputMaybe<Scalars['String']>;
  unitsIds?: InputMaybe<Array<Scalars['String']>>;
};

export type CreateMissionWithSaleAgreementResponse = {
  __typename: 'CreateMissionWithSaleAgreementResponse';
  dalenysHASH: Scalars['String'];
  dalenysParameters: CreateMissionWithSaleAgreementDalenysParameters;
};

export type CreatePaymentValidationRequest = {
  dataSecure: Scalars['String'];
};

export type CreatePaymentValidationResponse = {
  __typename: 'CreatePaymentValidationResponse';
  finalDocUrl: Scalars['String'];
};

export type CreateSepaMandateAsyncRequest = {
  amount?: InputMaybe<AmountInput>;
  bic: Scalars['String'];
  firstName: Scalars['String'];
  iban: Scalars['String'];
  instructionDay?: InputMaybe<Scalars['DebitInstructionDay']>;
  lastName: Scalars['String'];
  monthlyWithdrawal?: InputMaybe<Scalars['Boolean']>;
  paymentType: Scalars['String'];
  rememberBankInformations?: InputMaybe<Scalars['Boolean']>;
  signatureType: SignatureTypeEnum;
  telephone?: InputMaybe<Scalars['String']>;
};

export type CreateSepaMandateAsyncResponse = {
  __typename: 'CreateSepaMandateAsyncResponse';
  workflowId: Scalars['String'];
};

export type CreateSepaMandateRequest = {
  amount?: InputMaybe<AmountInput>;
  bic: Scalars['String'];
  firstName: Scalars['String'];
  iban: Scalars['String'];
  instructionDay?: InputMaybe<Scalars['DebitInstructionDay']>;
  lastName: Scalars['String'];
  monthlyWithdrawal?: InputMaybe<Scalars['Boolean']>;
  paymentType: Scalars['String'];
  rememberBankInformations?: InputMaybe<Scalars['Boolean']>;
  signatureType: SignatureTypeEnum;
  telephone?: InputMaybe<Scalars['String']>;
};

export type CreateSepaMandateResponse = {
  __typename: 'CreateSepaMandateResponse';
  docapostSignUrl: Scalars['String'];
  dpSignatureId: Scalars['String'];
  dpTransactionId: Scalars['String'];
  validationJwt: Scalars['String'];
};

export type CreateTicketInput = {
  category: TicketCategoryEnum;
  /**
   * Client-generated key: replaying the mutation with the same key returns the
   * already-created ticket instead of creating a duplicate
   */
  idempotencyKey?: InputMaybe<Scalars['String']>;
  message: MessageTicketInput;
  metadata: MetadataTicketInput;
};

export type Credit = {
  __typename: 'Credit';
  currency: CurrencyEnum;
  value: Scalars['Long'];
};

export type CreditBankingInformation = {
  __typename: 'CreditBankingInformation';
  creditPaymentType: CreditPaymentTypeEnum;
  detail?: Maybe<BankingInformation>;
};

export type CreditDebit = Credit | Debit;

export enum CreditPaymentTypeEnum {
  SelfPrintedCheck = 'SELF_PRINTED_CHECK',
  Transfer = 'TRANSFER',
  Without = 'WITHOUT'
}

export enum CurrencyEnum {
  All = 'ALL',
  Bgn = 'BGN',
  Byn = 'BYN',
  Cad = 'CAD',
  Chf = 'CHF',
  Cny = 'CNY',
  Czk = 'CZK',
  Eur = 'EUR',
  Isk = 'ISK',
  Jpy = 'JPY',
  Mdl = 'MDL',
  Nok = 'NOK',
  Pln = 'PLN',
  Ron = 'RON',
  Rsd = 'RSD',
  Sek = 'SEK',
  Usd = 'USD'
}

export type Customer = Node & {
  __typename: 'Customer';
  address: Address;
  birthDate?: Maybe<Scalars['Datetime']>;
  civility?: Maybe<CivilityEnum>;
  company?: Maybe<CustomerCompany>;
  confidentiality: CustomerConfidentiality;
  email?: Maybe<Scalars['String']>;
  familyStatus?: Maybe<FamilyStatusEnum>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  isValidAddress?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  noSnailMail?: Maybe<Scalars['Boolean']>;
  number: Scalars['String'];
  phones: CustomerPhones;
  pushNotification: CustomerPushNotification;
};

export type CustomerCompany = {
  __typename: 'CustomerCompany';
  address: Address;
  legalForm?: Maybe<LegalFormEnum>;
  name: Scalars['String'];
  siret?: Maybe<Scalars['String']>;
};

export type CustomerConfidentiality = {
  __typename: 'CustomerConfidentiality';
  customerUpdatedAt?: Maybe<Scalars['Datetime']>;
  isFirstSubmit: Scalars['Boolean'];
  offersInformation: Scalars['Boolean'];
  partnersOffersInformation: Scalars['Boolean'];
  personalData: Scalars['Boolean'];
};

export type CustomerPhones = {
  __typename: 'CustomerPhones';
  landline?: Maybe<Scalars['String']>;
  mobile?: Maybe<Scalars['String']>;
  pro?: Maybe<Scalars['String']>;
};

export enum CustomerPortalFileCategoryEnum {
  RcpSettlement = 'RCPSettlement',
  Sale = 'SALE',
  AccountSituation = 'accountSituation',
  AdministrativeDecisions = 'administrativeDecisions',
  BankReconciliation = 'bankReconciliation',
  BoilerCertificate = 'boiler_certificate',
  CoOwnershipIdentificationNumber = 'coOwnershipIdentificationNumber',
  CoOwnershipTransfer = 'coOwnershipTransfer',
  Contract = 'contract',
  Correspondence = 'correspondence',
  CouncilMeetingReport = 'councilMeetingReport',
  Deposit = 'deposit',
  DiagnosesGl = 'diagnosesGl',
  DiagnosesTech = 'diagnosesTech',
  DueNotice = 'dueNotice',
  ElectroRegistredMailSubscription = 'electro_registred_mail_subscription',
  ExpensesRepartition = 'expensesRepartition',
  GeneralAssembly = 'generalAssembly',
  HouseholdWasteTax = 'household_waste_tax',
  Insurance = 'insurance',
  Invoices = 'invoices',
  LandIncomes = 'landIncomes',
  LandlordPropertyTaxes = 'landlordPropertyTaxes',
  Leases = 'leases',
  LessorCoOwnershipDocuments = 'lessorCoOwnershipDocuments',
  Litigation = 'litigation',
  MaintenanceBook = 'maintenanceBook',
  Mandate = 'mandate',
  MandateDebit = 'mandateDebit',
  MissionPropertyRepair = 'missionPropertyRepair',
  OperatingLeaseReport = 'operatingLeaseReport',
  PeriodGeneralAssembly = 'period_generalAssembly',
  PropertyExpenseStatement = 'propertyExpenseStatement',
  PropertyRepairAccountingDistribution = 'propertyRepairAccountingDistribution',
  PropertyRepairAccountingInvoices = 'propertyRepairAccountingInvoices',
  ProvisionCalls = 'provisionCalls',
  RegularizationRentalManagement = 'regularization_Rental_Management',
  RentReview = 'rentReview',
  Repair = 'repair',
  ReportVisit = 'reportVisit',
  ResidentialRentalInspection = 'residentialRentalInspection',
  ServiceOrder = 'serviceOrder',
  SignedManagementMandate = 'signedManagementMandate',
  Sinister = 'sinister',
  StatementGeneralExpenses = 'statementGeneralExpenses',
  TenantSettlementAdditional = 'tenantSettlementAdditional',
  TenantStatementOfAccount = 'tenantStatementOfAccount',
  TrusteeContract = 'trusteeContract'
}

export type CustomerPushNotification = {
  __typename: 'CustomerPushNotification';
  permissions: Array<CustomerPushNotificationPermission>;
  tokens: Array<Scalars['String']>;
};

export type CustomerPushNotificationPermission = {
  __typename: 'CustomerPushNotificationPermission';
  enable: Scalars['Boolean'];
  kind: PushNotificationPermissionEnum;
};

export type Debit = {
  __typename: 'Debit';
  currency: CurrencyEnum;
  value: Scalars['Long'];
};

export type DebitBankingInformation = {
  __typename: 'DebitBankingInformation';
  automatic?: Maybe<BankingInformation>;
  debitPaymentType: DebitPaymentTypeEnum;
  hasDirectDebitPayments: Scalars['Boolean'];
  kyribaCompliant: Scalars['Boolean'];
  onDemand?: Maybe<BankingInformation>;
};

export type DebitCreditBankingInformation = CreditBankingInformation | DebitBankingInformation;

export enum DebitInstructionDayEnum {
  Day0 = 'DAY_0',
  Day1 = 'DAY_1',
  Day2 = 'DAY_2',
  Day3 = 'DAY_3',
  Day4 = 'DAY_4'
}

export enum DebitPaymentTypeEnum {
  Cash = 'CASH',
  Check = 'CHECK',
  DueDateTransfer = 'DUE_DATE_TRANSFER',
  NoRule = 'NO_RULE',
  SepaAutomaticDebit = 'SEPA_AUTOMATIC_DEBIT',
  SepaAutomaticDebitRequest = 'SEPA_AUTOMATIC_DEBIT_REQUEST',
  Telepayment = 'TELEPAYMENT',
  TrusteePropertyManagementPay = 'TRUSTEE_PROPERTY_MANAGEMENT_PAY'
}

export enum DocapostErrorCodesEnum {
  DeliveryModeForbidden = 'DELIVERY_MODE_FORBIDDEN',
  IncorrectOtpCode = 'INCORRECT_OTP_CODE',
  InvalidEmail = 'INVALID_EMAIL',
  InvalidEmailDomain = 'INVALID_EMAIL_DOMAIN',
  InvalidEmailSender = 'INVALID_EMAIL_SENDER',
  NoDocumentToSign = 'NO_DOCUMENT_TO_SIGN',
  OtpNotSent = 'OTP_NOT_SENT',
  OtpSendError = 'OTP_SEND_ERROR',
  PlaceholderMissing = 'PLACEHOLDER_MISSING',
  SignatoryNotInitialized = 'SIGNATORY_NOT_INITIALIZED',
  SignatoryUndefinedPhoneNumber = 'SIGNATORY_UNDEFINED_PHONE_NUMBER',
  SignatureAlreadyDone = 'SIGNATURE_ALREADY_DONE',
  SignatureIncorrectType = 'SIGNATURE_INCORRECT_TYPE',
  SignatureNotFound = 'SIGNATURE_NOT_FOUND',
  SignatureRequiresBundleGenotp = 'SIGNATURE_REQUIRES_BUNDLE_GENOTP',
  SmsCustomSenderInvalidLength = 'SMS_CUSTOM_SENDER_INVALID_LENGTH',
  SmsCustomSenderNoAlpha = 'SMS_CUSTOM_SENDER_NO_ALPHA',
  SmsCustomSenderWrongFormat = 'SMS_CUSTOM_SENDER_WRONG_FORMAT',
  TooManyOtpSent = 'TOO_MANY_OTP_SENT',
  TooManyOtpTries = 'TOO_MANY_OTP_TRIES',
  TransactionNotOpen = 'TRANSACTION_NOT_OPEN',
  ValidationError = 'VALIDATION_ERROR'
}

export type Document = {
  __typename: 'Document';
  category: FileCategoryEnum;
  createdAt?: Maybe<Scalars['Datetime']>;
  hashFile: Scalars['String'];
  id: Scalars['String'];
  mimeType?: Maybe<Scalars['String']>;
  originalFilename?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  url?: Maybe<Scalars['URL']>;
};

export type DocumentAccountingPeriod = Node & {
  __typename: 'DocumentAccountingPeriod';
  closingDate: Scalars['Datetime'];
  documentCount: Scalars['Int'];
  id: Scalars['ID'];
  name: Scalars['String'];
  openingDate: Scalars['Datetime'];
};

export type DocumentCategory = {
  __typename: 'DocumentCategory';
  documentStats: DocumentCategoryStat;
  key: CustomerPortalFileCategoryEnum;
  subCategories: Array<DocumentSubCategory>;
};

export type DocumentCategoryStat = {
  __typename: 'DocumentCategoryStat';
  count: Scalars['Int'];
  lastCreatedAt?: Maybe<Scalars['Datetime']>;
};

export type DocumentConnection = {
  __typename: 'DocumentConnection';
  edges: Array<DocumentNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type DocumentNode = {
  __typename: 'DocumentNode';
  node: Document;
};

export type DocumentSubCategory = {
  __typename: 'DocumentSubCategory';
  count: Scalars['Int'];
  key: FileCategoryEnum;
};

export type ErrorCodes = {
  __typename: 'ErrorCodes';
  docapost: Array<DocapostErrorCodesEnum>;
  iban: Array<IbanErrorCodesEnum>;
  plato: Array<PlatoErrorCodesEnum>;
};

export type ExpectedLandlordPropertyTax = {
  __typename: 'ExpectedLandlordPropertyTax';
  agencyId: Scalars['ID'];
  buildings: Array<ExpectedLandlordPropertyTaxBuilding>;
  fiscalYear: Scalars['Int'];
  id: Scalars['ID'];
  lessorAccountId: Scalars['ID'];
  status: Scalars['String'];
};

export type ExpectedLandlordPropertyTaxBuilding = {
  __typename: 'ExpectedLandlordPropertyTaxBuilding';
  building: Building;
  lessorPropertyTaxBuildingId?: Maybe<Scalars['ID']>;
  lessorPropertyTaxId?: Maybe<Scalars['ID']>;
};

export type ExpectedLandlordPropertyTaxes = {
  __typename: 'ExpectedLandlordPropertyTaxes';
  item: ExpectedLandlordPropertyTax;
};

export type ExpectedLandlordPropertyTaxesConnection = {
  __typename: 'ExpectedLandlordPropertyTaxesConnection';
  edges: Array<ExpectedLandlordPropertyTaxesNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type ExpectedLandlordPropertyTaxesFiscalYear = {
  __typename: 'ExpectedLandlordPropertyTaxesFiscalYear';
  fiscalYear: Scalars['Int'];
  status: ExpectedLessorPropertyTaxFiscalYearStatusEnum;
};

export type ExpectedLandlordPropertyTaxesFiscalYears = {
  __typename: 'ExpectedLandlordPropertyTaxesFiscalYears';
  fiscalYears: Array<ExpectedLandlordPropertyTaxesFiscalYear>;
};

export type ExpectedLandlordPropertyTaxesNode = {
  __typename: 'ExpectedLandlordPropertyTaxesNode';
  node: ExpectedLandlordPropertyTaxes;
};

export type ExpectedLessorPropertyTaxComputeProgress = {
  __typename: 'ExpectedLessorPropertyTaxComputeProgress';
  computeProgress: ExpectedLessorPropertyTaxComputeProgressEnum;
};

export enum ExpectedLessorPropertyTaxComputeProgressEnum {
  Done = 'DONE',
  Error = 'ERROR',
  Invalid = 'INVALID',
  Pending = 'PENDING'
}

export enum ExpectedLessorPropertyTaxFiscalYearStatusEnum {
  Completed = 'COMPLETED',
  Computed = 'COMPUTED',
  Invalid = 'INVALID',
  Undefined = 'UNDEFINED'
}

export type Expense = {
  __typename: 'Expense';
  date: Scalars['Datetime'];
  id: Scalars['String'];
  invoiceId?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  piece?: Maybe<Document>;
  recoverable: Amount;
  toAllocate: Amount;
  vat: Amount;
};

export type ExpenseType = {
  __typename: 'ExpenseType';
  allocationId: Scalars['String'];
  code: Scalars['String'];
  expenses: Array<Expense>;
  id: Scalars['String'];
  name: Scalars['String'];
  recoverable: Amount;
  toAllocate: Amount;
  vat: Amount;
};

export enum FamilyStatusEnum {
  CivilUnion = 'CIVIL_UNION',
  Divorce = 'DIVORCE',
  DomesticPartners = 'DOMESTIC_PARTNERS',
  Married = 'MARRIED',
  Other = 'OTHER',
  Separate = 'SEPARATE',
  Single = 'SINGLE',
  Townhall = 'TOWNHALL',
  Widower = 'WIDOWER'
}

export enum FeatureFlagNamesEnum {
  CustomerPortalConsentPlatform = 'CustomerPortalConsentPlatform',
  CustomerPortalDdppLegalBanner = 'CustomerPortalDdppLegalBanner',
  CustomerPortalDesignV2 = 'CustomerPortalDesignV2',
  CustomerPortalDisplayMissionIncidents = 'CustomerPortalDisplayMissionIncidents',
  CustomerPortalDocumentsNotifications = 'CustomerPortalDocumentsNotifications',
  CustomerPortalDpvWithdrawal = 'CustomerPortalDpvWithdrawal',
  CustomerPortalDynamicDpv = 'CustomerPortalDynamicDPV',
  CustomerPortalElectronicInvoicingDpv = 'CustomerPortalElectronicInvoicingDPV',
  CustomerPortalElectronicInvoicingFieldsConfiguration = 'CustomerPortalElectronicInvoicingFieldsConfiguration',
  CustomerPortalGetMeOnNewGateway = 'CustomerPortalGetMeOnNewGateway',
  CustomerPortalLandlordFundsCallsPayment = 'CustomerPortalLandlordFundsCallsPayment',
  CustomerPortalOutgoingTicket = 'CustomerPortalOutgoingTicket',
  CustomerPortalPlatoDocumentsMigrationSepaMandate = 'CustomerPortalPlatoDocumentsMigrationSepaMandate',
  CustomerPortalUpdateLandlordIbanData = 'CustomerPortalUpdateLandlordIbanData',
  CustomerPortalUpdateTenantHeaterCertificate = 'CustomerPortalUpdateTenantHeaterCertificate',
  CustomerPortalUploadExternalExpenseRegularization = 'CustomerPortalUploadExternalExpenseRegularization',
  CustomerPortalUseServiceNotificationPushInfo = 'CustomerPortalUseServiceNotificationPushInfo',
  MyFonciaLandlordKpi = 'MyFonciaLandlordKPI',
  MyFonciaLandlordPropertyTax = 'MyFonciaLandlordPropertyTax',
  MyFonciaRentalSituation = 'MyFonciaRentalSituation',
  MyFonciaTenantList = 'MyFonciaTenantList',
  NatixisPayment = 'NatixisPayment',
  OktaAuthenticationFlow = 'OktaAuthenticationFlow'
}

export type FeatureFlags = {
  __typename: 'FeatureFlags';
  accounts?: Maybe<Array<AccountFeatureFlags>>;
  /**
   * Union of the feature flags of every account of the customer
   * @deprecated Use globalFeatures and accounts
   */
  activatedFeatures: Array<FeatureFlagNamesEnum>;
  /** Feature flags active whatever the account displayed: add the displayed account's specificFeatures to them */
  globalFeatures?: Maybe<Array<FeatureFlagNamesEnum>>;
};

export enum FileCategoryEnum {
  AccontingControl = 'ACCONTING_CONTROL',
  AccountingInvoices = 'ACCOUNTING_INVOICES',
  AccountingLinesExtraction = 'ACCOUNTING_LINES_EXTRACTION',
  AgCover = 'AG_COVER',
  Annexe1 = 'ANNEXE1',
  Annexe1Bis = 'ANNEXE1_BIS',
  Annexe2 = 'ANNEXE2',
  Annexe3 = 'ANNEXE3',
  Annexe4 = 'ANNEXE4',
  Annexe5 = 'ANNEXE5',
  AnnexeFt = 'ANNEXE_FT',
  AppendixArchive = 'APPENDIX_ARCHIVE',
  BankOperationMediaPayment = 'BankOperationMediaPayment',
  CashAdvancePermed = 'CASH_ADVANCE_PERMED',
  CostInvoice = 'COST_INVOICE',
  EdenredVirtualIban = 'EdenredVirtualIban',
  InvoiceMediaPayment = 'InvoiceMediaPayment',
  InvoiceStamp = 'InvoiceStamp',
  KyribaFile = 'KyribaFile',
  MissionCreationWelcomeDocumentCoOwner = 'MissionCreationWelcomeDocumentCoOwner',
  PayingCustomers = 'PAYING_CUSTOMERS',
  RcpSettlement = 'RCPSettlement',
  RentalManagementMandateAppendix = 'RENTAL_MANAGEMENT_MANDATE_APPENDIX',
  RepairInvoice = 'REPAIR_INVOICE',
  Rgdd = 'RGDD',
  RgddN = 'RGDD_N',
  RgddN1 = 'RGDD_N1',
  RgddRepair = 'RGDD_REPAIR',
  Sale = 'SALE',
  WelcomePack = 'WELCOME_PACK',
  AccountSituation = 'accountSituation',
  AccountStatus = 'accountStatus',
  AccountingBalance = 'accountingBalance',
  AccountingCollectiveLoan = 'accountingCollectiveLoan',
  AccountingJournalReglement = 'accountingJournalReglement',
  AccountingJournalRentIssuance = 'accountingJournalRentIssuance',
  AccountingJournaux = 'accountingJournaux',
  AccountingLedgerAccount = 'accountingLedgerAccount',
  AccountingLinesCsv = 'accountingLinesCsv',
  AccountingPeriodAppendixes = 'accountingPeriodAppendixes',
  AccountingPointeCollateralie = 'accountingPointeCollateralie',
  AdHocProxy = 'adHocProxy',
  AdministrativeDecisions = 'administrativeDecisions',
  AppendixBalanceAccountant = 'appendixBalanceAccountant',
  AppendixLedgerAccount = 'appendixLedgerAccount',
  AppendixReconciliationBank = 'appendixReconciliationBank',
  AttendanceSheet = 'attendanceSheet',
  AttendanceSheetFinal = 'attendanceSheetFinal',
  AttendanceSheetFinalSigned = 'attendanceSheetFinalSigned',
  AttendanceSheetSigned = 'attendanceSheetSigned',
  AvisImposition = 'avisImposition',
  AvisRentReceiptRent = 'avisRentReceiptRent',
  AwsTest = 'awsTest',
  BankOrder = 'bankOrder',
  BankReconciliation = 'bankReconciliation',
  BankStatement = 'bankStatement',
  BoilerCertificate = 'boiler_certificate',
  Budget = 'budget',
  CafAlFile = 'cafALFile',
  CandidateTenant = 'candidateTenant',
  CarteProfessionnelle = 'carteProfessionnelle',
  Check = 'check',
  CheckRemittanceNote = 'checkRemittanceNote',
  CheckingBankStatement = 'checkingBankStatement',
  CoOwnershipIdentificationNumber = 'coOwnershipIdentificationNumber',
  CollectiveDpe = 'collectiveDPE',
  CommercialLeaseReminderLevelThree = 'commercialLeaseReminderLevelThree',
  CommercialLeaseReminderLevelTwo = 'commercialLeaseReminderLevelTwo',
  CommercialLeaseWithFeesReminderLevelOne = 'commercialLeaseWithFeesReminderLevelOne',
  CommercialLeaseWithoutFeesReminderLevelOne = 'commercialLeaseWithoutFeesReminderLevelOne',
  CommonAreasRiskDecree = 'commonAreasRiskDecree',
  CommonEquipmentsRiskDecree = 'commonEquipmentsRiskDecree',
  CompteReconciliationBank = 'compteReconciliationBank',
  Contract = 'contract',
  ContractorConstatimmo = 'contractorConstatimmo',
  Convocation = 'convocation',
  ConvocationGl = 'convocationGl',
  CoownershipReminderLevelThree = 'coownershipReminderLevelThree',
  CoownershipReminderLevelTwo = 'coownershipReminderLevelTwo',
  CouncilMeetingReport = 'councilMeetingReport',
  CouncilReportVisit = 'councilReportVisit',
  DatedState = 'datedState',
  Decree = 'decree',
  DefaultOrder = 'defaultOrder',
  DeficiencyMinutes = 'deficiencyMinutes',
  Deposit = 'deposit',
  Diagnoses = 'diagnoses',
  DiagnosesAsbestos = 'diagnosesAsbestos',
  DiagnosesElevator = 'diagnosesElevator',
  DiagnosesEnergy = 'diagnosesEnergy',
  DiagnosesEnergyAudit = 'diagnosesEnergyAudit',
  DiagnosesEnergyPerformanceContract = 'diagnosesEnergyPerformanceContract',
  DiagnosesGl = 'diagnosesGl',
  DiagnosesGlobalTechnical = 'diagnosesGlobalTechnical',
  DiagnosesOccupationalRisks = 'diagnosesOccupationalRisks',
  DiagnosesParasiticState = 'diagnosesParasiticState',
  DiagnosesPlumb = 'diagnosesPlumb',
  DiagnosesSanitaryConnection = 'diagnosesSanitaryConnection',
  DiagnosesStructure = 'diagnosesStructure',
  DiagnosticInvoice = 'diagnosticInvoice',
  DiagnosticSigne = 'diagnosticSigne',
  DocumentExtraction = 'documentExtraction',
  DueNotice = 'dueNotice',
  DueNoticeRent = 'dueNoticeRent',
  EdenredTransfersFile = 'edenredTransfersFile',
  ElectroRegistredMailSubscription = 'electro_registred_mail_subscription',
  ElectronicInvoicingMandateAmendment = 'electronicInvoicingMandateAmendment',
  EntryUnitAssesment = 'entryUnitAssesment',
  ExpensesRepartition = 'expensesRepartition',
  FeesConsolidationTransfer = 'feesConsolidationTransfer',
  FinancialPlan = 'financialPlan',
  Finding = 'finding',
  FrontReworkDecree = 'frontReworkDecree',
  FundsCall = 'fundsCall',
  GeneralAssembly = 'generalAssembly',
  GeneralAssemblyCertificate = 'generalAssemblyCertificate',
  GeneralAssemblyNotRepresentativeCoOwnerIdentity = 'generalAssemblyNotRepresentativeCoOwnerIdentity',
  GeneralAssemblyPostalVote = 'generalAssemblyPostalVote',
  GlobalDocument = 'globalDocument',
  GuardiansContract = 'guardiansContract',
  HasRebuildPlan = 'hasRebuildPlan',
  HouseholdWasteTax = 'household_waste_tax',
  IncomingMail = 'incomingMail',
  InsuranceContract = 'insuranceContract',
  InsuranceQuote = 'insuranceQuote',
  InsuranceOwner = 'insurance_Owner',
  InsuranceTenant = 'insurance_Tenant',
  InvoiceFee = 'invoiceFee',
  Invoices = 'invoices',
  JustificatifDivers = 'justificatifDivers',
  JustificatifDomicile = 'justificatifDomicile',
  JustificatifIdentity = 'justificatifIdentity',
  JustificatifIndemnites = 'justificatifIndemnites',
  JustificatifProfessionnel = 'justificatifProfessionnel',
  JustificatifTravail = 'justificatifTravail',
  JustificatifUnitsTransfer = 'justificatifUnitsTransfer',
  LandIncomes = 'landIncomes',
  LandlordPropertyTaxes = 'landlordPropertyTaxes',
  LeaseDivers = 'leaseDivers',
  LeaseGuaranteeCommitment = 'leaseGuaranteeCommitment',
  LeaseOtherDocument = 'leaseOtherDocument',
  Leases = 'leases',
  LedgerAccount = 'ledgerAccount',
  LessorRentalSituation = 'lessorRentalSituation',
  LetterCheck = 'letterCheck',
  Litigation = 'litigation',
  LivingProhibitionDecree = 'livingProhibitionDecree',
  MailStamping = 'mailStamping',
  MaintenanceBook = 'maintenanceBook',
  Mandate = 'mandate',
  MandateDebit = 'mandateDebit',
  MeetingReport = 'meetingReport',
  Minutes = 'minutes',
  MinutesSigned = 'minutesSigned',
  MinutesSignedGl = 'minutesSignedGl',
  MissionAttachment = 'missionAttachment',
  MissionPropertyRepairAcceptanceReport = 'missionPropertyRepairAcceptanceReport',
  MissionPropertyRepairConstructionDamageInsurance = 'missionPropertyRepairConstructionDamageInsurance',
  MissionPropertyRepairContractorInsurance = 'missionPropertyRepairContractorInsurance',
  MissionPropertyRepairHealthSafetyCoordination = 'missionPropertyRepairHealthSafetyCoordination',
  MissionPropertyRepairOther = 'missionPropertyRepairOther',
  MissionPropertyRepairPack = 'missionPropertyRepairPack',
  MissionPropertyRepairProjectManagement = 'missionPropertyRepairProjectManagement',
  MissionPropertyRepairRenovationStudy = 'missionPropertyRepairRenovationStudy',
  MissionPropertyRepairReservationLifting = 'missionPropertyRepairReservationLifting',
  MissionPropertyRepairSiteReport = 'missionPropertyRepairSiteReport',
  MissionPropertyRepairWorksContract = 'missionPropertyRepairWorksContract',
  MoveOutInspection = 'moveOutInspection',
  MultiriskInsurance = 'multiriskInsurance',
  NewMandateDocuments = 'newMandateDocuments',
  OperatingLeaseReport = 'operatingLeaseReport',
  OperatingLeaseReportCoownership = 'operatingLeaseReportCoownership',
  Organigrammes = 'organigrammes',
  OsDmdvDi = 'osDmdvDi',
  OtherCoOwner = 'otherCoOwner',
  OtherLessorCoOwnerShip = 'otherLessorCoOwnerShip',
  OthersLessors = 'others_Lessors',
  OthersCoOwnership = 'others_coOwnership',
  OthersGuardians = 'others_guardians',
  OutgoingMail = 'outgoingMail',
  OutgoingMailAck = 'outgoingMailACK',
  OutgoingMailScannedAck = 'outgoingMailScannedAck',
  PackFraicheur = 'packFraicheur',
  PagardimRomAccountingLines = 'pagardimRomAccountingLines',
  PagardimSalAccountingLines = 'pagardimSalAccountingLines',
  PagardimSalaries = 'pagardimSalaries',
  Passerelle = 'passerelle',
  PayChecks = 'payChecks',
  PicturePreVisit = 'picturePreVisit',
  PicturePublication = 'picturePublication',
  Plans = 'plans',
  PropertyExpenseStatement = 'propertyExpenseStatement',
  PropertyRepairAccountingDistribution = 'propertyRepairAccountingDistribution',
  PropertyRepairAccountingInvoices = 'propertyRepairAccountingInvoices',
  ProvisionalAdministration = 'provisionalAdministration',
  Quote = 'quote',
  RcpModificatifs = 'rcpModificatifs',
  RcpRcdCertificate = 'rcpRcdCertificate',
  RegistreSecurite = 'registreSecurite',
  RegularizationRentalManagement = 'regularization_Rental_Management',
  RelanceCoownership = 'relanceCoownership',
  RelanceGl = 'relanceGl',
  Reminders = 'reminders',
  RenewLease = 'renew_lease',
  RentReview = 'rentReview',
  Repartition = 'repartition',
  RepartitionRepair = 'repartitionRepair',
  ReportVisit = 'reportVisit',
  Request = 'request',
  ResidentialRentalInspection = 'residentialRentalInspection',
  Resolution = 'resolution',
  ReworkDecree = 'reworkDecree',
  SaleAgreement = 'saleAgreement',
  SaleAgreementInvoice = 'saleAgreementInvoice',
  Sample = 'sample',
  SavingBankStatement = 'savingBankStatement',
  ServiceOrder = 'serviceOrder',
  ShowCasePoster = 'showCasePoster',
  SignedDepositEngagement = 'signedDepositEngagement',
  SignedManagementMandate = 'signedManagementMandate',
  Sinister = 'sinister',
  SmokeDetector = 'smokeDetector',
  StatementAmountDues = 'statementAmountDues',
  StatementGeneralExpenses = 'statementGeneralExpenses',
  StepCreationStatement = 'stepCreationStatement',
  SubrogationNoticeDraft = 'subrogationNoticeDraft',
  SubrogationNoticeSigned = 'subrogationNoticeSigned',
  SummarySheet = 'summarySheet',
  SupportingCollectiveLoan = 'supportingCollectiveLoan',
  TenantLeaveReminderTenantLevelTwo = 'tenantLeaveReminderTenantLevelTwo',
  TenantLeaves = 'tenantLeaves',
  TenantSettlementAdditional = 'tenantSettlementAdditional',
  TenantStatementOfAccount = 'tenantStatementOfAccount',
  Transfert = 'transfert',
  TransfertNotification = 'transfertNotification',
  TrusteeContract = 'trusteeContract',
  UnsanitaryDecree = 'unsanitaryDecree',
  WorkOrder = 'workOrder',
  WorkSiteQuote = 'workSiteQuote',
  Workday = 'workday'
}

export type FileDraft = {
  __typename: 'FileDraft';
  id: Scalars['ID'];
  uploadUrl: Scalars['String'];
};

export type FileDraftConnection = {
  __typename: 'FileDraftConnection';
  edges: Array<FileDraftNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type FileDraftInput = {
  category: FileCategoryEnum;
  filename: Scalars['String'];
  metadata?: InputMaybe<MetadataInput>;
};

export type FileDraftNode = {
  __typename: 'FileDraftNode';
  node: FileDraft;
};

export type FileDraftResponse = {
  __typename: 'FileDraftResponse';
  id: Scalars['String'];
  uploadUrl: Scalars['String'];
};

export type GeneralAssemblyOfficialMeeting = {
  __typename: 'GeneralAssemblyOfficialMeeting';
  date?: Maybe<Scalars['Datetime']>;
};

export type GetExpectedLandlordPropertyTaxesRequest = {
  fiscalYear?: InputMaybe<Scalars['Int']>;
};

export type GetExpectedLessorPropertyTaxComputeProgressRequest = {
  fiscalYear: Scalars['Int'];
};

export type GetSepaMandateAsyncStatusResponse = {
  __typename: 'GetSepaMandateAsyncStatusResponse';
  result?: Maybe<SepaMandateResult>;
  status: Scalars['String'];
};

export enum HolderPropertyEnum {
  FullOwnership = 'FULL_OWNERSHIP',
  JointOwner = 'JOINT_OWNER',
  JointOwnershipAccount = 'JOINT_OWNERSHIP_ACCOUNT',
  MergedJointOwner = 'MERGED_JOINT_OWNER',
  NakedOwner = 'NAKED_OWNER',
  Usufructuary = 'USUFRUCTUARY'
}

export type Housing = Building | Unit;

export enum HousingTypeEnum {
  Building = 'Building',
  Unit = 'Unit'
}

export type IbanBankingInformation = {
  __typename: 'IbanBankingInformation';
  account?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  bank?: Maybe<Scalars['String']>;
  bankCode?: Maybe<Scalars['String']>;
  bic?: Maybe<Scalars['String']>;
  branch?: Maybe<Scalars['String']>;
  branchCode?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryIso?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  fax?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  www?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export enum IbanErrorCodesEnum {
  Error201 = 'ERROR_201',
  Error202 = 'ERROR_202',
  Error203 = 'ERROR_203',
  Error205 = 'ERROR_205',
  Error206 = 'ERROR_206',
  Error207 = 'ERROR_207',
  Error301 = 'ERROR_301',
  Error302 = 'ERROR_302',
  Error303 = 'ERROR_303',
  Error304 = 'ERROR_304',
  Error305 = 'ERROR_305'
}

export type Insurance = {
  __typename: 'Insurance';
  /** Date de fin de l'assurance habitation */
  endDate?: Maybe<Scalars['Datetime']>;
  /** Indique si le tenant a un bandeau pour la mise à jour de son assurance habitation */
  hasTenantInsuranceHeadband: Scalars['Boolean'];
};

export type LandlordAccount = Account & {
  __typename: 'LandlordAccount';
  accounting: Accounting;
  bankingInformation: CreditBankingInformation;
  branch?: Maybe<Branch>;
  buildings: Array<Building>;
  count: AccountStat;
  customer: Customer;
  documentCategories: Array<DocumentCategory>;
  documents: DocumentConnection;
  hasRestrictedAccess: Scalars['Boolean'];
  landlordAccounting: LandlordAccounting;
  mainUnits: Array<Unit>;
  manager?: Maybe<Manager>;
  missionTargets: Array<Housing>;
  number: Scalars['String'];
  quality: AccountQualityEnum;
  showEdenredHeadband: Scalars['Boolean'];
  uuid: Scalars['EncodedID'];
};


export type LandlordAccountDocumentCategoriesArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  customerPortalCategories?: InputMaybe<Array<CustomerPortalFileCategoryEnum>>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type LandlordAccountDocumentsArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  customerPortalCategory: CustomerPortalFileCategoryEnum;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['String']>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
  originalFilename?: InputMaybe<Scalars['String']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  subCategories?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type LandlordAccounting = {
  __typename: 'LandlordAccounting';
  /** balances */
  balances: LandlordAccountingBalances;
  exportedData: Scalars['String'];
  lines: AccountingLineConnection;
  /** provision amount (only available on landlord account) */
  provisionAmount: Amount;
};


export type LandlordAccountingExportedDataArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  endingDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  startingDate?: InputMaybe<Scalars['String']>;
};


export type LandlordAccountingLinesArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  buildingIds?: InputMaybe<Array<Scalars['String']>>;
  endingDate?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  startingDate?: InputMaybe<Scalars['String']>;
};

export type LandlordAccountingBalances = {
  __typename: 'LandlordAccountingBalances';
  buildingTotals: Array<BuildingBalance>;
  buildingsTotal: Amount;
  globalSituation: Amount;
  globalTotal: Amount;
};

export type LandlordPropertyTax = {
  __typename: 'LandlordPropertyTax';
  areAllBuildingsManagedByAgency: Scalars['Boolean'];
  buildings: Array<PropertyTaxBuilding>;
  fileId: Scalars['String'];
  fiscalManagementFees: Amount;
  fiscalYear: Scalars['Int'];
  id: Scalars['ID'];
  total: Amount;
};

export type LandlordPropertyTaxConnection = {
  __typename: 'LandlordPropertyTaxConnection';
  edges: Array<LandlordPropertyTaxNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type LandlordPropertyTaxNode = {
  __typename: 'LandlordPropertyTaxNode';
  node: LandlordPropertyTax;
};

export enum LegalFormEnum {
  AgriculturalCooperative = 'AGRICULTURAL_COOPERATIVE',
  BondsEmmitterAssociation = 'BONDS_EMMITTER_ASSOCIATION',
  CommercialRepresentationOfAForeignCommloty = 'COMMERCIAL_REPRESENTATION_OF_A_FOREIGN_COMMLOTY',
  CommercialRepresentationOfAForeignPublicEstablisment = 'COMMERCIAL_REPRESENTATION_OF_A_FOREIGN_PUBLIC_ESTABLISMENT',
  CommercialRepresentationOfAForeignState = 'COMMERCIAL_REPRESENTATION_OF_A_FOREIGN_STATE',
  CompanyCooperativeDeCommercantsDetaillantsAFormeAnonyme = 'COMPANY_COOPERATIVE_DE_COMMERCANTS_DETAILLANTS_A_FORME_ANONYME',
  CompanyLegalStatusAdmi = 'COMPANY_LEGAL_STATUS_ADMI',
  CompanyLegalStatusAful = 'COMPANY_LEGAL_STATUS_AFUL',
  CompanyLegalStatusAgen = 'COMPANY_LEGAL_STATUS_AGEN',
  CompanyLegalStatusAsl = 'COMPANY_LEGAL_STATUS_ASL',
  CompanyLegalStatusAsso = 'COMPANY_LEGAL_STATUS_ASSO',
  CompanyLegalStatusCbt = 'COMPANY_LEGAL_STATUS_CBT',
  CompanyLegalStatusCie = 'COMPANY_LEGAL_STATUS_CIE',
  CompanyLegalStatusCoop = 'COMPANY_LEGAL_STATUS_COOP',
  CompanyLegalStatusCrts = 'COMPANY_LEGAL_STATUS_CRTS',
  CompanyLegalStatusDoct = 'COMPANY_LEGAL_STATUS_DOCT',
  CompanyLegalStatusEarl = 'COMPANY_LEGAL_STATUS_EARL',
  CompanyLegalStatusEi = 'COMPANY_LEGAL_STATUS_EI',
  CompanyLegalStatusEirl = 'COMPANY_LEGAL_STATUS_EIRL',
  CompanyLegalStatusEntr = 'COMPANY_LEGAL_STATUS_ENTR',
  CompanyLegalStatusEts = 'COMPANY_LEGAL_STATUS_ETS',
  CompanyLegalStatusEtud = 'COMPANY_LEGAL_STATUS_ETUD',
  CompanyLegalStatusEurl = 'COMPANY_LEGAL_STATUS_EURL',
  CompanyLegalStatusFond = 'COMPANY_LEGAL_STATUS_FOND',
  CompanyLegalStatusGie = 'COMPANY_LEGAL_STATUS_GIE',
  CompanyLegalStatusGrp = 'COMPANY_LEGAL_STATUS_GRP',
  CompanyLegalStatusHoir = 'COMPANY_LEGAL_STATUS_HOIR',
  CompanyLegalStatusInd = 'COMPANY_LEGAL_STATUS_IND',
  CompanyLegalStatusOpa = 'COMPANY_LEGAL_STATUS_OPA',
  CompanyLegalStatusSa = 'COMPANY_LEGAL_STATUS_SA',
  CompanyLegalStatusSacicap = 'COMPANY_LEGAL_STATUS_SACICAP',
  CompanyLegalStatusSaos = 'COMPANY_LEGAL_STATUS_SAOS',
  CompanyLegalStatusSap = 'COMPANY_LEGAL_STATUS_SAP',
  CompanyLegalStatusSapo = 'COMPANY_LEGAL_STATUS_SAPO',
  CompanyLegalStatusSarl = 'COMPANY_LEGAL_STATUS_SARL',
  CompanyLegalStatusSas = 'COMPANY_LEGAL_STATUS_SAS',
  CompanyLegalStatusSasp = 'COMPANY_LEGAL_STATUS_SASP',
  CompanyLegalStatusSasu = 'COMPANY_LEGAL_STATUS_SASU',
  CompanyLegalStatusSc = 'COMPANY_LEGAL_STATUS_SC',
  CompanyLegalStatusSca = 'COMPANY_LEGAL_STATUS_SCA',
  CompanyLegalStatusScas = 'COMPANY_LEGAL_STATUS_SCAS',
  CompanyLegalStatusScc = 'COMPANY_LEGAL_STATUS_SCC',
  CompanyLegalStatusSccv = 'COMPANY_LEGAL_STATUS_SCCV',
  CompanyLegalStatusScea = 'COMPANY_LEGAL_STATUS_SCEA',
  CompanyLegalStatusSci = 'COMPANY_LEGAL_STATUS_SCI',
  CompanyLegalStatusSciagr = 'COMPANY_LEGAL_STATUS_SCIAGR',
  CompanyLegalStatusScic = 'COMPANY_LEGAL_STATUS_SCIC',
  CompanyLegalStatusScm = 'COMPANY_LEGAL_STATUS_SCM',
  CompanyLegalStatusScoa = 'COMPANY_LEGAL_STATUS_SCOA',
  CompanyLegalStatusScoagr = 'COMPANY_LEGAL_STATUS_SCOAGR',
  CompanyLegalStatusScobp = 'COMPANY_LEGAL_STATUS_SCOBP',
  CompanyLegalStatusScoc = 'COMPANY_LEGAL_STATUS_SCOC',
  CompanyLegalStatusScoe = 'COMPANY_LEGAL_STATUS_SCOE',
  CompanyLegalStatusScofa = 'COMPANY_LEGAL_STATUS_SCOFA',
  CompanyLegalStatusScoicas = 'COMPANY_LEGAL_STATUS_SCOICAS',
  CompanyLegalStatusScoicfa = 'COMPANY_LEGAL_STATUS_SCOICFA',
  CompanyLegalStatusScoicrl = 'COMPANY_LEGAL_STATUS_SCOICRL',
  CompanyLegalStatusScom = 'COMPANY_LEGAL_STATUS_SCOM',
  CompanyLegalStatusScoopfa = 'COMPANY_LEGAL_STATUS_SCOOPFA',
  CompanyLegalStatusScooprl = 'COMPANY_LEGAL_STATUS_SCOOPRL',
  CompanyLegalStatusScopas = 'COMPANY_LEGAL_STATUS_SCOPAS',
  CompanyLegalStatusScopfa = 'COMPANY_LEGAL_STATUS_SCOPFA',
  CompanyLegalStatusScoprdas = 'COMPANY_LEGAL_STATUS_SCOPRDAS',
  CompanyLegalStatusScoprdfa = 'COMPANY_LEGAL_STATUS_SCOPRDFA',
  CompanyLegalStatusScoprdrl = 'COMPANY_LEGAL_STATUS_SCOPRDRL',
  CompanyLegalStatusScoprl = 'COMPANY_LEGAL_STATUS_SCOPRL',
  CompanyLegalStatusScorl = 'COMPANY_LEGAL_STATUS_SCORL',
  CompanyLegalStatusScotfa = 'COMPANY_LEGAL_STATUS_SCOTFA',
  CompanyLegalStatusScotrl = 'COMPANY_LEGAL_STATUS_SCOTRL',
  CompanyLegalStatusScp = 'COMPANY_LEGAL_STATUS_SCP',
  CompanyLegalStatusScpi = 'COMPANY_LEGAL_STATUS_SCPI',
  CompanyLegalStatusScs = 'COMPANY_LEGAL_STATUS_SCS',
  CompanyLegalStatusSdc = 'COMPANY_LEGAL_STATUS_SDC',
  CompanyLegalStatusSde = 'COMPANY_LEGAL_STATUS_SDE',
  CompanyLegalStatusSe = 'COMPANY_LEGAL_STATUS_SE',
  CompanyLegalStatusSelarl = 'COMPANY_LEGAL_STATUS_SELARL',
  CompanyLegalStatusSelas = 'COMPANY_LEGAL_STATUS_SELAS',
  CompanyLegalStatusSelca = 'COMPANY_LEGAL_STATUS_SELCA',
  CompanyLegalStatusSelrl = 'COMPANY_LEGAL_STATUS_SELRL',
  CompanyLegalStatusSem = 'COMPANY_LEGAL_STATUS_SEM',
  CompanyLegalStatusSemou = 'COMPANY_LEGAL_STATUS_SEMOU',
  CompanyLegalStatusSicaas = 'COMPANY_LEGAL_STATUS_SICAAS',
  CompanyLegalStatusSicagras = 'COMPANY_LEGAL_STATUS_SICAGRAS',
  CompanyLegalStatusSicagrfa = 'COMPANY_LEGAL_STATUS_SICAGRFA',
  CompanyLegalStatusSicagrrl = 'COMPANY_LEGAL_STATUS_SICAGRRL',
  CompanyLegalStatusSicf = 'COMPANY_LEGAL_STATUS_SICF',
  CompanyLegalStatusSisa = 'COMPANY_LEGAL_STATUS_SISA',
  CompanyLegalStatusSlp = 'COMPANY_LEGAL_STATUS_SLP',
  CompanyLegalStatusSnc = 'COMPANY_LEGAL_STATUS_SNC',
  CompanyLegalStatusSpfplca = 'COMPANY_LEGAL_STATUS_SPFPLCA',
  CompanyLegalStatusSpfplfa = 'COMPANY_LEGAL_STATUS_SPFPLFA',
  CompanyLegalStatusSpfplfs = 'COMPANY_LEGAL_STATUS_SPFPLFS',
  CompanyLegalStatusSpfplrl = 'COMPANY_LEGAL_STATUS_SPFPLRL',
  CompanyLegalStatusSpla = 'COMPANY_LEGAL_STATUS_SPLA',
  CompanyLegalStatusSppicv = 'COMPANY_LEGAL_STATUS_SPPICV',
  CompanyLegalStatusSte = 'COMPANY_LEGAL_STATUS_STE',
  CompanyLegalStatusTrib = 'COMPANY_LEGAL_STATUS_TRIB',
  CountrySideLandOwnershipCollective = 'COUNTRY_SIDE_LAND_OWNERSHIP_COLLECTIVE',
  EconomicInterestCollective = 'ECONOMIC_INTEREST_COLLECTIVE',
  EuropeanCompany = 'EUROPEAN_COMPANY',
  EuropeanEconomicInterestCollective = 'EUROPEAN_ECONOMIC_INTEREST_COLLECTIVE',
  FarmingCollectiveGroup = 'FARMING_COLLECTIVE_GROUP',
  FarmingLandOwnershipCollective = 'FARMING_LAND_OWNERSHIP_COLLECTIVE',
  ForeignCountryBusinessOffice = 'FOREIGN_COUNTRY_BUSINESS_OFFICE',
  ForeignPublicBusinessOffice = 'FOREIGN_PUBLIC_BUSINESS_OFFICE',
  ForeignTerritoryBusinessOffice = 'FOREIGN_TERRITORY_BUSINESS_OFFICE',
  ForestCollective = 'FOREST_COLLECTIVE',
  IndustrialAndCommercialPublicOffices = 'INDUSTRIAL_AND_COMMERCIAL_PUBLIC_OFFICES',
  SocialEconomyUnionCooperativeCompanyWithAnonymousForm = 'SOCIAL_ECONOMY_UNION_COOPERATIVE_COMPANY_WITH_ANONYMOUS_FORM',
  SocialEconomyUnionLimitedLiabilityCooperativeCompany = 'SOCIAL_ECONOMY_UNION_LIMITED_LIABILITY_COOPERATIVE_COMPANY',
  SocialEconomyUnionSimplifyCooperativeStockCompany = 'SOCIAL_ECONOMY_UNION_SIMPLIFY_COOPERATIVE_STOCK_COMPANY',
  UnionOfAgriculturalCooperative = 'UNION_OF_AGRICULTURAL_COOPERATIVE',
  UnionOfCooperativeCompanyWithAnonymousForm = 'UNION_OF_COOPERATIVE_COMPANY_WITH_ANONYMOUS_FORM',
  UnionOfLimitedLiabilityCooperativeCompany = 'UNION_OF_LIMITED_LIABILITY_COOPERATIVE_COMPANY'
}

export type LoginCheckFirstConnectionResponse = {
  __typename: 'LoginCheckFirstConnectionResponse';
  customerId?: Maybe<Scalars['String']>;
  isOktaLoginEnabled: Scalars['Boolean'];
  isUniqueLogin: Scalars['Boolean'];
};

export type LoginCheckResponse = {
  __typename: 'LoginCheckResponse';
  agencyEmail?: Maybe<Scalars['String']>;
  agencyPhone?: Maybe<Scalars['String']>;
  anonymizedEmail?: Maybe<Scalars['String']>;
  isOktaAuthenticationFlow?: Maybe<Scalars['Boolean']>;
  isTemporaryLogin: Scalars['Boolean'];
  redirectUrl?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

export type LoginRequest = {
  appId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  username: Scalars['String'];
};

export type LoginResponse = {
  __typename: 'LoginResponse';
  token: Scalars['String'];
};

export enum MailStatusEnum {
  Cancelled = 'cancelled',
  DeliveredPostalServices = 'deliveredPostalServices',
  DocapostGlobalProcessError = 'docapostGlobalProcessError',
  DocapostIndividualProcessError = 'docapostIndividualProcessError',
  ErecoExpired = 'erecoExpired',
  ErecoNotReceived = 'erecoNotReceived',
  ErecoNotified = 'erecoNotified',
  ErecoRead = 'erecoRead',
  Error = 'error',
  MailDeliveredToRecipient = 'mailDeliveredToRecipient',
  NotDelivered = 'notDelivered',
  PendingAtDocapost = 'pendingAtDocapost',
  ProcessedDocapost = 'processedDocapost',
  SendingToDocapost = 'sendingToDocapost',
  SentToDocapost = 'sentToDocapost',
  ToSendDocapost = 'toSendDocapost'
}

export type Manager = Node & {
  __typename: 'Manager';
  branch?: Maybe<Branch>;
  branchId: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['ID'];
  lastName: Scalars['String'];
};

export type Me = {
  __typename: 'Me';
  civility?: Maybe<CivilityEnum>;
  companyName?: Maybe<Scalars['String']>;
  customerNumber: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  fullname?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isCompany: Scalars['Boolean'];
  isTemporary: Scalars['Boolean'];
  lastName?: Maybe<Scalars['String']>;
  login: Scalars['String'];
};

export enum MediaPaymentStatusEnum {
  Archived = 'ARCHIVED',
  Awaiting = 'AWAITING',
  Cancelled = 'CANCELLED',
  Consolidated = 'CONSOLIDATED',
  ErrorProcess = 'ERROR_PROCESS',
  PendingBuildingTransfer = 'PENDING_BUILDING_TRANSFER',
  Processed = 'PROCESSED',
  Processing = 'PROCESSING',
  Quarantine = 'QUARANTINE',
  Rejected = 'REJECTED',
  Standby = 'STANDBY',
  Suspended = 'SUSPENDED',
  ToProcess = 'TO_PROCESS',
  Transfered = 'TRANSFERED'
}

export type MessageMetadata = {
  __typename: 'MessageMetadata';
  associateId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
};

export type MessageTicketInput = {
  content: Scalars['String'];
};

export type MetadataInput = {
  fiscalYear?: InputMaybe<Scalars['Int']>;
  leaseId?: InputMaybe<Scalars['ID']>;
};

export type MetadataTicketInput = {
  buildingId: Scalars['String'];
  unitId?: InputMaybe<Scalars['String']>;
};

export type Mission = {
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  housing: Housing;
  id: Scalars['ID'];
  kind: MissionKindRestrictedEnum;
  label?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  startedAt?: Maybe<Scalars['Datetime']>;
  status: MissionStatusEnum;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionConnection = {
  __typename: 'MissionConnection';
  edges: Array<MissionNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MissionDates = {
  __typename: 'MissionDates';
  end?: Maybe<Scalars['Datetime']>;
  planned?: Maybe<Scalars['Datetime']>;
  start?: Maybe<Scalars['Datetime']>;
};

export type MissionGeneralAssembly = Mission & {
  __typename: 'MissionGeneralAssembly';
  accountingPeriodId: Scalars['String'];
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  hasAccessToPostalVote: Scalars['Boolean'];
  hasPreVoting: Scalars['Boolean'];
  housing: Housing;
  id: Scalars['ID'];
  kind: MissionKindRestrictedEnum;
  label?: Maybe<Scalars['String']>;
  lastValidPostalVoteReceptionDate?: Maybe<Scalars['Datetime']>;
  meetingPlace: Address;
  number: Scalars['String'];
  officialMeeting: GeneralAssemblyOfficialMeeting;
  startedAt?: Maybe<Scalars['Datetime']>;
  status: MissionStatusEnum;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionGeneralAssemblyConnection = {
  __typename: 'MissionGeneralAssemblyConnection';
  edges: Array<MissionGeneralAssemblyNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MissionGeneralAssemblyNode = {
  __typename: 'MissionGeneralAssemblyNode';
  node: MissionGeneralAssembly;
};

export type MissionGeneralAssemblyPerYear = {
  __typename: 'MissionGeneralAssemblyPerYear';
  missionGeneralAssemblyIds: Array<Scalars['String']>;
  year: Scalars['String'];
};

export type MissionIncident = Mission & {
  __typename: 'MissionIncident';
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  housing: Housing;
  id: Scalars['ID'];
  kind: MissionKindRestrictedEnum;
  label?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  startedAt?: Maybe<Scalars['Datetime']>;
  status: MissionStatusEnum;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionIncidentConnection = {
  __typename: 'MissionIncidentConnection';
  edges: Array<MissionIncidentNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum MissionIncidentDisplayStatusEnum {
  Completed = 'COMPLETED',
  InterventionScheduled = 'INTERVENTION_SCHEDULED',
  RequestTransmitted = 'REQUEST_TRANSMITTED'
}

export type MissionIncidentNode = {
  __typename: 'MissionIncidentNode';
  node: MissionIncident;
};

export enum MissionKindEnum {
  MissionAccident = 'MissionAccident',
  MissionCurrentManagement = 'MissionCurrentManagement',
  MissionGeneralAssembly = 'MissionGeneralAssembly',
  MissionIncident = 'MissionIncident',
  MissionManagementAccident = 'MissionManagementAccident',
  MissionManagementProcedure = 'MissionManagementProcedure',
  MissionMarketing = 'MissionMarketing',
  MissionRepair = 'MissionRepair',
  MissionTenantLeave = 'MissionTenantLeave',
  MissionTrusteeCouncil = 'MissionTrusteeCouncil',
  MissionVisit = 'MissionVisit',
  MissionWithSaleAgreement = 'MissionWithSaleAgreement'
}

export enum MissionKindRestrictedEnum {
  MissionGeneralAssembly = 'MissionGeneralAssembly',
  MissionIncident = 'MissionIncident',
  MissionRepair = 'MissionRepair',
  MissionTrusteeCouncil = 'MissionTrusteeCouncil',
  MissionVisit = 'MissionVisit'
}

export type MissionMeeting = Mission & {
  __typename: 'MissionMeeting';
  agendas: Array<MissionMeetingAgenda>;
  createdAt: Scalars['Datetime'];
  date?: Maybe<MissionDates>;
  description: Scalars['String'];
  housing: Housing;
  id: Scalars['ID'];
  kind: MissionKindRestrictedEnum;
  label?: Maybe<Scalars['String']>;
  notes: Array<MissionMeetingNote>;
  number: Scalars['String'];
  reports: Array<MissionReport>;
  startedAt?: Maybe<Scalars['Datetime']>;
  status: MissionStatusEnum;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionMeetingAgenda = {
  __typename: 'MissionMeetingAgenda';
  mission: Mission;
  status: MissionStatusEnum;
};

export type MissionMeetingConnection = {
  __typename: 'MissionMeetingConnection';
  edges: Array<MissionMeetingNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MissionMeetingNode = {
  __typename: 'MissionMeetingNode';
  node: MissionMeeting;
};

export type MissionMeetingNote = Node & {
  __typename: 'MissionMeetingNote';
  associate?: Maybe<Manager>;
  createdAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['ID'];
  isPrivate: Scalars['Boolean'];
  text?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionNode = {
  __typename: 'MissionNode';
  node: Mission;
};

export type MissionRepair = Mission & {
  __typename: 'MissionRepair';
  createdAt: Scalars['Datetime'];
  description: Scalars['String'];
  housing: Housing;
  id: Scalars['ID'];
  kind: MissionKindRestrictedEnum;
  label?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  startedAt?: Maybe<Scalars['Datetime']>;
  status: MissionStatusEnum;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionRepairConnection = {
  __typename: 'MissionRepairConnection';
  edges: Array<MissionRepairNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MissionRepairNode = {
  __typename: 'MissionRepairNode';
  node: MissionRepair;
};

export type MissionReport = Node & {
  __typename: 'MissionReport';
  createdAt: Scalars['Datetime'];
  detail: Scalars['String'];
  id: Scalars['ID'];
  kind?: Maybe<Scalars['String']>;
  status: ReportStatusEnum;
  title: Scalars['String'];
  updatedAt: Scalars['Datetime'];
};

export enum MissionSaleAgreementStatusEnum {
  Close = 'CLOSE',
  Finished = 'FINISHED',
  Open = 'OPEN',
  Paid = 'PAID',
  ToValidateByAccountant = 'TO_VALIDATE_BY_ACCOUNTANT',
  ValidatedByAccountant = 'VALIDATED_BY_ACCOUNTANT',
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

export enum MissionStatusEnum {
  Close = 'CLOSE',
  Ended = 'ENDED',
  Finished = 'FINISHED',
  MinutesSent = 'MINUTES_SENT',
  Open = 'OPEN',
  Summoned = 'SUMMONED',
  WorkInProgress = 'WORK_IN_PROGRESS'
}

export type MissionVisit = Mission & {
  __typename: 'MissionVisit';
  createdAt: Scalars['Datetime'];
  date: MissionDates;
  description: Scalars['String'];
  documents: Array<Document>;
  housing: Housing;
  id: Scalars['ID'];
  kind: MissionKindRestrictedEnum;
  label?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  startedAt?: Maybe<Scalars['Datetime']>;
  status: MissionStatusEnum;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionVisitConnection = {
  __typename: 'MissionVisitConnection';
  edges: Array<MissionVisitNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type MissionVisitNode = {
  __typename: 'MissionVisitNode';
  node: MissionVisit;
};

export type MissionWithSaleAgreement = {
  __typename: 'MissionWithSaleAgreement';
  createdAt: Scalars['Datetime'];
  document?: Maybe<Document>;
  documentNotificationSendedAt?: Maybe<Scalars['Datetime']>;
  earlyExecutionRequested?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  /** Withdrawal period still open, no withdrawal registered, and the DPV was not delivered after an early execution request */
  isWithdrawable?: Maybe<Scalars['Boolean']>;
  label: Scalars['String'];
  orderId?: Maybe<Scalars['String']>;
  status: MissionSaleAgreementStatusEnum;
  units: Array<MissionWithSaleAgreementUnit>;
  /** Last day (inclusive) the client can withdraw from the DPV order */
  withdrawalDeadline?: Maybe<Scalars['Datetime']>;
  withdrawalPeriodStartedAt?: Maybe<Scalars['Datetime']>;
};

export type MissionWithSaleAgreementUnit = {
  __typename: 'MissionWithSaleAgreementUnit';
  id: Scalars['String'];
  unitLegacyNumber: Scalars['String'];
};

export type MobileConfig = {
  __typename: 'MobileConfig';
  minimumMajorVersion: Scalars['Int'];
  minimumMinorVersion: Scalars['Int'];
  minimumPatchVersion: Scalars['Int'];
};

export type MockConfig = {
  __typename: 'MockConfig';
  accountingLinesCount: Scalars['Int'];
  boilerContractEndDate?: Maybe<Scalars['String']>;
  buildingAddress: Address;
  buildingName: Scalars['String'];
  /** [MANDATE_0] */
  coOwnershipMandateId: Scalars['String'];
  coownershipMembersCount: Scalars['Int'];
  currentBalance: Scalars['Int'];
  customerAddress: Address;
  customerCivility: CivilityEnum;
  customerFirstName?: Maybe<Scalars['String']>;
  customerHasSetConsent: Scalars['Boolean'];
  /** [false] */
  customerIsCompany: Scalars['Boolean'];
  customerLandlinePhone?: Maybe<Scalars['String']>;
  customerLastName?: Maybe<Scalars['String']>;
  customerMobilePhone?: Maybe<Scalars['String']>;
  debitLinesCount: Scalars['Int'];
  documentCount: Scalars['Int'];
  erecoDocumentCount: Scalars['Int'];
  /** [false] */
  hasActiveCoOwnershipMandate: Scalars['Boolean'];
  hasAutomaticPaymentMandate: Scalars['Boolean'];
  /** [false] */
  hasERecoHistory: Scalars['Boolean'];
  /** [false] */
  hasFutureLeaseEntryDate: Scalars['Boolean'];
  hasMultipleBuildings: Scalars['Boolean'];
  hasOnDemandPaymentMandate: Scalars['Boolean'];
  /** [false] */
  hasRestrictedAccess: Scalars['Boolean'];
  /** [false] */
  hasTenantInsuranceHeadband: Scalars['Boolean'];
  insuranceEndDate?: Maybe<Scalars['String']>;
  /** [false] */
  isSubscribedToEReco: Scalars['Boolean'];
  /** [false] */
  isTemporaryLogin: Scalars['Boolean'];
  /** [false] */
  isTrusteeCouncilMember: Scalars['Boolean'];
  /** [false] */
  leaseId: Scalars['String'];
  missionIncidentsCount: Scalars['Int'];
  missionNextMeetingsCount: Scalars['Int'];
  missionNextVisitsCount: Scalars['Int'];
  missionPastMeetingsCount: Scalars['Int'];
  missionPastVisitsCount: Scalars['Int'];
  missionRepairsCount: Scalars['Int'];
  missionWorkOrderCount: Scalars['Int'];
  /** [false] */
  needHeatingCertificate: Scalars['Boolean'];
  /** [0] */
  otherAccounts: Scalars['Int'];
  projectedBalance: Scalars['Int'];
  /** [CO_OWNER] */
  quality: AccountQualityEnum;
  requestHasDocument: Scalars['Boolean'];
  requestHasReply: Scalars['Boolean'];
  requestsCount: Scalars['Int'];
  /** [false] */
  showDalenysHeadband: Scalars['Boolean'];
  /** [false] */
  showEdenredHeadband: Scalars['Boolean'];
  supplierContractCount: Scalars['Int'];
  ticketHasDocument: Scalars['Boolean'];
  ticketHasReply: Scalars['Boolean'];
  ticketsCount: Scalars['Int'];
};

export type Mutation = {
  __typename: 'Mutation';
  /** add a message to a ticket */
  addMessageTicket: Ticket;
  /** Approve ticket in order to consider it as closed */
  approveTicket: Ticket;
  /** Compute an expected lessor property tax for a lessor account and a fiscal year */
  computeExpectedLessorPropertyTax: Scalars['Boolean'];
  /** mutation to confirm the customer's banking information update */
  confirmBankingInformationUpdate: Scalars['Boolean'];
  /** mutation to confirm the customer's password update */
  confirmPasswordUpdate: Scalars['Boolean'];
  /** Create a debit */
  createDebit: AccountingDebit;
  /** Create a docapost transaction to subscribe to the e-reco service */
  createErecoSubscription: CreateErecoSubscriptionResponse;
  /** create file draft */
  createFileDraft: FileDraft;
  /** Create mission with sale agreement, start process (DPV) */
  createMissionWithSaleAgreement: CreateMissionWithSaleAgreementResponse;
  /** Validates Docapost SEPA payment */
  createPaymentValidation: CreatePaymentValidationResponse;
  /** Create postal votes draft */
  createPostalVoteDraft: Array<ResolutionVote>;
  /** Create a docapost transaction to sign a sepa mandate */
  createSepaMandate: CreateSepaMandateResponse;
  /** Create a docapost transaction to sign a sepa mandate, async version */
  createSepaMandateAsync: CreateSepaMandateAsyncResponse;
  /** Create ticket */
  createTicket: Ticket;
  /** Delete postal votes */
  deletePostalVote: Scalars['String'];
  /** Login user (on myfoncia by default) */
  login: LoginResponse;
  /** to validate association login */
  loginAssociationConfirmationFirstConnection: Scalars['String'];
  /** to send the email of login association */
  loginAssociationRequestFirstConnection: Scalars['String'];
  /** Login check */
  loginCheck: LoginCheckResponse;
  /** check login */
  loginCheckFirstConnection: LoginCheckFirstConnectionResponse;
  /** Make initial payment */
  natixisPay: NatixisPayType;
  /** Return the base64-encoded PDF file used to subscribe to the e-reco service */
  previewErecoSubscription: PreviewErecoSubscriptionResponse;
  /** Return the base64-encoded PDF file used for a sepa mandate */
  previewSepaMandate: PreviewSepaMandateResponse;
  /** Reset password */
  resetPassword: Scalars['String'];
  /** Resiliate ereco option for account/customer */
  resiliateErecoSubscription: CoownerAccount;
  resiliateSepaMandate: ResiliationSepaMandateResults;
  /** Create an OTP for a Docapost signature */
  sendSignatureOtp: SendSignatureOtpResponse;
  /** start to sign vote resolutions */
  startSignaturePostalVoteResolutions: StartSignaturePostalResolutionsResponse;
  /** end process to sign vote resolutions */
  terminateSignaturePostalVoteResolutions: TerminateSignaturePostalResolutionsResponse;
  /** Update account snail mail */
  updateCoOwnerAccountSnailMail: CoownerAccount;
  /** Update customer credentials */
  updateCredentials: Customer;
  /** Update credit banking informations */
  updateCreditBankingInformation: CreditBankingInformation;
  /** Update customer consent */
  updateCustomerConsent: Customer;
  /** Update customer push notification */
  updateCustomerPushNotification: Customer;
  /** Update customer account show dalenys headband */
  updateCustomerShowDalenysHeadband: CoownerAccount;
  /** Update customer snail mail */
  updateCustomerSnailMail: Customer;
  /** Update isRead ticket */
  updateIsReadTicket: Ticket;
  /** Update customer password */
  updatePassword: Scalars['String'];
  /** Upload Landlord Property Tax */
  uploadLandlordPropertyTax: LandlordPropertyTax;
  /** Valid mission with sale agreement, end process after payment (DPV) */
  validMissionWithSaleAgreement: ValidMissionWithSaleAgreementResponse;
  /** valid email to send */
  validateEmailFirstConnection: Scalars['String'];
  /** Validate reset password */
  validateResetPassword: Scalars['String'];
  /** Validate an OTP for a Docapost signature */
  validateSignature: ValidateSignatureResponse;
  /** Verify customer credentials */
  verifyCredentials: Scalars['String'];
};


export type MutationAddMessageTicketArgs = {
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  message: MessageTicketInput;
  ticketId: Scalars['String'];
};


export type MutationApproveTicketArgs = {
  ticketId: Scalars['String'];
};


export type MutationComputeExpectedLessorPropertyTaxArgs = {
  accountUuid: Scalars['EncodedID'];
  request: ComputeExpectedLessorPropertyTaxRequest;
};


export type MutationConfirmBankingInformationUpdateArgs = {
  request: ConfirmBankingInformationUpdateRequest;
};


export type MutationConfirmPasswordUpdateArgs = {
  request: ConfirmPasswordUpdateRequest;
};


export type MutationCreateDebitArgs = {
  accountUuid: Scalars['EncodedID'];
  request: CreateDebitRequest;
};


export type MutationCreateErecoSubscriptionArgs = {
  accountUuid: Scalars['EncodedID'];
  agencyId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateFileDraftArgs = {
  accountUuid: Scalars['EncodedID'];
  request: FileDraftInput;
};


export type MutationCreateMissionWithSaleAgreementArgs = {
  accountUuid: Scalars['EncodedID'];
  request: CreateMissionWithSaleAgreementRequest;
};


export type MutationCreatePaymentValidationArgs = {
  request: CreatePaymentValidationRequest;
};


export type MutationCreatePostalVoteDraftArgs = {
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
  votes: Array<VoteInput>;
};


export type MutationCreateSepaMandateArgs = {
  accountUuid: Scalars['EncodedID'];
  request: CreateSepaMandateRequest;
};


export type MutationCreateSepaMandateAsyncArgs = {
  accountUuid: Scalars['EncodedID'];
  request: CreateSepaMandateAsyncRequest;
};


export type MutationCreateTicketArgs = {
  accountUuid: Scalars['EncodedID'];
  documents?: InputMaybe<Array<Scalars['Upload']>>;
  request: CreateTicketInput;
};


export type MutationDeletePostalVoteArgs = {
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
};


export type MutationLoginArgs = {
  request: LoginRequest;
};


export type MutationLoginAssociationConfirmationFirstConnectionArgs = {
  brandCode?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  emailToken?: InputMaybe<Scalars['String']>;
  idpAccessToken?: InputMaybe<Scalars['String']>;
  login: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationLoginAssociationRequestFirstConnectionArgs = {
  brandCode?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  login: Scalars['String'];
};


export type MutationLoginCheckArgs = {
  login: Scalars['String'];
};


export type MutationLoginCheckFirstConnectionArgs = {
  login: Scalars['String'];
};


export type MutationNatixisPayArgs = {
  accountUuid: Scalars['EncodedID'];
  request: NatixisPayRequest;
};


export type MutationPreviewErecoSubscriptionArgs = {
  accountUuid: Scalars['EncodedID'];
};


export type MutationPreviewSepaMandateArgs = {
  accountUuid: Scalars['EncodedID'];
  request: PreviewSepaMandateRequest;
};


export type MutationResetPasswordArgs = {
  request: ResetPasswordRequest;
};


export type MutationResiliateErecoSubscriptionArgs = {
  accountUuid: Scalars['EncodedID'];
};


export type MutationResiliateSepaMandateArgs = {
  accountUuid: Scalars['EncodedID'];
  bankInformationId: Scalars['ID'];
};


export type MutationSendSignatureOtpArgs = {
  request: SendSignatureOtpRequest;
  signatureId: Scalars['String'];
};


export type MutationStartSignaturePostalVoteResolutionsArgs = {
  accountUuid: Scalars['EncodedID'];
  agencyId?: InputMaybe<Scalars['String']>;
  brandCode?: InputMaybe<Scalars['String']>;
  generalAssemblyId: Scalars['String'];
};


export type MutationTerminateSignaturePostalVoteResolutionsArgs = {
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
  transactionId: Scalars['String'];
};


export type MutationUpdateCoOwnerAccountSnailMailArgs = {
  accountUuid: Scalars['EncodedID'];
  request: UpdateCustomerSnailMailRequest;
};


export type MutationUpdateCredentialsArgs = {
  request: UpdateCredentialsRequest;
};


export type MutationUpdateCreditBankingInformationArgs = {
  accountUuid: Scalars['EncodedID'];
  request: UpdateCreditBankingInformationRequest;
};


export type MutationUpdateCustomerConsentArgs = {
  customerId: Scalars['ID'];
  request: UpdateCustomerConsentRequest;
};


export type MutationUpdateCustomerPushNotificationArgs = {
  customerId: Scalars['ID'];
  request: UpdateCustomerPushNotificationRequest;
};


export type MutationUpdateCustomerShowDalenysHeadbandArgs = {
  accountUuid: Scalars['EncodedID'];
  request: UpdateCustomerShowDalenysHeadbandRequest;
};


export type MutationUpdateCustomerSnailMailArgs = {
  customerId: Scalars['ID'];
  request: UpdateCustomerSnailMailRequest;
};


export type MutationUpdateIsReadTicketArgs = {
  isRead: Scalars['Boolean'];
  ticketId: Scalars['String'];
};


export type MutationUpdatePasswordArgs = {
  request: UpdatePasswordRequest;
};


export type MutationUploadLandlordPropertyTaxArgs = {
  accountUuid: Scalars['EncodedID'];
  request: UploadLandLordPropertyTaxInput;
};


export type MutationValidMissionWithSaleAgreementArgs = {
  paramsAsString: Scalars['String'];
};


export type MutationValidateEmailFirstConnectionArgs = {
  brandCode?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  token: Scalars['String'];
};


export type MutationValidateResetPasswordArgs = {
  request: ValidateResetPasswordRequest;
};


export type MutationValidateSignatureArgs = {
  request: ValidateSignatureRequest;
  signatureId: Scalars['String'];
};


export type MutationVerifyCredentialsArgs = {
  request: VerifyCredentialsRequest;
};

export type NatixisPayRequest = {
  amount: AmountInput;
  bankId: Scalars['String'];
  callbackUrl: Scalars['String'];
};

export type NatixisPayType = {
  __typename: 'NatixisPayType';
  url: Scalars['String'];
};

export type NatixisPaymentBank = {
  __typename: 'NatixisPaymentBank';
  id: Scalars['String'];
  label: Scalars['String'];
  logo?: Maybe<Scalars['String']>;
};

export type NatixisPaymentStatus = {
  __typename: 'NatixisPaymentStatus';
  status: Scalars['String'];
};

export type Node = {
  id: Scalars['ID'];
};

export type OkFonciaDocument = {
  __typename: 'OkFonciaDocument';
  mimeType: Scalars['String'];
  originalFilename: Scalars['String'];
  url: Scalars['String'];
};

export type PageInfo = {
  __typename: 'PageInfo';
  endCursor?: Maybe<Scalars['Cursor']>;
  hasNextPage?: Maybe<Scalars['Boolean']>;
  hasPreviousPage?: Maybe<Scalars['Boolean']>;
  itemsPerPage?: Maybe<Scalars['Int']>;
  pageNumber?: Maybe<Scalars['Int']>;
  startCursor?: Maybe<Scalars['Cursor']>;
  totalDisplayPages?: Maybe<Scalars['Int']>;
  totalPages?: Maybe<Scalars['Int']>;
};

export type PastBuildingAccountingRgdd = {
  __typename: 'PastBuildingAccountingRGDD';
  allocations: Array<Allocation>;
  totalRecoverable: Amount;
  totalToAllocate: Amount;
  totalVat: Amount;
};

export enum PlatoErrorCodesEnum {
  CoownerMandatesOutdated = 'COOWNER_MANDATES_OUTDATED',
  CoownerUnitsSold = 'COOWNER_UNITS_SOLD',
  DebitAlreadyExists = 'DEBIT_ALREADY_EXISTS',
  FirstConnectionBadPassword = 'FIRST_CONNECTION_BAD_PASSWORD',
  FirstConnectionPasswordFromTemporaryLogin = 'FIRST_CONNECTION_PASSWORD_FROM_TEMPORARY_LOGIN',
  IbanBicMismatch = 'IBAN_BIC_MISMATCH',
  LeaseOutdated = 'LEASE_OUTDATED',
  LessorManagementOutdated = 'LESSOR_MANAGEMENT_OUTDATED',
  LessorMandateOutdated = 'LESSOR_MANDATE_OUTDATED',
  LoginAlreadyChanged = 'LOGIN_ALREADY_CHANGED',
  LoginAlreadyExists = 'LOGIN_ALREADY_EXISTS',
  LoginNotFound = 'LOGIN_NOT_FOUND',
  MultiCustomerUser = 'MULTI_CUSTOMER_USER',
  SddNotSupported = 'SDD_NOT_SUPPORTED',
  TokenInvalidOrExpired = 'TOKEN_INVALID_OR_EXPIRED'
}

export type PostalVote = {
  __typename: 'PostalVote';
  voteDocument?: Maybe<Document>;
  voteReceptionDate?: Maybe<Scalars['Datetime']>;
};

export enum PostalVoteStatusEnum {
  Abstention = 'ABSTENTION',
  Contre = 'CONTRE',
  Pour = 'POUR'
}

export type PreviewErecoSubscriptionResponse = {
  __typename: 'PreviewErecoSubscriptionResponse';
  data: Scalars['String'];
};

export type PreviewSepaMandateRequest = {
  amount?: InputMaybe<AmountInput>;
  bic: Scalars['String'];
  firstName: Scalars['String'];
  iban: Scalars['String'];
  instructionDay?: InputMaybe<Scalars['DebitInstructionDay']>;
  lastName: Scalars['String'];
  monthlyWithdrawal?: InputMaybe<Scalars['Boolean']>;
  paymentType: Scalars['String'];
  signatureType: SignatureTypeEnum;
  telephone?: InputMaybe<Scalars['String']>;
};

export type PreviewSepaMandateResponse = {
  __typename: 'PreviewSepaMandateResponse';
  data: Scalars['Base64File'];
};

export type PropertyAssets = {
  __typename: 'PropertyAssets';
  expensesTotal: Amount;
  grossIncomes: Amount;
  netIncomes: Amount;
  rentsCalledTotal: Amount;
  rentsCollectedTotal: Amount;
  startDate: Scalars['Datetime'];
  unpaidRentCover: Amount;
};

export type PropertyTaxBuilding = {
  __typename: 'PropertyTaxBuilding';
  areAllUnitsManagedByAgency: Scalars['Boolean'];
  buildingId: Scalars['ID'];
  totalContributionFees: Amount;
  wasteContributionFees: Amount;
};

export enum PropertyTypeEnum {
  ActivityPremises = 'ACTIVITY_PREMISES',
  AdministrativeArea = 'ADMINISTRATIVE_AREA',
  AdvertisementBoard = 'ADVERTISEMENT_BOARD',
  Agricultural = 'AGRICULTURAL',
  AgriculturalPremise = 'AGRICULTURAL_PREMISE',
  Apartment = 'APARTMENT',
  ArtisanalPremise = 'ARTISANAL_PREMISE',
  Attic = 'ATTIC',
  Bakery = 'BAKERY',
  Balcony = 'BALCONY',
  Bar = 'BAR',
  Barn = 'BARN',
  BikeRoom = 'BIKE_ROOM',
  Box = 'BOX',
  Brewery = 'BREWERY',
  Building = 'BUILDING',
  Cellar = 'CELLAR',
  CellularAntenna = 'CELLULAR_ANTENNA',
  ClothesDryer = 'CLOTHES_DRYER',
  CoffeeDeskTransfer = 'COFFEE_DESK_TRANSFER',
  CommercialPremise = 'COMMERCIAL_PREMISE',
  Cupboard = 'CUPBOARD',
  Diverse = 'DIVERSE',
  DoctorOffice = 'DOCTOR_OFFICE',
  Duplex = 'DUPLEX',
  Empty = 'EMPTY',
  EmptyWallCommercialProperty = 'EMPTY_WALL_COMMERCIAL_PROPERTY',
  Field = 'FIELD',
  Fitted = 'FITTED',
  FittedTreeFilled = 'FITTED_TREE_FILLED',
  Forest = 'FOREST',
  FuelArea = 'FUEL_AREA',
  Garage = 'GARAGE',
  Garden = 'GARDEN',
  Garret = 'GARRET',
  GasField = 'GAS_FIELD',
  Grocery = 'GROCERY',
  Hallway = 'HALLWAY',
  Hotel = 'HOTEL',
  HotelRestaurantBrewery = 'HOTEL_RESTAURANT_BREWERY',
  House = 'HOUSE',
  Housing = 'HOUSING',
  IndoorParking = 'INDOOR_PARKING',
  IndustrialCraftLand = 'INDUSTRIAL_CRAFT_LAND',
  IndustrialPremise = 'INDUSTRIAL_PREMISE',
  IndustrialPremises = 'INDUSTRIAL_PREMISES',
  InporteParking = 'INPORTE_PARKING',
  Land = 'LAND',
  Landscape = 'LANDSCAPE',
  Leisure = 'LEISURE',
  LivingBuilding = 'LIVING_BUILDING',
  LivingLocal = 'LIVING_LOCAL',
  Local = 'LOCAL',
  LockUp = 'LOCK_UP',
  Loft = 'LOFT',
  MixedOwnership = 'MIXED_OWNERSHIP',
  Nc = 'NC',
  Offices = 'OFFICES',
  OfficesBuilding = 'OFFICES_BUILDING',
  Other = 'OTHER',
  OutdoorParking = 'OUTDOOR_PARKING',
  OutsideParking = 'OUTSIDE_PARKING',
  Pantry = 'PANTRY',
  Parking = 'PARKING',
  ParkingArea = 'PARKING_AREA',
  Pasture = 'PASTURE',
  PortCleat = 'PORT_CLEAT',
  ProfessionalPremise = 'PROFESSIONAL_PREMISE',
  ProfessionalRetailer = 'PROFESSIONAL_RETAILER',
  Rental = 'RENTAL',
  Reserved = 'RESERVED',
  Restaurant = 'RESTAURANT',
  Room = 'ROOM',
  Sale = 'SALE',
  ShoeRack = 'SHOE_RACK',
  Showcase = 'SHOWCASE',
  SkiLocker = 'SKI_LOCKER',
  Souplex = 'SOUPLEX',
  Specific = 'SPECIFIC',
  Store = 'STORE',
  Storeroom = 'STOREROOM',
  StoreRoom = 'STORE_ROOM',
  Studio = 'STUDIO',
  TeaRoom = 'TEA_ROOM',
  TechnicalPremise = 'TECHNICAL_PREMISE',
  Terrace = 'TERRACE',
  Toilet = 'TOILET',
  Toilets = 'TOILETS',
  TreeFilled = 'TREE_FILLED',
  Triplex = 'TRIPLEX',
  Undefined = 'UNDEFINED',
  UninhabitedRoom = 'UNINHABITED_ROOM',
  UrbanAbandonedLand = 'URBAN_ABANDONED_LAND',
  Villa = 'VILLA',
  Warehouse = 'WAREHOUSE',
  Warehouses = 'WAREHOUSES'
}

export enum PushNotificationPermissionEnum {
  DocumentAvailable = 'DOCUMENT_AVAILABLE',
  MissionRequest = 'MISSION_REQUEST',
  PushInfo = 'PUSH_INFO',
  TenantHeatingCertificate = 'TENANT_HEATING_CERTIFICATE',
  TenantInsurance = 'TENANT_INSURANCE'
}

export type Query = {
  __typename: 'Query';
  /** Get one account */
  account: Account;
  /** Get many accounts */
  accounts: Array<Account>;
  /** Get config */
  config: Config;
  /** Get one coownerAccount */
  coownerAccount: CoownerAccount;
  /** Get one customer */
  customer: Customer;
  /** Get document URL */
  documentURL?: Maybe<Scalars['URL']>;
  /** Get property taxes */
  expectedLandlordPropertyTaxes: ExpectedLandlordPropertyTaxes;
  /** Get fiscal years that are not computed or that are not completed */
  expectedLandlordPropertyTaxesFiscalYears: ExpectedLandlordPropertyTaxesFiscalYears;
  /** Get compute progress of an expected lessor property tax for a lessor account and a fiscal year */
  expectedLessorPropertyTaxComputeProgress: ExpectedLessorPropertyTaxComputeProgress;
  /** Get activated feature flags */
  featureFlags: FeatureFlags;
  /** Get the status of an async SEPA mandate creation */
  getSepaMandateAsyncStatus: GetSepaMandateAsyncStatusResponse;
  /** Validate an IBAN, its BIC and Sepa Direct Debit support */
  ibanValidation: IbanBankingInformation;
  /** Get invoice URL */
  invoiceURL?: Maybe<Scalars['URL']>;
  /** Get one LandlordAccount */
  landlordAccount: LandlordAccount;
  /** Get info about current user and authentication */
  me: Me;
  missionsWithSaleAgreement: Array<MissionWithSaleAgreement>;
  /** Get Natixis partner banks to initiate payment */
  natixisPaymentBanks: Array<NatixisPaymentBank>;
  /** Get Natixis payment status */
  natixisPaymentStatus: NatixisPaymentStatus;
  /** Get documents of okFoncia */
  okFonciaDocuments: Array<OkFonciaDocument>;
  /** Get postal votes */
  postalVote: PostalVote;
  /** Get postal vote draft */
  postalVoteDraft: Array<ResolutionVote>;
  /** Get property assets with a building id */
  propertyAssets: PropertyAssets;
  /** Get property tax filing guide */
  propertyTaxFilingGuide: OkFonciaDocument;
  /** Get repairBudgets */
  repairBudgets: Array<BuildingRepairBudgetType>;
  /** Get Resolutions */
  resolutions: Array<Resolution>;
  /** Get one tenantAccount */
  tenantAccount: TenantAccount;
  /** Get ticket by id */
  ticket: Ticket;
  tickets: TicketConnection;
  /** Get worksOrders */
  workOrders: WorkOrderConnection;
  /** Get a zipfile through a workflow */
  zipFileWorkflow: ZipFileWorkflow;
};


export type QueryAccountArgs = {
  uuid: Scalars['EncodedID'];
};


export type QueryAccountsArgs = {
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
};


export type QueryCoownerAccountArgs = {
  uuid: Scalars['EncodedID'];
};


export type QueryCustomerArgs = {
  id: Scalars['ID'];
};


export type QueryDocumentUrlArgs = {
  hash: Scalars['String'];
};


export type QueryExpectedLandlordPropertyTaxesArgs = {
  accountUuid: Scalars['EncodedID'];
  request?: InputMaybe<GetExpectedLandlordPropertyTaxesRequest>;
};


export type QueryExpectedLandlordPropertyTaxesFiscalYearsArgs = {
  accountUuid: Scalars['EncodedID'];
};


export type QueryExpectedLessorPropertyTaxComputeProgressArgs = {
  accountUuid: Scalars['EncodedID'];
  request: GetExpectedLessorPropertyTaxComputeProgressRequest;
};


export type QueryGetSepaMandateAsyncStatusArgs = {
  accountUuid: Scalars['EncodedID'];
  includeFile?: InputMaybe<Scalars['Boolean']>;
  workflowId: Scalars['String'];
};


export type QueryIbanValidationArgs = {
  allowForeignIban?: InputMaybe<Scalars['Boolean']>;
  bic?: InputMaybe<Scalars['String']>;
  iban: Scalars['String'];
};


export type QueryInvoiceUrlArgs = {
  invoiceId: Scalars['String'];
};


export type QueryLandlordAccountArgs = {
  uuid: Scalars['EncodedID'];
};


export type QueryMissionsWithSaleAgreementArgs = {
  accountUuid: Scalars['EncodedID'];
};


export type QueryNatixisPaymentStatusArgs = {
  accountUuid: Scalars['EncodedID'];
  paymentId: Scalars['String'];
};


export type QueryOkFonciaDocumentsArgs = {
  accountUuid: Scalars['EncodedID'];
};


export type QueryPostalVoteArgs = {
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
};


export type QueryPostalVoteDraftArgs = {
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
};


export type QueryPropertyAssetsArgs = {
  accountUuid: Scalars['EncodedID'];
  assetsYear: Scalars['Int'];
  buildingIds: Array<Scalars['String']>;
};


export type QueryRepairBudgetsArgs = {
  accountUuid: Scalars['EncodedID'];
};


export type QueryResolutionsArgs = {
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
};


export type QueryTenantAccountArgs = {
  uuid: Scalars['EncodedID'];
};


export type QueryTicketArgs = {
  ticketId: Scalars['String'];
};


export type QueryTicketsArgs = {
  accountUuid: Scalars['EncodedID'];
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  canBeReopened?: InputMaybe<Scalars['Boolean']>;
  category?: InputMaybe<Array<TicketCategoryEnum>>;
  createdDateFrom?: InputMaybe<Scalars['String']>;
  createdDateTo?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  source?: InputMaybe<Array<TicketSourceEnum>>;
  status?: InputMaybe<Array<TicketStatusEnum>>;
  ticketNumber?: InputMaybe<Scalars['String']>;
};


export type QueryWorkOrdersArgs = {
  accountUuid: Scalars['EncodedID'];
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  missionId: Scalars['ID'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  status?: InputMaybe<Array<WorkOrderStatusEnum>>;
};


export type QueryZipFileWorkflowArgs = {
  filename: Scalars['String'];
  ids: Array<Scalars['String']>;
  workflow?: InputMaybe<Scalars['String']>;
};

export type RgddAllocation = Node & {
  __typename: 'RGDDAllocation';
  categories: Array<RgddAllocationCategory>;
  code?: Maybe<Scalars['String']>;
  deductible?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  name: Scalars['String'];
  recoverable?: Maybe<Scalars['Int']>;
  toAllocate?: Maybe<Scalars['Int']>;
  vat?: Maybe<Scalars['Int']>;
};

export type RgddAllocationCategory = Node & {
  __typename: 'RGDDAllocationCategory';
  code: Scalars['String'];
  deductible: Scalars['Int'];
  details: Array<RgddAllocationDetail>;
  id: Scalars['ID'];
  name: Scalars['String'];
  recoverable: Scalars['Int'];
  toAllocate: Scalars['Int'];
  vat: Scalars['Int'];
};

export type RgddAllocationDetail = Node & {
  __typename: 'RGDDAllocationDetail';
  date: Scalars['Datetime'];
  deductible: Scalars['Int'];
  id: Scalars['ID'];
  invoiceHash?: Maybe<Scalars['String']>;
  label: Scalars['String'];
  recoverable: Scalars['Int'];
  toAllocate: Scalars['Int'];
  vat: Scalars['Int'];
};

export type RgddStatistic = Node & {
  __typename: 'RGDDStatistic';
  categories: Array<RgddStatisticCategory>;
  code?: Maybe<Scalars['String']>;
  currentClosingDate?: Maybe<Scalars['Datetime']>;
  currentOpeningDate?: Maybe<Scalars['Datetime']>;
  currentTotal?: Maybe<Amount>;
  id: Scalars['ID'];
  name: Scalars['String'];
  previousTotal?: Maybe<Amount>;
};

export type RgddStatisticCategory = Node & {
  __typename: 'RGDDStatisticCategory';
  code: Scalars['String'];
  currentTotal?: Maybe<Amount>;
  details: Array<RgddStatisticDetail>;
  id: Scalars['ID'];
  name: Scalars['String'];
  previousTotal?: Maybe<Amount>;
};

export type RgddStatisticDetail = {
  __typename: 'RGDDStatisticDetail';
  amount: CreditDebit;
  date: Scalars['Datetime'];
  invoiceHash?: Maybe<Scalars['String']>;
  label: Scalars['String'];
};

export enum ReportStatusEnum {
  Close = 'CLOSE',
  Open = 'OPEN',
  WorkInProgress = 'WORK_IN_PROGRESS'
}

export type ResetPasswordRequest = {
  brandCode: BrandCodeEnum;
  login: Scalars['String'];
};

export type ResiliateSepaMandateDebit = {
  __typename: 'ResiliateSepaMandateDebit';
  amount: Amount;
  id: Scalars['String'];
  instructionDate: Scalars['Datetime'];
  label: Scalars['String'];
};

export type ResiliationSepaMandateResults = {
  __typename: 'ResiliationSepaMandateResults';
  debitsCancelled: Array<ResiliateSepaMandateDebit>;
  debitsNotCancelled: Array<ResiliateSepaMandateDebit>;
};

export type Resolution = {
  __typename: 'Resolution';
  candidate?: Maybe<Scalars['String']>;
  hasVoteResolution: Scalars['Boolean'];
  id: Scalars['String'];
  isCouncilMemberVote: Scalars['Boolean'];
  isEligibleSecondVote: Scalars['Boolean'];
  label: Scalars['String'];
  proxyNumber: Scalars['Int'];
  proxySubNumber: Scalars['Int'];
  text: Scalars['String'];
  typeNumber: Scalars['Int'];
  votable: Scalars['Boolean'];
  voteKind: Scalars['String'];
};

export type ResolutionVote = {
  __typename: 'ResolutionVote';
  candidate?: Maybe<Scalars['String']>;
  isSecondVote: Scalars['Boolean'];
  resolutionId: Scalars['String'];
  status: PostalVoteStatusEnum;
};

export type RestrictedCoowner = Node & {
  __typename: 'RestrictedCoowner';
  balance: Amount;
  id: Scalars['ID'];
  mainHolder: RestrictedCoownerHolder;
  units: Array<RestrictedUnit>;
};

export type RestrictedCoownerConnection = {
  __typename: 'RestrictedCoownerConnection';
  edges: Array<RestrictedCoownerNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type RestrictedCoownerHolder = {
  __typename: 'RestrictedCoownerHolder';
  customer: RestrictedCustomer;
  propertyType: HolderPropertyEnum;
};

export type RestrictedCoownerNode = {
  __typename: 'RestrictedCoownerNode';
  node: RestrictedCoowner;
};

export type RestrictedCustomer = {
  __typename: 'RestrictedCustomer';
  address: Address;
  civility?: Maybe<CivilityEnum>;
  displayName?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastName?: Maybe<Scalars['String']>;
};

export type RestrictedUnit = {
  __typename: 'RestrictedUnit';
  coOwnershipByLawsId: Scalars['String'];
  id: Scalars['String'];
  number: Scalars['String'];
};

export type SendSignatureOtpRequest = {
  agencyId?: InputMaybe<Scalars['String']>;
  brandCode?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  transactionType: Scalars['String'];
};

export type SendSignatureOtpResponse = {
  __typename: 'SendSignatureOtpResponse';
  maxSend: Scalars['Int'];
  sentCount: Scalars['Int'];
};

export type SepaMandateResult = {
  __typename: 'SepaMandateResult';
  docapostSignUrl: Scalars['String'];
  dpSignatureId: Scalars['String'];
  dpTransactionId: Scalars['String'];
  fileBase64?: Maybe<Scalars['String']>;
  validationJwt: Scalars['String'];
};

export enum SignatureTypeEnum {
  Otp = 'OTP',
  Pad = 'PAD'
}

export type SortByType = {
  direction: SortDirectionEnum;
  key: Scalars['String'];
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type StartSignaturePostalResolutionsResponse = {
  __typename: 'StartSignaturePostalResolutionsResponse';
  callbackUrl: Scalars['String'];
  document: Document;
  signUrl: Scalars['String'];
  signatoryId: Scalars['String'];
  transactionId: Scalars['String'];
};

export type Supplier = Node & {
  __typename: 'Supplier';
  activity?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  number: Scalars['String'];
};

export type SupplierContract = Node & {
  __typename: 'SupplierContract';
  description?: Maybe<Scalars['String']>;
  documents: Array<Document>;
  endingDate: Scalars['Datetime'];
  id: Scalars['ID'];
  label?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  supplier: Supplier;
};

export type SupplierContractConnection = {
  __typename: 'SupplierContractConnection';
  edges: Array<SupplierContractNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SupplierContractNode = {
  __typename: 'SupplierContractNode';
  node: SupplierContract;
};

export type SuspendedFlow = {
  __typename: 'SuspendedFlow';
  isSuspended: Scalars['Boolean'];
  reactivationDate?: Maybe<Scalars['Datetime']>;
};

export type TenantAccount = Account & {
  __typename: 'TenantAccount';
  accounting: Accounting;
  bankingInformation: DebitBankingInformation;
  boilerContract: BoilerContract;
  branch?: Maybe<Branch>;
  building: Building;
  count: AccountStat;
  customer: Customer;
  documentCategories: Array<DocumentCategory>;
  documents: DocumentConnection;
  hasFutureLeaseEntryDate: Scalars['Boolean'];
  hasFutureLeaseStartDate: Scalars['Boolean'];
  hasRestrictedAccess: Scalars['Boolean'];
  insurance: Insurance;
  leaseId: Scalars['String'];
  mainUnit: Unit;
  manager?: Maybe<Manager>;
  missionTargets: Array<Housing>;
  number: Scalars['String'];
  quality: AccountQualityEnum;
  showEdenredHeadband: Scalars['Boolean'];
  uuid: Scalars['EncodedID'];
};


export type TenantAccountDocumentCategoriesArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  customerPortalCategories?: InputMaybe<Array<CustomerPortalFileCategoryEnum>>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
};


export type TenantAccountDocumentsArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  customerPortalCategory: CustomerPortalFileCategoryEnum;
  first?: InputMaybe<Scalars['Int']>;
  fromDate?: InputMaybe<Scalars['String']>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']>>;
  originalFilename?: InputMaybe<Scalars['String']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  subCategories?: InputMaybe<Array<Scalars['String']>>;
  toDate?: InputMaybe<Scalars['String']>;
};

export type TerminateSignaturePostalResolutionsResponse = {
  __typename: 'TerminateSignaturePostalResolutionsResponse';
  document: Document;
  transactionId: Scalars['String'];
};

export type Ticket = {
  __typename: 'Ticket';
  activities: Array<TicketActivity>;
  associate?: Maybe<Manager>;
  building?: Maybe<Building>;
  canBeReopened: Scalars['Boolean'];
  cancelledAt?: Maybe<Scalars['Datetime']>;
  category: TicketCategoryEnum;
  createdAt: Scalars['Datetime'];
  customerApprovalDate?: Maybe<Scalars['Datetime']>;
  finishedAt?: Maybe<Scalars['Datetime']>;
  id: Scalars['ID'];
  isRead: Scalars['Boolean'];
  messages: Array<TicketMessage>;
  metadata: TicketMetadata;
  openedAt?: Maybe<Scalars['Datetime']>;
  status: TicketStatusEnum;
  ticketNumber: Scalars['String'];
  unit?: Maybe<Unit>;
  updatedAt?: Maybe<Scalars['Datetime']>;
  wipAt?: Maybe<Scalars['Datetime']>;
};

export type TicketActivity = {
  __typename: 'TicketActivity';
  activityType: TicketActivityEnum;
  createdAt: Scalars['Datetime'];
  metadata?: Maybe<ActivityMetadata>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export enum TicketActivityEnum {
  AutoClosedNoClientResponse = 'AUTO_CLOSED_NO_CLIENT_RESPONSE',
  AutoClosedNoManagerAction = 'AUTO_CLOSED_NO_MANAGER_ACTION',
  CategoryChanged = 'CATEGORY_CHANGED',
  MissionAttached = 'MISSION_ATTACHED',
  TransferFromAssociate = 'TRANSFER_FROM_ASSOCIATE',
  TransferFromSupport = 'TRANSFER_FROM_SUPPORT',
  TransferToMiddleOffice = 'TRANSFER_TO_MIDDLE_OFFICE'
}

export enum TicketCategoryEnum {
  CoOwnerAgContacts = 'CO_OWNER_AG_CONTACTS',
  CoOwnerAgDecision = 'CO_OWNER_AG_DECISION',
  CoOwnerAgOrganisation = 'CO_OWNER_AG_ORGANISATION',
  CoOwnerAgOther = 'CO_OWNER_AG_OTHER',
  CoOwnerBuildingsAccess = 'CO_OWNER_BUILDINGS_ACCESS',
  CoOwnerBuildingsIssue = 'CO_OWNER_BUILDINGS_ISSUE',
  CoOwnerBuildingsMaintenance = 'CO_OWNER_BUILDINGS_MAINTENANCE',
  CoOwnerBuildingsOther = 'CO_OWNER_BUILDINGS_OTHER',
  CoOwnerCustomerPortal = 'CO_OWNER_CUSTOMER_PORTAL',
  CoOwnerCustomerPortalHelp = 'CO_OWNER_CUSTOMER_PORTAL_HELP',
  CoOwnerCustomerPortalOther = 'CO_OWNER_CUSTOMER_PORTAL_OTHER',
  CoOwnerCustomerPortalPayment = 'CO_OWNER_CUSTOMER_PORTAL_PAYMENT',
  CoOwnerDocumentsContact = 'CO_OWNER_DOCUMENTS_CONTACT',
  CoOwnerDocumentsDemand = 'CO_OWNER_DOCUMENTS_DEMAND',
  CoOwnerDocumentsEstimate = 'CO_OWNER_DOCUMENTS_ESTIMATE',
  CoOwnerDocumentsMeters = 'CO_OWNER_DOCUMENTS_METERS',
  CoOwnerDocumentsOther = 'CO_OWNER_DOCUMENTS_OTHER',
  CoOwnerDocumentsRentEstimate = 'CO_OWNER_DOCUMENTS_RENT_ESTIMATE',
  CoOwnerDocumentsSale = 'CO_OWNER_DOCUMENTS_SALE',
  CoOwnerDocumentsSending = 'CO_OWNER_DOCUMENTS_SENDING',
  CoOwnerDpvWithdrawal = 'CO_OWNER_DPV_WITHDRAWAL',
  CoOwnerPaymentCharges = 'CO_OWNER_PAYMENT_CHARGES',
  CoOwnerPaymentDeclaration = 'CO_OWNER_PAYMENT_DECLARATION',
  CoOwnerPaymentDivision = 'CO_OWNER_PAYMENT_DIVISION',
  CoOwnerPaymentExplanations = 'CO_OWNER_PAYMENT_EXPLANATIONS',
  CoOwnerPaymentLatepayment = 'CO_OWNER_PAYMENT_LATEPAYMENT',
  CoOwnerPaymentOther = 'CO_OWNER_PAYMENT_OTHER',
  CoOwnerRepairAgWork = 'CO_OWNER_REPAIR_AG_WORK',
  CoOwnerRepairDeclaration = 'CO_OWNER_REPAIR_DECLARATION',
  CoOwnerRepairFollowup = 'CO_OWNER_REPAIR_FOLLOWUP',
  CoOwnerRepairIntervention = 'CO_OWNER_REPAIR_INTERVENTION',
  CoOwnerRepairOther = 'CO_OWNER_REPAIR_OTHER',
  CoOwnerRepairSinister = 'CO_OWNER_REPAIR_SINISTER',
  CoOwnerRepairWork = 'CO_OWNER_REPAIR_WORK',
  LandlordCoproAgdecision = 'LANDLORD_COPRO_AGDECISION',
  LandlordCoproAgorganisation = 'LANDLORD_COPRO_AGORGANISATION',
  LandlordCoproOther = 'LANDLORD_COPRO_OTHER',
  LandlordCoproSyndic = 'LANDLORD_COPRO_SYNDIC',
  LandlordCustomerPortal = 'LANDLORD_CUSTOMER_PORTAL',
  LandlordDocumentsContacts = 'LANDLORD_DOCUMENTS_CONTACTS',
  LandlordDocumentsDemand = 'LANDLORD_DOCUMENTS_DEMAND',
  LandlordDocumentsEstimate = 'LANDLORD_DOCUMENTS_ESTIMATE',
  LandlordDocumentsMeters = 'LANDLORD_DOCUMENTS_METERS',
  LandlordDocumentsOther = 'LANDLORD_DOCUMENTS_OTHER',
  LandlordDocumentsRib = 'LANDLORD_DOCUMENTS_RIB',
  LandlordDocumentsSale = 'LANDLORD_DOCUMENTS_SALE',
  LandlordIncomeAccount = 'LANDLORD_INCOME_ACCOUNT',
  LandlordIncomeCompensation = 'LANDLORD_INCOME_COMPENSATION',
  LandlordIncomeCrg = 'LANDLORD_INCOME_CRG',
  LandlordIncomeDeclaration = 'LANDLORD_INCOME_DECLARATION',
  LandlordIncomeFees = 'LANDLORD_INCOME_FEES',
  LandlordIncomeOther = 'LANDLORD_INCOME_OTHER',
  LandlordIncomePayment = 'LANDLORD_INCOME_PAYMENT',
  LandlordIncomeTax = 'LANDLORD_INCOME_TAX',
  LandlordIncomeTenant = 'LANDLORD_INCOME_TENANT',
  LandlordRepairDeclaration = 'LANDLORD_REPAIR_DECLARATION',
  LandlordRepairFollowup = 'LANDLORD_REPAIR_FOLLOWUP',
  LandlordRepairIntervention = 'LANDLORD_REPAIR_INTERVENTION',
  LandlordRepairOther = 'LANDLORD_REPAIR_OTHER',
  LandlordRepairSinister = 'LANDLORD_REPAIR_SINISTER',
  LandlordRepairWork = 'LANDLORD_REPAIR_WORK',
  LandlordTenant = 'LANDLORD_TENANT',
  TenantBuildingAccess = 'TENANT_BUILDING_ACCESS',
  TenantBuildingMaintenance = 'TENANT_BUILDING_MAINTENANCE',
  TenantBuildingOther = 'TENANT_BUILDING_OTHER',
  TenantCustomerPortal = 'TENANT_CUSTOMER_PORTAL',
  TenantCustomerPortalHelp = 'TENANT_CUSTOMER_PORTAL_HELP',
  TenantCustomerPortalOther = 'TENANT_CUSTOMER_PORTAL_OTHER',
  TenantCustomerPortalPayment = 'TENANT_CUSTOMER_PORTAL_PAYMENT',
  TenantDeparture = 'TENANT_DEPARTURE',
  TenantDocumentsBoiler = 'TENANT_DOCUMENTS_BOILER',
  TenantDocumentsCaf = 'TENANT_DOCUMENTS_CAF',
  TenantDocumentsContacts = 'TENANT_DOCUMENTS_CONTACTS',
  TenantDocumentsDemand = 'TENANT_DOCUMENTS_DEMAND',
  TenantDocumentsInsurance = 'TENANT_DOCUMENTS_INSURANCE',
  TenantDocumentsMeters = 'TENANT_DOCUMENTS_METERS',
  TenantDocumentsOther = 'TENANT_DOCUMENTS_OTHER',
  TenantPaymentAccount = 'TENANT_PAYMENT_ACCOUNT',
  TenantPaymentDeposit = 'TENANT_PAYMENT_DEPOSIT',
  TenantPaymentLatepayment = 'TENANT_PAYMENT_LATEPAYMENT',
  TenantPaymentOther = 'TENANT_PAYMENT_OTHER',
  TenantPaymentReceipt = 'TENANT_PAYMENT_RECEIPT',
  TenantPaymentRegularization = 'TENANT_PAYMENT_REGULARIZATION',
  TenantPaymentRent = 'TENANT_PAYMENT_RENT',
  TenantRepairDeclaration = 'TENANT_REPAIR_DECLARATION',
  TenantRepairFollowup = 'TENANT_REPAIR_FOLLOWUP',
  TenantRepairIntervention = 'TENANT_REPAIR_INTERVENTION',
  TenantRepairOther = 'TENANT_REPAIR_OTHER',
  TenantRepairSinister = 'TENANT_REPAIR_SINISTER',
  TenantRepairWork = 'TENANT_REPAIR_WORK',
  Unknown = 'UNKNOWN'
}

export type TicketConnection = {
  __typename: 'TicketConnection';
  edges: Array<TicketNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum TicketCreatorEnum {
  Client = 'CLIENT',
  Manager = 'MANAGER',
  MiddleOffice = 'MIDDLE_OFFICE'
}

export enum TicketHeadingCategoryEnum {
  CoOwnerAg = 'CO_OWNER_AG',
  CoOwnerBuildings = 'CO_OWNER_BUILDINGS',
  CoOwnerCustomerPortal = 'CO_OWNER_CUSTOMER_PORTAL',
  CoOwnerDocuments = 'CO_OWNER_DOCUMENTS',
  CoOwnerPayment = 'CO_OWNER_PAYMENT',
  CoOwnerRepair = 'CO_OWNER_REPAIR',
  LandlordCopro = 'LANDLORD_COPRO',
  LandlordCustomerPortal = 'LANDLORD_CUSTOMER_PORTAL',
  LandlordDocuments = 'LANDLORD_DOCUMENTS',
  LandlordIncome = 'LANDLORD_INCOME',
  LandlordRepair = 'LANDLORD_REPAIR',
  LandlordTenant = 'LANDLORD_TENANT',
  TenantBuilding = 'TENANT_BUILDING',
  TenantCustomerPortal = 'TENANT_CUSTOMER_PORTAL',
  TenantDeparture = 'TENANT_DEPARTURE',
  TenantDocuments = 'TENANT_DOCUMENTS',
  TenantPayment = 'TENANT_PAYMENT',
  TenantRepair = 'TENANT_REPAIR'
}

export type TicketMessage = {
  __typename: 'TicketMessage';
  associate?: Maybe<Manager>;
  content: Scalars['String'];
  createdAt: Scalars['Datetime'];
  createdBy: TicketCreatorEnum;
  documents?: Maybe<Array<Document>>;
  metadata: MessageMetadata;
  source?: Maybe<TicketSourceEnum>;
  updatedAt?: Maybe<Scalars['Datetime']>;
};

export type TicketMetadata = {
  __typename: 'TicketMetadata';
  accountId?: Maybe<Scalars['String']>;
  associateId?: Maybe<Scalars['String']>;
  branchId?: Maybe<Scalars['String']>;
  buildingId?: Maybe<Scalars['String']>;
  customerId?: Maybe<Scalars['String']>;
  mission?: Maybe<TicketMission>;
  unitId?: Maybe<Scalars['String']>;
};

export type TicketMission = {
  __typename: 'TicketMission';
  id: Scalars['String'];
  kind: MissionKindRestrictedEnum;
};

export type TicketNode = {
  __typename: 'TicketNode';
  node: Ticket;
};

export enum TicketSourceEnum {
  Agence = 'AGENCE',
  Associate = 'ASSOCIATE',
  CustomerPortal = 'CUSTOMER_PORTAL',
  Email = 'EMAIL',
  Telephone = 'TELEPHONE'
}

export enum TicketStatusEnum {
  Closed = 'CLOSED',
  Finished = 'FINISHED',
  Open = 'OPEN',
  Processed = 'PROCESSED',
  WaitingForFirstClientResponse = 'WAITING_FOR_FIRST_CLIENT_RESPONSE',
  WorkInProgress = 'WORK_IN_PROGRESS'
}

export type TrusteeCouncil = {
  __typename: 'TrusteeCouncil';
  accountingCurrent: BuildingAccountingCurrent;
  accountingPeriods: AccountingPeriodConnection;
  bankBalance: Amount;
  coowners: RestrictedCoownerConnection;
  missionIncidents: MissionIncidentConnection;
  missionMeetings: MissionMeetingConnection;
  missionRepairs: MissionRepairConnection;
  missionVisits: MissionVisitConnection;
  pastAccountingRGDD: PastBuildingAccountingRgdd;
  projectDocuments: DocumentConnection;
  repairBudgets: BuildingRepairBudget;
  supplierContracts: SupplierContractConnection;
  votedBudget: Amount;
};


export type TrusteeCouncilAccountingCurrentArgs = {
  withPreviousExercice?: InputMaybe<Scalars['Boolean']>;
};


export type TrusteeCouncilAccountingPeriodsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  closingDateTo?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  status?: InputMaybe<Array<AccountingPeriodStatusEnum>>;
};


export type TrusteeCouncilCoownersArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  customerName?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  fullAddress?: InputMaybe<Scalars['String']>;
  holderProperties?: InputMaybe<Array<Scalars['String']>>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  units?: InputMaybe<Array<Scalars['String']>>;
};


export type TrusteeCouncilMissionIncidentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  status?: InputMaybe<Array<MissionStatusEnum>>;
};


export type TrusteeCouncilMissionMeetingsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  isPast: Scalars['Boolean'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
};


export type TrusteeCouncilMissionRepairsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  status?: InputMaybe<Array<MissionStatusEnum>>;
};


export type TrusteeCouncilMissionVisitsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  status?: InputMaybe<Array<MissionStatusEnum>>;
};


export type TrusteeCouncilPastAccountingRgddArgs = {
  accountingPeriodId?: InputMaybe<Scalars['String']>;
};


export type TrusteeCouncilProjectDocumentsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType>>;
  subCategory?: InputMaybe<Scalars['String']>;
};


export type TrusteeCouncilRepairBudgetsArgs = {
  accountUuid: Scalars['EncodedID'];
  budgetId: Scalars['ID'];
};


export type TrusteeCouncilSupplierContractsArgs = {
  after?: InputMaybe<Scalars['Cursor']>;
  before?: InputMaybe<Scalars['Cursor']>;
  description?: InputMaybe<Scalars['String']>;
  endingDateFrom?: InputMaybe<Scalars['String']>;
  endingDateTo?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  supplierFullname?: InputMaybe<Scalars['String']>;
};

export enum TrusteeCouncilQualityEnum {
  Alternate = 'ALTERNATE',
  Auditor = 'AUDITOR',
  Member = 'MEMBER',
  NotAMember = 'NOT_A_MEMBER',
  President = 'PRESIDENT',
  Secretary = 'SECRETARY',
  Treasurer = 'TREASURER',
  VicePresident = 'VICE_PRESIDENT'
}

export type Unit = Node & {
  __typename: 'Unit';
  coOwnershipByLawsId?: Maybe<Scalars['String']>;
  description: UnitDescription;
  fractionalShares?: Maybe<Scalars['Int']>;
  id: Scalars['ID'];
  number: Scalars['String'];
  shareBase?: Maybe<Scalars['Int']>;
  situation: UnitSituation;
};

export type UnitDescription = {
  __typename: 'UnitDescription';
  entityType?: Maybe<PropertyTypeEnum>;
  freeLabeling?: Maybe<Scalars['String']>;
  isMainUnit?: Maybe<Scalars['Boolean']>;
  surface?: Maybe<UnitDescriptionSurface>;
  totalRooms?: Maybe<UnitDescriptionRooms>;
};

export type UnitDescriptionRooms = {
  __typename: 'UnitDescriptionRooms';
  commercial?: Maybe<Scalars['Float']>;
  liveable?: Maybe<Scalars['Float']>;
};

export type UnitDescriptionSurface = {
  __typename: 'UnitDescriptionSurface';
  carrezLaw?: Maybe<Scalars['Float']>;
  garden?: Maybe<Scalars['Float']>;
  liveable?: Maybe<Scalars['Float']>;
};

export type UnitSituation = {
  __typename: 'UnitSituation';
  door?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  property?: Maybe<Scalars['String']>;
  stairs?: Maybe<Scalars['String']>;
};

export type UpdateCredentialsRequest = {
  brandCode?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
  newLogin: Scalars['String'];
  password: Scalars['String'];
  temporaryLogin: Scalars['String'];
};

export type UpdateCreditBankingInformationRequest = {
  bic: Scalars['String'];
  firstName: Scalars['String'];
  iban: Scalars['String'];
  lastName: Scalars['String'];
};

export type UpdateCustomerConsentRequest = {
  isFirstSubmit?: InputMaybe<Scalars['Boolean']>;
  partnersOffersInformation?: InputMaybe<Scalars['Boolean']>;
  personalData?: InputMaybe<Scalars['Boolean']>;
};

export type UpdateCustomerPushNotificationPermissionRequest = {
  enable: Scalars['Boolean'];
  kind: PushNotificationPermissionEnum;
};

export type UpdateCustomerPushNotificationRequest = {
  permissions?: InputMaybe<Array<UpdateCustomerPushNotificationPermissionRequest>>;
  token?: InputMaybe<Scalars['String']>;
};

export type UpdateCustomerShowDalenysHeadbandRequest = {
  showDalenysHeadband: Scalars['Boolean'];
};

export type UpdateCustomerSnailMailRequest = {
  noSnailMail: Scalars['Boolean'];
};

export type UpdatePasswordRequest = {
  brandCode: BrandCodeEnum;
  confirmationPassword: Scalars['String'];
  currentPassword: Scalars['String'];
  newPassword: Scalars['String'];
  userId: Scalars['ID'];
};

export type UploadLandLordPropertyTaxInput = {
  areAllBuildingsManagedByAgency: Scalars['Boolean'];
  buildings: Array<BuildingInput>;
  fileId: Scalars['String'];
  fiscalManagementFees: AmountInput;
  fiscalYear: Scalars['Int'];
  lessorAccountId?: InputMaybe<Scalars['String']>;
  total: AmountInput;
};

export type ValidMissionWithSaleAgreementResponse = {
  __typename: 'ValidMissionWithSaleAgreementResponse';
  isSuccess: Scalars['Boolean'];
  message: Scalars['String'];
};

export type ValidateResetPasswordRequest = {
  newPassword: Scalars['String'];
  remoteToken?: InputMaybe<Scalars['String']>;
  tokenReset: Scalars['String'];
};

export type ValidateSignatureRequest = {
  otp: Scalars['String'];
};

export type ValidateSignatureResponse = {
  __typename: 'ValidateSignatureResponse';
  date: Scalars['String'];
  id: Scalars['String'];
};

export type VerifyCredentialsRequest = {
  verifyToken: Scalars['String'];
};

export type VoteInput = {
  candidate?: InputMaybe<Scalars['String']>;
  isSecondVote: Scalars['Boolean'];
  resolutionId: Scalars['String'];
  status: PostalVoteStatusEnum;
};

export type WorkOrder = Node & {
  __typename: 'WorkOrder';
  id: Scalars['ID'];
  label: Scalars['String'];
  number: Scalars['String'];
  repairDate: WorkOrderRepairDate;
  supplier: Supplier;
};

export type WorkOrderConnection = {
  __typename: 'WorkOrderConnection';
  edges: Array<WorkOrderNode>;
  pageInfo: PageInfo;
  totalCount?: Maybe<Scalars['Int']>;
};

export type WorkOrderNode = {
  __typename: 'WorkOrderNode';
  node: WorkOrder;
};

export type WorkOrderRepairDate = {
  __typename: 'WorkOrderRepairDate';
  end: Scalars['Datetime'];
  start: Scalars['Datetime'];
};

export enum WorkOrderStatusEnum {
  Accepted = 'ACCEPTED',
  CanceledByTheManager = 'CANCELED_BY_THE_MANAGER',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  Finished = 'FINISHED',
  Paid = 'PAID',
  PendingReply = 'PENDING_REPLY',
  Received = 'RECEIVED',
  UnderPayment = 'UNDER_PAYMENT',
  Unpaid = 'UNPAID'
}

export type ZipFileWorkflow = ZipFileWorkflowAcceptedResult | ZipFileWorkflowResult;

export type ZipFileWorkflowAcceptedResult = {
  __typename: 'ZipFileWorkflowAcceptedResult';
  workflow: Scalars['String'];
};

export type ZipFileWorkflowResult = {
  __typename: 'ZipFileWorkflowResult';
  url: Scalars['String'];
};

export type PhysicalBuilding = {
  __typename: 'physicalBuilding';
  entrances: Array<PhysicalBuildingEntrance>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type PhysicalBuildingEntrance = {
  __typename: 'physicalBuildingEntrance';
  id?: Maybe<Scalars['String']>;
  pinpad?: Maybe<Scalars['String']>;
};

export type GetAccountingBalanceQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetAccountingBalanceQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } | { __typename: 'LandlordAccount', uuid: string, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } };

export type GetAccountingLineNewTenantQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
}>;


export type GetAccountingLineNewTenantQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'LandlordAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', endCursor?: string | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> } } } };

export type GetAccountingLinesQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
}>;


export type GetAccountingLinesQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'LandlordAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> } } } };

export type GetAccountingLinesCsvQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
}>;


export type GetAccountingLinesCsvQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', exportedData: string } } | { __typename: 'LandlordAccount', uuid: string, accounting: { __typename: 'Accounting', exportedData: string } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', exportedData: string } } };

export type GetLandlordAccountingBalanceQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetLandlordAccountingBalanceQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } | { __typename: 'LandlordAccount', uuid: string, landlordAccounting: { __typename: 'LandlordAccounting', balances: { __typename: 'LandlordAccountingBalances', globalSituation: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, provisionAmount: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } };

export type BuildingBalanceFragment = { __typename: 'BuildingBalance', buildingId: string, total: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type GetLandlordAccountingLinesQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  startingDate?: InputMaybe<Scalars['String']>;
  endingDate?: InputMaybe<Scalars['String']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  skipNotPaginatedData?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetLandlordAccountingLinesQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string } | { __typename: 'LandlordAccount', uuid: string, landlordAccounting: { __typename: 'LandlordAccounting', balances: { __typename: 'LandlordAccountingBalances', buildingsTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, buildingTotals: Array<{ __typename: 'BuildingBalance', buildingId: string, total: { __typename: 'Amount', value: any, currency: CurrencyEnum } }>, globalTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'TenantAccount', uuid: string } };

export type GetLandlordAccountingLinesCsvQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  buildingIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  startingDate?: InputMaybe<Scalars['String']>;
  endingDate?: InputMaybe<Scalars['String']>;
}>;


export type GetLandlordAccountingLinesCsvQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string } | { __typename: 'LandlordAccount', uuid: string, landlordAccounting: { __typename: 'LandlordAccounting', exportedData: string } } | { __typename: 'TenantAccount', uuid: string } };

type AccountCoownerAccountFragment = { __typename: 'CoownerAccount', hasEReleve: boolean, hasAccessToGeneralAssembly: boolean, hasActiveCoOwnershipMandate: boolean, coOwnershipMandateId: string, isTrusteeCouncilMember: boolean, showDalenysHeadband: boolean, uuid: string, number: string, quality: AccountQualityEnum, hasRestrictedAccess: boolean, eReco: { __typename: 'CoownerAccountEReco', isSubscribed: boolean, hasHistory: boolean }, suspendedFlow: { __typename: 'SuspendedFlow', isSuspended: boolean, reactivationDate?: string | null }, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null }, manager?: { __typename: 'Manager', id: string } | null, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null };

type AccountLandlordAccountFragment = { __typename: 'LandlordAccount', uuid: string, number: string, quality: AccountQualityEnum, hasRestrictedAccess: boolean, buildings: Array<{ __typename: 'Building', id: string, number: string, name?: string | null, numberOfElevators?: number | null, shareBase?: number | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, physicalBuildings: Array<{ __typename: 'physicalBuilding', id: string, name: string, entrances: Array<{ __typename: 'physicalBuildingEntrance', id?: string | null, pinpad?: string | null }> }>, conciergeOffice?: { __typename: 'BuildingConciergeOffice', exist: boolean, hours?: string | null, openingDays?: string | null, phone?: string | null } | null, units: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }> }>, mainUnits: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }>, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null }, manager?: { __typename: 'Manager', id: string } | null, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null };

type AccountTenantAccountFragment = { __typename: 'TenantAccount', hasFutureLeaseEntryDate: boolean, leaseId: string, uuid: string, number: string, quality: AccountQualityEnum, hasRestrictedAccess: boolean, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, mainUnit: { __typename: 'Unit', id: string }, insurance: { __typename: 'Insurance', hasTenantInsuranceHeadband: boolean, endDate?: string | null }, boilerContract: { __typename: 'BoilerContract', endDate?: string | null, needHeatingCertificate: boolean }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null }, manager?: { __typename: 'Manager', id: string } | null, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null };

export type AccountFragment = AccountCoownerAccountFragment | AccountLandlordAccountFragment | AccountTenantAccountFragment;

export type GetAccountQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
}>;


export type GetAccountQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', hasEReleve: boolean, hasAccessToGeneralAssembly: boolean, hasActiveCoOwnershipMandate: boolean, coOwnershipMandateId: string, isTrusteeCouncilMember: boolean, showDalenysHeadband: boolean, uuid: string, number: string, quality: AccountQualityEnum, hasRestrictedAccess: boolean, eReco: { __typename: 'CoownerAccountEReco', isSubscribed: boolean, hasHistory: boolean }, suspendedFlow: { __typename: 'SuspendedFlow', isSuspended: boolean, reactivationDate?: string | null }, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null }, manager?: { __typename: 'Manager', id: string } | null, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null } | { __typename: 'LandlordAccount', uuid: string, number: string, quality: AccountQualityEnum, hasRestrictedAccess: boolean, buildings: Array<{ __typename: 'Building', id: string, number: string, name?: string | null, numberOfElevators?: number | null, shareBase?: number | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, physicalBuildings: Array<{ __typename: 'physicalBuilding', id: string, name: string, entrances: Array<{ __typename: 'physicalBuildingEntrance', id?: string | null, pinpad?: string | null }> }>, conciergeOffice?: { __typename: 'BuildingConciergeOffice', exist: boolean, hours?: string | null, openingDays?: string | null, phone?: string | null } | null, units: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }> }>, mainUnits: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }>, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null }, manager?: { __typename: 'Manager', id: string } | null, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null } | { __typename: 'TenantAccount', hasFutureLeaseEntryDate: boolean, leaseId: string, uuid: string, number: string, quality: AccountQualityEnum, hasRestrictedAccess: boolean, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, mainUnit: { __typename: 'Unit', id: string }, insurance: { __typename: 'Insurance', hasTenantInsuranceHeadband: boolean, endDate?: string | null }, boilerContract: { __typename: 'BoilerContract', endDate?: string | null, needHeatingCertificate: boolean }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null }, manager?: { __typename: 'Manager', id: string } | null, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null } };

type BasicAccountCoownerAccountFragment = { __typename: 'CoownerAccount', uuid: string, number: string, quality: AccountQualityEnum, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, count: { __typename: 'AccountStat', units: number, buildings: number }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null } };

type BasicAccountLandlordAccountFragment = { __typename: 'LandlordAccount', uuid: string, number: string, quality: AccountQualityEnum, buildings: Array<{ __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }>, count: { __typename: 'AccountStat', units: number, buildings: number }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null } };

type BasicAccountTenantAccountFragment = { __typename: 'TenantAccount', uuid: string, number: string, quality: AccountQualityEnum, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, count: { __typename: 'AccountStat', units: number, buildings: number }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null } };

export type BasicAccountFragment = BasicAccountCoownerAccountFragment | BasicAccountLandlordAccountFragment | BasicAccountTenantAccountFragment;

export type GetBasicAccountsQueryVariables = Exact<{
  itemsPerPage?: InputMaybe<Scalars['Int']>;
  pageNumber?: InputMaybe<Scalars['Int']>;
}>;


export type GetBasicAccountsQuery = { __typename: 'Query', accounts: Array<{ __typename: 'CoownerAccount', uuid: string, number: string, quality: AccountQualityEnum, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, count: { __typename: 'AccountStat', units: number, buildings: number }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null } } | { __typename: 'LandlordAccount', uuid: string, number: string, quality: AccountQualityEnum, buildings: Array<{ __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }>, count: { __typename: 'AccountStat', units: number, buildings: number }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null } } | { __typename: 'TenantAccount', uuid: string, number: string, quality: AccountQualityEnum, building: { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> }, count: { __typename: 'AccountStat', units: number, buildings: number }, customer: { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null } }> };

export type ConfirmPasswordUpdateMutationVariables = Exact<{
  request: ConfirmPasswordUpdateRequest;
}>;


export type ConfirmPasswordUpdateMutation = { __typename: 'Mutation', confirmPasswordUpdate: boolean };

export type GetMeQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMeQuery = { __typename: 'Query', me: { __typename: 'Me', isTemporary: boolean, login: string, civility?: CivilityEnum | null, companyName?: string | null, fullname?: string | null, isCompany: boolean } };

export type LoginMutationVariables = Exact<{
  request: LoginRequest;
}>;


export type LoginMutation = { __typename: 'Mutation', login: { __typename: 'LoginResponse', token: string } };

export type LoginAssociationConfirmationFirstConnectionMutationVariables = Exact<{
  login: Scalars['String'];
  emailToken: Scalars['String'];
  password?: InputMaybe<Scalars['String']>;
  idpAccessToken?: InputMaybe<Scalars['String']>;
  brandCode?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
}>;


export type LoginAssociationConfirmationFirstConnectionMutation = { __typename: 'Mutation', loginAssociationConfirmationFirstConnection: string };

export type LoginAssociationRequestFirstConnectionMutationVariables = Exact<{
  login: Scalars['String'];
  brandCode?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
}>;


export type LoginAssociationRequestFirstConnectionMutation = { __typename: 'Mutation', loginAssociationRequestFirstConnection: string };

export type LoginCheckMutationVariables = Exact<{
  login: Scalars['String'];
}>;


export type LoginCheckMutation = { __typename: 'Mutation', loginCheck: { __typename: 'LoginCheckResponse', isTemporaryLogin: boolean, isOktaAuthenticationFlow?: boolean | null, redirectUrl?: string | null } };

export type LoginCheckFirstConnectionMutationVariables = Exact<{
  login: Scalars['String'];
}>;


export type LoginCheckFirstConnectionMutation = { __typename: 'Mutation', loginCheckFirstConnection: { __typename: 'LoginCheckFirstConnectionResponse', isUniqueLogin: boolean, isOktaLoginEnabled: boolean } };

export type ResetPasswordMutationVariables = Exact<{
  request: ResetPasswordRequest;
}>;


export type ResetPasswordMutation = { __typename: 'Mutation', resetPassword: string };

export type UpdateCredentialsMutationVariables = Exact<{
  request: UpdateCredentialsRequest;
}>;


export type UpdateCredentialsMutation = { __typename: 'Mutation', updateCredentials: { __typename: 'Customer', id: string } };

export type UpdatePasswordMutationVariables = Exact<{
  request: UpdatePasswordRequest;
}>;


export type UpdatePasswordMutation = { __typename: 'Mutation', updatePassword: string };

export type ValidateEmailFirstConnectionMutationVariables = Exact<{
  token: Scalars['String'];
  brandCode?: InputMaybe<Scalars['String']>;
  callbackUrl?: InputMaybe<Scalars['String']>;
}>;


export type ValidateEmailFirstConnectionMutation = { __typename: 'Mutation', validateEmailFirstConnection: string };

export type ValidateResetPasswordMutationVariables = Exact<{
  request: ValidateResetPasswordRequest;
}>;


export type ValidateResetPasswordMutation = { __typename: 'Mutation', validateResetPassword: string };

export type VerifyCredentialsMutationVariables = Exact<{
  request: VerifyCredentialsRequest;
}>;


export type VerifyCredentialsMutation = { __typename: 'Mutation', verifyCredentials: string };

export type GetAccountingPeriodsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  sortBy?: InputMaybe<Array<SortByType> | SortByType>;
  status?: InputMaybe<Array<AccountingPeriodStatusEnum> | AccountingPeriodStatusEnum>;
  closingDateTo?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type GetAccountingPeriodsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', accountingPeriods: { __typename: 'AccountingPeriodConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'AccountingPeriodNode', node: { __typename: 'AccountingPeriod', id: string, name: string, openingDate: string, closingDate: string, status?: AccountingPeriodStatusEnum | null } }> } } } };

export type BuildingAccountingCurrentExpenseFragment = { __typename: 'BuildingAccountingCurrentExpense', invoiceId?: string | null, label: string, date: string, isFromPreviousPeriod: boolean, piece?: { __typename: 'Document', hashFile: string } | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } };

export type BuildingAccountingCurrentExpenseTypeFragment = { __typename: 'BuildingAccountingCurrentExpenseType', id: string, allocationId: string, name: string, code: string, previousTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, votedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, total: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'BuildingAccountingCurrentExpense', invoiceId?: string | null, label: string, date: string, isFromPreviousPeriod: boolean, piece?: { __typename: 'Document', hashFile: string } | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } }> };

export type BuildingAccountingCurrentAllocationFragment = { __typename: 'BuildingAccountingCurrentAllocation', id: string, name: string, code: string, previousTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, votedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, total: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenseTypes: Array<{ __typename: 'BuildingAccountingCurrentExpenseType', id: string, allocationId: string, name: string, code: string, previousTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, votedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, total: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'BuildingAccountingCurrentExpense', invoiceId?: string | null, label: string, date: string, isFromPreviousPeriod: boolean, piece?: { __typename: 'Document', hashFile: string } | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } }> }> };

export type GetBuildingAccountingCurrentQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
}>;


export type GetBuildingAccountingCurrentQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', bankBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, accountingCurrent: { __typename: 'BuildingAccountingCurrent', id: string, openingDate: string, closingDate: string, previousTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, votedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, total: { __typename: 'Amount', value: any, currency: CurrencyEnum }, allocations: Array<{ __typename: 'BuildingAccountingCurrentAllocation', id: string, name: string, code: string, previousTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, votedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, total: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenseTypes: Array<{ __typename: 'BuildingAccountingCurrentExpenseType', id: string, allocationId: string, name: string, code: string, previousTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, votedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, total: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'BuildingAccountingCurrentExpense', invoiceId?: string | null, label: string, date: string, isFromPreviousPeriod: boolean, piece?: { __typename: 'Document', hashFile: string } | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } }> }> }> } } } };

export type GetBuildingAccountingRgddQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
  accountingPeriodId?: InputMaybe<Scalars['String']>;
}>;


export type GetBuildingAccountingRgddQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', pastAccountingRGDD: { __typename: 'PastBuildingAccountingRGDD', totalToAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, totalVat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, totalRecoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, allocations: Array<{ __typename: 'Allocation', id: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenseTypes: Array<{ __typename: 'ExpenseType', id: string, allocationId: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'Expense', id: string, label: string, date: string, invoiceId?: string | null, piece?: { __typename: 'Document', hashFile: string, category: FileCategoryEnum, id: string } | null, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum } }> }> }> } } } };

export type RestrictedUnitFragment = { __typename: 'RestrictedUnit', id: string, number: string, coOwnershipByLawsId: string };

export type RestrictedCoownerFragment = { __typename: 'RestrictedCoowner', id: string, units: Array<{ __typename: 'RestrictedUnit', id: string, number: string, coOwnershipByLawsId: string }>, mainHolder: { __typename: 'RestrictedCoownerHolder', propertyType: HolderPropertyEnum, customer: { __typename: 'RestrictedCustomer', id: string, civility?: CivilityEnum | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, address: { __typename: 'Address', address1?: string | null, city?: string | null, zipCode?: string | null } } }, balance: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type GetCouncilCoownersQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  customerName: Scalars['String'];
  fullAddress: Scalars['String'];
  sortBy?: InputMaybe<Array<SortByType> | SortByType>;
  units?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  holderProperties?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetCouncilCoownersQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', coowners: { __typename: 'RestrictedCoownerConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'RestrictedCoownerNode', node: { __typename: 'RestrictedCoowner', id: string, units: Array<{ __typename: 'RestrictedUnit', id: string, number: string, coOwnershipByLawsId: string }>, mainHolder: { __typename: 'RestrictedCoownerHolder', propertyType: HolderPropertyEnum, customer: { __typename: 'RestrictedCustomer', id: string, civility?: CivilityEnum | null, firstName?: string | null, lastName?: string | null, displayName?: string | null, address: { __typename: 'Address', address1?: string | null, city?: string | null, zipCode?: string | null } } }, balance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } }> } } } };

export type GetCouncilProjectDocumentsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  sortBy?: InputMaybe<Array<SortByType> | SortByType>;
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  skipNotPaginatedData?: Scalars['Boolean'];
}>;


export type GetCouncilProjectDocumentsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, pastGeneralAssembly?: { __typename: 'MissionGeneralAssembly', id: string, label?: string | null, lastValidPostalVoteReceptionDate?: string | null, hasAccessToPostalVote: boolean, hasPreVoting: boolean, status: MissionStatusEnum, officialMeeting: { __typename: 'GeneralAssemblyOfficialMeeting', date?: string | null }, meetingPlace: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, nextGeneralAssembly?: { __typename: 'MissionGeneralAssembly', id: string, label?: string | null, lastValidPostalVoteReceptionDate?: string | null, hasAccessToPostalVote: boolean, hasPreVoting: boolean, status: MissionStatusEnum, officialMeeting: { __typename: 'GeneralAssemblyOfficialMeeting', date?: string | null }, meetingPlace: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, trusteeCouncil: { __typename: 'TrusteeCouncil', projectDocuments: { __typename: 'DocumentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'DocumentNode', node: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } }> } } } };

export type BuildingRepairBudgetFragment = { __typename: 'BuildingRepairBudget', budgetId: string, totalToAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, totalVat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, totalRecoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, allocations: Array<{ __typename: 'Allocation', id: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenseTypes: Array<{ __typename: 'ExpenseType', id: string, allocationId: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'Expense', id: string, label: string, date: string, invoiceId?: string | null, piece?: { __typename: 'Document', hashFile: string, category: FileCategoryEnum, id: string } | null, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum } }> }> }> };

export type GetRepairBudgetDetailsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  budgetId: Scalars['ID'];
}>;


export type GetRepairBudgetDetailsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', repairBudgets: { __typename: 'BuildingRepairBudget', budgetId: string, totalToAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, totalVat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, totalRecoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, allocations: Array<{ __typename: 'Allocation', id: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenseTypes: Array<{ __typename: 'ExpenseType', id: string, allocationId: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'Expense', id: string, label: string, date: string, invoiceId?: string | null, piece?: { __typename: 'Document', hashFile: string, category: FileCategoryEnum, id: string } | null, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum } }> }> }> } } } };

export type GetRepairBudgetsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetRepairBudgetsQuery = { __typename: 'Query', repairBudgets: Array<{ __typename: 'BuildingRepairBudgetType', id: string, label: string, validatedAmount: { __typename: 'Amount', value: any, currency: CurrencyEnum } }> };

export type ConfirmBankingInformationUpdateMutationVariables = Exact<{
  request: ConfirmBankingInformationUpdateRequest;
}>;


export type ConfirmBankingInformationUpdateMutation = { __typename: 'Mutation', confirmBankingInformationUpdate: boolean };

export type UpdateCoOwnerAccountSnailMailMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: UpdateCustomerSnailMailRequest;
}>;


export type UpdateCoOwnerAccountSnailMailMutation = { __typename: 'Mutation', updateCoOwnerAccountSnailMail: { __typename: 'CoownerAccount', uuid: string, hasEReleve: boolean } };

export type UpdateCustomerConsentMutationVariables = Exact<{
  customerId: Scalars['ID'];
  request: UpdateCustomerConsentRequest;
}>;


export type UpdateCustomerConsentMutation = { __typename: 'Mutation', updateCustomerConsent: { __typename: 'Customer', id: string, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, partnersOffersInformation: boolean, isFirstSubmit: boolean } } };

export type UpdateCustomerShowDalenysHeadbandMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: UpdateCustomerShowDalenysHeadbandRequest;
}>;


export type UpdateCustomerShowDalenysHeadbandMutation = { __typename: 'Mutation', updateCustomerShowDalenysHeadband: { __typename: 'CoownerAccount', uuid: string, showDalenysHeadband: boolean } };

export type UpdateCustomerSnailMailMutationVariables = Exact<{
  customerId: Scalars['ID'];
  request: UpdateCustomerSnailMailRequest;
}>;


export type UpdateCustomerSnailMailMutation = { __typename: 'Mutation', updateCustomerSnailMail: { __typename: 'Customer', id: string, noSnailMail?: boolean | null } };

export type GetBranchQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
}>;


export type GetBranchQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null } | { __typename: 'LandlordAccount', uuid: string, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null } | { __typename: 'TenantAccount', uuid: string, branch?: { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } } | null } };

export type GetDashboardAccountingBalanceQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
}>;


export type GetDashboardAccountingBalanceQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> }, currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } | { __typename: 'LandlordAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> }, currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', lines: { __typename: 'AccountingLineConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingLineNode', node: { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } } }> }, currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } } } };

export type GetDashboardTicketsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  sortBy?: InputMaybe<Array<SortByType> | SortByType>;
}>;


export type GetDashboardTicketsQuery = { __typename: 'Query', tickets: { __typename: 'TicketConnection', edges: Array<{ __typename: 'TicketNode', node: { __typename: 'Ticket', id: string, category: TicketCategoryEnum, ticketNumber: string, status: TicketStatusEnum, createdAt: string, finishedAt?: string | null, isRead: boolean, canBeReopened: boolean, customerApprovalDate?: string | null, cancelledAt?: string | null, messages: Array<{ __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null }>, activities: Array<{ __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null }>, building?: { __typename: 'Building', id: string, number: string, name?: string | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, unit?: { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } } | null, metadata: { __typename: 'TicketMetadata', mission?: { __typename: 'TicketMission', kind: MissionKindRestrictedEnum } | null } } }> } };

export type GetManagerQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
}>;


export type GetManagerQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, manager?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null } | { __typename: 'LandlordAccount', uuid: string, manager?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null } | { __typename: 'TenantAccount', uuid: string, manager?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null } };

export type CreateFileDraftMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: FileDraftInput;
}>;


export type CreateFileDraftMutation = { __typename: 'Mutation', createFileDraft: { __typename: 'FileDraft', id: string, uploadUrl: string } };

export type GetAccountDocumentsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  customerPortalCategory: CustomerPortalFileCategoryEnum;
  subCategories?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  originalFilename?: InputMaybe<Scalars['String']>;
  fromDate?: InputMaybe<Scalars['String']>;
  toDate?: InputMaybe<Scalars['String']>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetAccountDocumentsQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, documents: { __typename: 'DocumentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'DocumentNode', node: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } }> } } | { __typename: 'LandlordAccount', uuid: string, documents: { __typename: 'DocumentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'DocumentNode', node: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } }> } } | { __typename: 'TenantAccount', uuid: string, documents: { __typename: 'DocumentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'DocumentNode', node: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } }> } } };

export type ErecoFragment = { __typename: 'CoownerAccountERecoDocument', id: string, url: string, typeDocument: FileCategoryEnum, createdAt: string, status: MailStatusEnum, document: { __typename: 'Document', hashFile: string } };

export type GetAccountErecoDocumentsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
}>;


export type GetAccountErecoDocumentsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, eReco: { __typename: 'CoownerAccountEReco', documents: { __typename: 'CoownerAccountERecoDocumentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'CoownerAccountERecoDocumentNode', node: { __typename: 'CoownerAccountERecoDocument', id: string, url: string, typeDocument: FileCategoryEnum, createdAt: string, status: MailStatusEnum, document: { __typename: 'Document', hashFile: string } } }> } } } };

export type GetDocumentCategoriesQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  customerPortalCategories?: InputMaybe<Array<CustomerPortalFileCategoryEnum> | CustomerPortalFileCategoryEnum>;
  missionGeneralAssemblyIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type GetDocumentCategoriesQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', isTrusteeCouncilMember: boolean, uuid: string, quality: AccountQualityEnum, eReco: { __typename: 'CoownerAccountEReco', isSubscribed: boolean, hasHistory: boolean }, documentCategories: Array<{ __typename: 'DocumentCategory', key: CustomerPortalFileCategoryEnum, documentStats: { __typename: 'DocumentCategoryStat', count: number, lastCreatedAt?: string | null }, subCategories: Array<{ __typename: 'DocumentSubCategory', key: FileCategoryEnum }> }> } | { __typename: 'LandlordAccount', uuid: string, quality: AccountQualityEnum, documentCategories: Array<{ __typename: 'DocumentCategory', key: CustomerPortalFileCategoryEnum, documentStats: { __typename: 'DocumentCategoryStat', count: number, lastCreatedAt?: string | null }, subCategories: Array<{ __typename: 'DocumentSubCategory', key: FileCategoryEnum }> }> } | { __typename: 'TenantAccount', uuid: string, quality: AccountQualityEnum, documentCategories: Array<{ __typename: 'DocumentCategory', key: CustomerPortalFileCategoryEnum, documentStats: { __typename: 'DocumentCategoryStat', count: number, lastCreatedAt?: string | null }, subCategories: Array<{ __typename: 'DocumentSubCategory', key: FileCategoryEnum }> }> } };

export type GetDocumentUrlQueryVariables = Exact<{
  hash: Scalars['String'];
}>;


export type GetDocumentUrlQuery = { __typename: 'Query', documentURL?: string | null };

export type GetInvoiceUrlQueryVariables = Exact<{
  invoiceId: Scalars['String'];
}>;


export type GetInvoiceUrlQuery = { __typename: 'Query', invoiceURL?: string | null };

export type GetMissionGeneralAssemblyPerYearQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetMissionGeneralAssemblyPerYearQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, missionGeneralAssemblyPerYear: Array<{ __typename: 'MissionGeneralAssemblyPerYear', year: string, missionGeneralAssemblyIds: Array<string> }> } };

export type GetZipDocumentWorkflowQueryVariables = Exact<{
  filename: Scalars['String'];
  ids: Array<Scalars['String']> | Scalars['String'];
  workflow?: InputMaybe<Scalars['String']>;
}>;


export type GetZipDocumentWorkflowQuery = { __typename: 'Query', zipFileWorkflow: { __typename: 'ZipFileWorkflowAcceptedResult', workflow: string } | { __typename: 'ZipFileWorkflowResult', url: string } };

export type GetFeatureFlagsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFeatureFlagsQuery = { __typename: 'Query', featureFlags: { __typename: 'FeatureFlags', activatedFeatures: Array<FeatureFlagNamesEnum> } };

export type AccountingBalanceFragment = { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type AccountingLineFragment = { __typename: 'AccountingLine', id: string, label: string, valueDate: string, dueDate: string, invoiceId?: string | null, amount: { __typename: 'Credit', value: any, currency: CurrencyEnum } | { __typename: 'Debit', value: any, currency: CurrencyEnum } };

export type AccountingPeriodFragment = { __typename: 'AccountingPeriod', id: string, name: string, openingDate: string, closingDate: string, status?: AccountingPeriodStatusEnum | null };

export type AddressFragment = { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null };

export type AllocationFragment = { __typename: 'Allocation', id: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenseTypes: Array<{ __typename: 'ExpenseType', id: string, allocationId: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'Expense', id: string, label: string, date: string, invoiceId?: string | null, piece?: { __typename: 'Document', hashFile: string, category: FileCategoryEnum, id: string } | null, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum } }> }> };

export type AmountFragment = { __typename: 'Amount', value: any, currency: CurrencyEnum };

export type BankingInformationFragment = { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null };

export type BasicBuildingFragment = { __typename: 'Building', id: string, name?: string | null, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, units: Array<{ __typename: 'Unit', id: string }> };

export type BranchFragment = { __typename: 'Branch', commercialName: string, agency: { __typename: 'Agency', id: string }, schedule: Array<{ __typename: 'BranchHour', day?: string | null, startHourAm?: string | null, startHourPm?: string | null, endHourAm?: string | null, endHourPm?: string | null, onAppointmentAm?: boolean | null, onAppointmentPm?: boolean | null }>, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, contact: { __typename: 'BranchContact', telephone?: string | null, coOwnerSinisterPhone?: string | null, tenantSinisterPhone?: string | null } };

export type BuildingFragment = { __typename: 'Building', id: string, number: string, name?: string | null, numberOfElevators?: number | null, shareBase?: number | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, physicalBuildings: Array<{ __typename: 'physicalBuilding', id: string, name: string, entrances: Array<{ __typename: 'physicalBuildingEntrance', id?: string | null, pinpad?: string | null }> }>, conciergeOffice?: { __typename: 'BuildingConciergeOffice', exist: boolean, hours?: string | null, openingDays?: string | null, phone?: string | null } | null, units: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }> };

export type CustomerFragment = { __typename: 'Customer', id: string, number: string, civility?: CivilityEnum | null, familyStatus?: FamilyStatusEnum | null, firstName?: string | null, lastName?: string | null, email?: string | null, birthDate?: string | null, noSnailMail?: boolean | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, phones: { __typename: 'CustomerPhones', landline?: string | null, mobile?: string | null }, confidentiality: { __typename: 'CustomerConfidentiality', personalData: boolean, isFirstSubmit: boolean, partnersOffersInformation: boolean }, company?: { __typename: 'CustomerCompany', name: string, siret?: string | null, legalForm?: LegalFormEnum | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null };

export type DebitLineFragment = { __typename: 'AccountingDebit', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate: string, isAuto?: boolean | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type DocumentFragment = { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null };

export type ExpectedLandlordPropertyTaxFragment = { __typename: 'ExpectedLandlordPropertyTax', fiscalYear: number, buildings: Array<{ __typename: 'ExpectedLandlordPropertyTaxBuilding', lessorPropertyTaxId?: string | null, lessorPropertyTaxBuildingId?: string | null, building: { __typename: 'Building', id: string, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } }> };

export type ExpectedPropertyTaxBuildingFragment = { __typename: 'ExpectedLandlordPropertyTaxBuilding', lessorPropertyTaxId?: string | null, lessorPropertyTaxBuildingId?: string | null, building: { __typename: 'Building', id: string, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } };

export type ExpenseFragment = { __typename: 'Expense', id: string, label: string, date: string, invoiceId?: string | null, piece?: { __typename: 'Document', hashFile: string, category: FileCategoryEnum, id: string } | null, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type ExpenseTypeFragment = { __typename: 'ExpenseType', id: string, allocationId: string, name: string, code: string, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expenses: Array<{ __typename: 'Expense', id: string, label: string, date: string, invoiceId?: string | null, piece?: { __typename: 'Document', hashFile: string, category: FileCategoryEnum, id: string } | null, toAllocate: { __typename: 'Amount', value: any, currency: CurrencyEnum }, vat: { __typename: 'Amount', value: any, currency: CurrencyEnum }, recoverable: { __typename: 'Amount', value: any, currency: CurrencyEnum } }> };

export type GeneralAssemblyFragment = { __typename: 'MissionGeneralAssembly', id: string, label?: string | null, lastValidPostalVoteReceptionDate?: string | null, hasAccessToPostalVote: boolean, hasPreVoting: boolean, status: MissionStatusEnum, officialMeeting: { __typename: 'GeneralAssemblyOfficialMeeting', date?: string | null }, meetingPlace: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } };

export type ManagerFragment = { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null };

export type MissionIncidentFragment = { __typename: 'MissionIncident', id: string, number: string, startedAt?: string | null, label?: string | null, status: MissionStatusEnum };

export type MissionMeetingAgendaFragment = { __typename: 'MissionMeetingAgenda', status: MissionStatusEnum, mission: { __typename: 'MissionGeneralAssembly', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionIncident', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionMeeting', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionRepair', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionVisit', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } };

export type MissionRepairFragment = { __typename: 'MissionRepair', id: string, number: string, startedAt?: string | null, label?: string | null, status: MissionStatusEnum };

export type MissionVisitFragment = { __typename: 'MissionVisit', id: string, label?: string | null, number: string, status: MissionStatusEnum, createdAt: string, date: { __typename: 'MissionDates', planned?: string | null }, documents: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> };

export type PageInfoFragment = { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null };

export type PaymentLineFragment = { __typename: 'AccountingPayment', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate?: string | null, isAuto?: boolean | null, paymentUrl?: string | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type PropertyAssetsFragment = { __typename: 'PropertyAssets', startDate: string, netIncomes: { __typename: 'Amount', value: any, currency: CurrencyEnum }, grossIncomes: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expensesTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, rentsCollectedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, rentsCalledTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, unpaidRentCover: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type SupplierFragment = { __typename: 'Supplier', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, activity?: string | null };

export type TicketMessageFragment = { __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null };

export type TicketActivityFragment = { __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null };

export type TicketFragment = { __typename: 'Ticket', id: string, category: TicketCategoryEnum, ticketNumber: string, status: TicketStatusEnum, createdAt: string, finishedAt?: string | null, isRead: boolean, canBeReopened: boolean, customerApprovalDate?: string | null, cancelledAt?: string | null, messages: Array<{ __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null }>, activities: Array<{ __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null }>, building?: { __typename: 'Building', id: string, number: string, name?: string | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, unit?: { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } } | null, metadata: { __typename: 'TicketMetadata', mission?: { __typename: 'TicketMission', kind: MissionKindRestrictedEnum } | null } };

export type UnitFragment = { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } };

export type GetGeneralAssembliesQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetGeneralAssembliesQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, pastGeneralAssembly?: { __typename: 'MissionGeneralAssembly', id: string, label?: string | null, lastValidPostalVoteReceptionDate?: string | null, hasAccessToPostalVote: boolean, hasPreVoting: boolean, status: MissionStatusEnum, officialMeeting: { __typename: 'GeneralAssemblyOfficialMeeting', date?: string | null }, meetingPlace: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, nextGeneralAssembly?: { __typename: 'MissionGeneralAssembly', id: string, label?: string | null, lastValidPostalVoteReceptionDate?: string | null, hasAccessToPostalVote: boolean, hasPreVoting: boolean, status: MissionStatusEnum, officialMeeting: { __typename: 'GeneralAssemblyOfficialMeeting', date?: string | null }, meetingPlace: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, nextGeneralAssemblies: Array<{ __typename: 'MissionGeneralAssembly', id: string, label?: string | null, lastValidPostalVoteReceptionDate?: string | null, hasAccessToPostalVote: boolean, hasPreVoting: boolean, status: MissionStatusEnum, officialMeeting: { __typename: 'GeneralAssemblyOfficialMeeting', date?: string | null }, meetingPlace: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } }> } | { __typename: 'LandlordAccount', uuid: string } | { __typename: 'TenantAccount', uuid: string } };

export type GetEstateListQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
}>;


export type GetEstateListQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, units: Array<{ __typename: 'CoownerAccountUnits', unit: string, saleDate?: string | null }>, building: { __typename: 'Building', id: string, number: string, name?: string | null, numberOfElevators?: number | null, shareBase?: number | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, physicalBuildings: Array<{ __typename: 'physicalBuilding', id: string, name: string, entrances: Array<{ __typename: 'physicalBuildingEntrance', id?: string | null, pinpad?: string | null }> }>, conciergeOffice?: { __typename: 'BuildingConciergeOffice', exist: boolean, hours?: string | null, openingDays?: string | null, phone?: string | null } | null, units: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }> } } | { __typename: 'LandlordAccount', uuid: string, buildings: Array<{ __typename: 'Building', id: string, number: string, name?: string | null, numberOfElevators?: number | null, shareBase?: number | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, physicalBuildings: Array<{ __typename: 'physicalBuilding', id: string, name: string, entrances: Array<{ __typename: 'physicalBuildingEntrance', id?: string | null, pinpad?: string | null }> }>, conciergeOffice?: { __typename: 'BuildingConciergeOffice', exist: boolean, hours?: string | null, openingDays?: string | null, phone?: string | null } | null, units: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }> }> } | { __typename: 'TenantAccount', uuid: string, building: { __typename: 'Building', id: string, number: string, name?: string | null, numberOfElevators?: number | null, shareBase?: number | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, physicalBuildings: Array<{ __typename: 'physicalBuilding', id: string, name: string, entrances: Array<{ __typename: 'physicalBuildingEntrance', id?: string | null, pinpad?: string | null }> }>, conciergeOffice?: { __typename: 'BuildingConciergeOffice', exist: boolean, hours?: string | null, openingDays?: string | null, phone?: string | null } | null, units: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }> } } };

export type CreateMissionWithSaleAgreementMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: CreateMissionWithSaleAgreementRequest;
}>;


export type CreateMissionWithSaleAgreementMutation = { __typename: 'Mutation', createMissionWithSaleAgreement: { __typename: 'CreateMissionWithSaleAgreementResponse', dalenysHASH: string, dalenysParameters: { __typename: 'CreateMissionWithSaleAgreementDalenysParameters', IDENTIFIER: string, OPERATIONTYPE: string, AMOUNT: number, CLIENTEMAIL: string, CLIENTIDENT: string, HIDECLIENTEMAIL: string, DESCRIPTION: string, ORDERID: string, VERSION: string, EXTRADATA: string } } };

export type GetCouncilMissionIncidentsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
  sortBy?: InputMaybe<Array<SortByType> | SortByType>;
}>;


export type GetCouncilMissionIncidentsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', missionIncidents: { __typename: 'MissionIncidentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'MissionIncidentNode', node: { __typename: 'MissionIncident', id: string, number: string, startedAt?: string | null, label?: string | null, status: MissionStatusEnum } }> } } } };

export type MissionMeetingFragment = { __typename: 'MissionMeeting', id: string, status: MissionStatusEnum, number: string, label?: string | null, date?: { __typename: 'MissionDates', planned?: string | null, end?: string | null } | null, agendas: Array<{ __typename: 'MissionMeetingAgenda', status: MissionStatusEnum, mission: { __typename: 'MissionGeneralAssembly', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionIncident', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionMeeting', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionRepair', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionVisit', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } }>, housing: { __typename: 'Building', id: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | { __typename: 'Unit' }, notes: Array<{ __typename: 'MissionMeetingNote', id: string, text?: string | null }> };

export type GetCouncilMissionMeetingsQueryVariables = Exact<{
  isPast: Scalars['Boolean'];
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type GetCouncilMissionMeetingsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', missionMeetings: { __typename: 'MissionMeetingConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'MissionMeetingNode', node: { __typename: 'MissionMeeting', id: string, status: MissionStatusEnum, number: string, label?: string | null, date?: { __typename: 'MissionDates', planned?: string | null, end?: string | null } | null, agendas: Array<{ __typename: 'MissionMeetingAgenda', status: MissionStatusEnum, mission: { __typename: 'MissionGeneralAssembly', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionIncident', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionMeeting', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionRepair', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } | { __typename: 'MissionVisit', number: string, label?: string | null, kind: MissionKindRestrictedEnum, status: MissionStatusEnum } }>, housing: { __typename: 'Building', id: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | { __typename: 'Unit' }, notes: Array<{ __typename: 'MissionMeetingNote', id: string, text?: string | null }> } }> } } } };

export type GetCouncilMissionRepairsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  sortBy?: InputMaybe<Array<SortByType> | SortByType>;
}>;


export type GetCouncilMissionRepairsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', missionRepairs: { __typename: 'MissionRepairConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'MissionRepairNode', node: { __typename: 'MissionRepair', id: string, number: string, startedAt?: string | null, label?: string | null, status: MissionStatusEnum } }> } } } };

export type SupplierContractFragment = { __typename: 'SupplierContract', id: string, label?: string | null, description?: string | null, number: string, endingDate: string, supplier: { __typename: 'Supplier', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, activity?: string | null }, documents: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> };

export type GetCouncilMissionSuppliersQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  description?: InputMaybe<Scalars['String']>;
  supplierFullname?: InputMaybe<Scalars['String']>;
  endingDateFrom?: InputMaybe<Scalars['String']>;
  endingDateTo?: InputMaybe<Scalars['String']>;
}>;


export type GetCouncilMissionSuppliersQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, trusteeCouncil: { __typename: 'TrusteeCouncil', supplierContracts: { __typename: 'SupplierContractConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'SupplierContractNode', node: { __typename: 'SupplierContract', id: string, label?: string | null, description?: string | null, number: string, endingDate: string, supplier: { __typename: 'Supplier', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, activity?: string | null }, documents: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> } }> } } } };

export type GetCouncilMissionVisitsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  first?: InputMaybe<Scalars['Int']>;
  after?: InputMaybe<Scalars['Cursor']>;
  status?: InputMaybe<Array<MissionStatusEnum> | MissionStatusEnum>;
  skipNotPaginatedData?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetCouncilMissionVisitsQuery = { __typename: 'Query', coownerAccount: { __typename: 'CoownerAccount', uuid: string, building?: { __typename: 'Building', id: string, number: string, name?: string | null, numberOfElevators?: number | null, shareBase?: number | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null }, physicalBuildings: Array<{ __typename: 'physicalBuilding', id: string, name: string, entrances: Array<{ __typename: 'physicalBuildingEntrance', id?: string | null, pinpad?: string | null }> }>, conciergeOffice?: { __typename: 'BuildingConciergeOffice', exist: boolean, hours?: string | null, openingDays?: string | null, phone?: string | null } | null, units: Array<{ __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } }> }, trusteeCouncil: { __typename: 'TrusteeCouncil', missionVisits: { __typename: 'MissionVisitConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'MissionVisitNode', node: { __typename: 'MissionVisit', id: string, label?: string | null, number: string, status: MissionStatusEnum, createdAt: string, date: { __typename: 'MissionDates', planned?: string | null }, documents: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> } }> } } } };

export type MissionWithSaleAgreementFragment = { __typename: 'MissionWithSaleAgreement', id: string, label: string, status: MissionSaleAgreementStatusEnum, orderId?: string | null, withdrawalPeriodStartedAt?: string | null, createdAt: string, documentNotificationSendedAt?: string | null, earlyExecutionRequested?: boolean | null, withdrawalDeadline?: string | null, isWithdrawable?: boolean | null, units: Array<{ __typename: 'MissionWithSaleAgreementUnit', id: string, unitLegacyNumber: string }>, document?: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } | null };

export type GetMissionsWithSaleAgreementQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetMissionsWithSaleAgreementQuery = { __typename: 'Query', missionsWithSaleAgreement: Array<{ __typename: 'MissionWithSaleAgreement', id: string, label: string, status: MissionSaleAgreementStatusEnum, orderId?: string | null, withdrawalPeriodStartedAt?: string | null, createdAt: string, documentNotificationSendedAt?: string | null, earlyExecutionRequested?: boolean | null, withdrawalDeadline?: string | null, isWithdrawable?: boolean | null, units: Array<{ __typename: 'MissionWithSaleAgreementUnit', id: string, unitLegacyNumber: string }>, document?: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } | null }> };

export type WorkOrderFragment = { __typename: 'WorkOrder', id: string, number: string, label: string, repairDate: { __typename: 'WorkOrderRepairDate', start: string, end: string }, supplier: { __typename: 'Supplier', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, activity?: string | null } };

export type GetWorkOrdersQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  missionId: Scalars['ID'];
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
}>;


export type GetWorkOrdersQuery = { __typename: 'Query', workOrders: { __typename: 'WorkOrderConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'WorkOrderNode', node: { __typename: 'WorkOrder', id: string, number: string, label: string, repairDate: { __typename: 'WorkOrderRepairDate', start: string, end: string }, supplier: { __typename: 'Supplier', id: string, name?: string | null, firstName?: string | null, lastName?: string | null, activity?: string | null } } }> } };

export type ValidMissionWithSaleAgreementMutationVariables = Exact<{
  paramsAsString: Scalars['String'];
}>;


export type ValidMissionWithSaleAgreementMutation = { __typename: 'Mutation', validMissionWithSaleAgreement: { __typename: 'ValidMissionWithSaleAgreementResponse', isSuccess: boolean, message: string } };

export type GetNatixisPaymentBanksQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNatixisPaymentBanksQuery = { __typename: 'Query', natixisPaymentBanks: Array<{ __typename: 'NatixisPaymentBank', id: string, label: string, logo?: string | null }> };

export type GetNatixisPaymentStatusQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  paymentId: Scalars['String'];
}>;


export type GetNatixisPaymentStatusQuery = { __typename: 'Query', natixisPaymentStatus: { __typename: 'NatixisPaymentStatus', status: string } };

export type NatixisPayMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: NatixisPayRequest;
}>;


export type NatixisPayMutation = { __typename: 'Mutation', natixisPay: { __typename: 'NatixisPayType', url: string } };

export type CreateDebitMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: CreateDebitRequest;
}>;


export type CreateDebitMutation = { __typename: 'Mutation', createDebit: { __typename: 'AccountingDebit', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate: string, isAuto?: boolean | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } } };

export type CreatePaymentValidationMutationVariables = Exact<{
  request: CreatePaymentValidationRequest;
}>;


export type CreatePaymentValidationMutation = { __typename: 'Mutation', createPaymentValidation: { __typename: 'CreatePaymentValidationResponse', finalDocUrl: string } };

export type CreateSepaMandateMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: CreateSepaMandateRequest;
}>;


export type CreateSepaMandateMutation = { __typename: 'Mutation', createSepaMandate: { __typename: 'CreateSepaMandateResponse', docapostSignUrl: string, dpSignatureId: string, dpTransactionId: string, validationJwt: string } };

export type CreateSepaMandateAsyncMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: CreateSepaMandateAsyncRequest;
}>;


export type CreateSepaMandateAsyncMutation = { __typename: 'Mutation', createSepaMandateAsync: { __typename: 'CreateSepaMandateAsyncResponse', workflowId: string } };

export type GetDebitLinesQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
}>;


export type GetDebitLinesQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', debits: { __typename: 'AccountingDebitConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingDebitNode', node: { __typename: 'AccountingDebit', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate: string, isAuto?: boolean | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'LandlordAccount', uuid: string, accounting: { __typename: 'Accounting', debits: { __typename: 'AccountingDebitConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingDebitNode', node: { __typename: 'AccountingDebit', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate: string, isAuto?: boolean | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', debits: { __typename: 'AccountingDebitConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingDebitNode', node: { __typename: 'AccountingDebit', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate: string, isAuto?: boolean | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } } }> } } } };

export type GetIbanValidationQueryVariables = Exact<{
  iban: Scalars['String'];
  bic?: InputMaybe<Scalars['String']>;
  allowForeignIban?: InputMaybe<Scalars['Boolean']>;
}>;


export type GetIbanValidationQuery = { __typename: 'Query', ibanValidation: { __typename: 'IbanBankingInformation', bic?: string | null } };

export type GetLandlordBankingInformationQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetLandlordBankingInformationQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, quality: AccountQualityEnum, bankingInformation: { __typename: 'DebitBankingInformation' } } | { __typename: 'LandlordAccount', uuid: string, quality: AccountQualityEnum, bankingInformation: { __typename: 'CreditBankingInformation', creditPaymentType: CreditPaymentTypeEnum, detail?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null } } | { __typename: 'TenantAccount', uuid: string, quality: AccountQualityEnum, bankingInformation: { __typename: 'DebitBankingInformation' } } };

export type GetPaymentAutomaticQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetPaymentAutomaticQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, quality: AccountQualityEnum, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, bankingInformation: { __typename: 'DebitBankingInformation', automatic?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null } } | { __typename: 'LandlordAccount', uuid: string, quality: AccountQualityEnum, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, bankingInformation: { __typename: 'CreditBankingInformation' } } | { __typename: 'TenantAccount', uuid: string, quality: AccountQualityEnum, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, bankingInformation: { __typename: 'DebitBankingInformation', automatic?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null } } };

export type GetPaymentLinesQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  pageOptions?: InputMaybe<Scalars['PageOptions']>;
}>;


export type GetPaymentLinesQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, accounting: { __typename: 'Accounting', payments: { __typename: 'AccountingPaymentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingPaymentNode', node: { __typename: 'AccountingPayment', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate?: string | null, isAuto?: boolean | null, paymentUrl?: string | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'LandlordAccount', uuid: string, accounting: { __typename: 'Accounting', payments: { __typename: 'AccountingPaymentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingPaymentNode', node: { __typename: 'AccountingPayment', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate?: string | null, isAuto?: boolean | null, paymentUrl?: string | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } } }> } } } | { __typename: 'TenantAccount', uuid: string, accounting: { __typename: 'Accounting', payments: { __typename: 'AccountingPaymentConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null, pageNumber?: number | null, itemsPerPage?: number | null, totalDisplayPages?: number | null, totalPages?: number | null }, edges: Array<{ __typename: 'AccountingPaymentNode', node: { __typename: 'AccountingPayment', id: string, status: MediaPaymentStatusEnum, motive: string, createdAt: string, instructionDate?: string | null, isAuto?: boolean | null, paymentUrl?: string | null, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } } }> } } } };

export type GetPaymentModeDataQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetPaymentModeDataQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, quality: AccountQualityEnum, bankingInformation: { __typename: 'DebitBankingInformation', hasDirectDebitPayments: boolean, automatic?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null, onDemand?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null }, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, customer: { __typename: 'Customer', isValidAddress?: boolean | null } } | { __typename: 'LandlordAccount', uuid: string, quality: AccountQualityEnum, bankingInformation: { __typename: 'CreditBankingInformation' }, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, customer: { __typename: 'Customer', isValidAddress?: boolean | null } } | { __typename: 'TenantAccount', uuid: string, quality: AccountQualityEnum, bankingInformation: { __typename: 'DebitBankingInformation', hasDirectDebitPayments: boolean, automatic?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null, onDemand?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null }, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, customer: { __typename: 'Customer', isValidAddress?: boolean | null } } };

export type GetPaymentOnDemandQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetPaymentOnDemandQuery = { __typename: 'Query', account: { __typename: 'CoownerAccount', uuid: string, quality: AccountQualityEnum, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, bankingInformation: { __typename: 'DebitBankingInformation', onDemand?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null } } | { __typename: 'LandlordAccount', uuid: string, quality: AccountQualityEnum, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, bankingInformation: { __typename: 'CreditBankingInformation' } } | { __typename: 'TenantAccount', uuid: string, quality: AccountQualityEnum, accounting: { __typename: 'Accounting', currentBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum }, projectedBalance: { __typename: 'Amount', value: any, currency: CurrencyEnum } }, bankingInformation: { __typename: 'DebitBankingInformation', onDemand?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null } } };

export type GetSepaMandateAsyncStatusQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  workflowId: Scalars['String'];
}>;


export type GetSepaMandateAsyncStatusQuery = { __typename: 'Query', getSepaMandateAsyncStatus: { __typename: 'GetSepaMandateAsyncStatusResponse', status: string, result?: { __typename: 'SepaMandateResult', docapostSignUrl: string, dpTransactionId: string, dpSignatureId: string, validationJwt: string } | null } };

export type ResiliateMandateDebitFragment = { __typename: 'ResiliateSepaMandateDebit', id: string, label: string, instructionDate: string, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } };

export type ResiliateSepaMandateMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  bankInformationId: Scalars['ID'];
}>;


export type ResiliateSepaMandateMutation = { __typename: 'Mutation', resiliateSepaMandate: { __typename: 'ResiliationSepaMandateResults', debitsCancelled: Array<{ __typename: 'ResiliateSepaMandateDebit', id: string, label: string, instructionDate: string, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } }>, debitsNotCancelled: Array<{ __typename: 'ResiliateSepaMandateDebit', id: string, label: string, instructionDate: string, amount: { __typename: 'Amount', value: any, currency: CurrencyEnum } }> } };

export type UpdateCreditBankingInformationMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: UpdateCreditBankingInformationRequest;
}>;


export type UpdateCreditBankingInformationMutation = { __typename: 'Mutation', updateCreditBankingInformation: { __typename: 'CreditBankingInformation', creditPaymentType: CreditPaymentTypeEnum, detail?: { __typename: 'BankingInformation', isOutdated?: boolean | null, detail?: { __typename: 'BankingInformationDetail', id: string, name: string, iban: string, bic: string } | null } | null } };

export type CreatePostalVoteDraftMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
  votes: Array<VoteInput> | VoteInput;
}>;


export type CreatePostalVoteDraftMutation = { __typename: 'Mutation', createPostalVoteDraft: Array<{ __typename: 'ResolutionVote', status: PostalVoteStatusEnum, resolutionId: string, candidate?: string | null, isSecondVote: boolean }> };

export type DeletePostalVoteMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
}>;


export type DeletePostalVoteMutation = { __typename: 'Mutation', deletePostalVote: string };

export type GetGeneralAssemblyDashbordQueryVariables = Exact<{
  uuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
}>;


export type GetGeneralAssemblyDashbordQuery = { __typename: 'Query', resolutions: Array<{ __typename: 'Resolution', id: string, votable: boolean, typeNumber: number, label: string, text: string, voteKind: string, proxyNumber: number, proxySubNumber: number, candidate?: string | null, isCouncilMemberVote: boolean, isEligibleSecondVote: boolean, hasVoteResolution: boolean }>, postalVoteDraft: Array<{ __typename: 'ResolutionVote', resolutionId: string, candidate?: string | null, status: PostalVoteStatusEnum, isSecondVote: boolean }>, postalVote: { __typename: 'PostalVote', voteReceptionDate?: string | null, voteDocument?: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } | null } };

export type TerminateSignaturePostalVoteResolutionsMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  generalAssemblyId: Scalars['String'];
  transactionId: Scalars['String'];
}>;


export type TerminateSignaturePostalVoteResolutionsMutation = { __typename: 'Mutation', terminateSignaturePostalVoteResolutions: { __typename: 'TerminateSignaturePostalResolutionsResponse', transactionId: string, document: { __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null } } };

export type GetPropertyAssetsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  buildingIds: Array<Scalars['String']> | Scalars['String'];
  assetsYear: Scalars['Int'];
}>;


export type GetPropertyAssetsQuery = { __typename: 'Query', propertyAssets: { __typename: 'PropertyAssets', startDate: string, netIncomes: { __typename: 'Amount', value: any, currency: CurrencyEnum }, grossIncomes: { __typename: 'Amount', value: any, currency: CurrencyEnum }, expensesTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, rentsCollectedTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, rentsCalledTotal: { __typename: 'Amount', value: any, currency: CurrencyEnum }, unpaidRentCover: { __typename: 'Amount', value: any, currency: CurrencyEnum } } };

export type ComputeExpectedLessorPropertyTaxMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: ComputeExpectedLessorPropertyTaxRequest;
}>;


export type ComputeExpectedLessorPropertyTaxMutation = { __typename: 'Mutation', computeExpectedLessorPropertyTax: boolean };

export type GetExpectedLandlordPropertyTaxesQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request?: InputMaybe<GetExpectedLandlordPropertyTaxesRequest>;
}>;


export type GetExpectedLandlordPropertyTaxesQuery = { __typename: 'Query', expectedLandlordPropertyTaxes: { __typename: 'ExpectedLandlordPropertyTaxes', item: { __typename: 'ExpectedLandlordPropertyTax', fiscalYear: number, buildings: Array<{ __typename: 'ExpectedLandlordPropertyTaxBuilding', lessorPropertyTaxId?: string | null, lessorPropertyTaxBuildingId?: string | null, building: { __typename: 'Building', id: string, number: string, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } }> } } };

export type GetExpectedLandlordPropertyTaxesFiscalYearsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
}>;


export type GetExpectedLandlordPropertyTaxesFiscalYearsQuery = { __typename: 'Query', expectedLandlordPropertyTaxesFiscalYears: { __typename: 'ExpectedLandlordPropertyTaxesFiscalYears', fiscalYears: Array<{ __typename: 'ExpectedLandlordPropertyTaxesFiscalYear', fiscalYear: number, status: ExpectedLessorPropertyTaxFiscalYearStatusEnum }> } };

export type GetExpectedLessorPropertyTaxComputeProgressQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: GetExpectedLessorPropertyTaxComputeProgressRequest;
}>;


export type GetExpectedLessorPropertyTaxComputeProgressQuery = { __typename: 'Query', expectedLessorPropertyTaxComputeProgress: { __typename: 'ExpectedLessorPropertyTaxComputeProgress', computeProgress: ExpectedLessorPropertyTaxComputeProgressEnum } };

export type UploadLandlordPropertyTaxMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: UploadLandLordPropertyTaxInput;
}>;


export type UploadLandlordPropertyTaxMutation = { __typename: 'Mutation', uploadLandlordPropertyTax: { __typename: 'LandlordPropertyTax', id: string } };

export type AddMessageTicketMutationVariables = Exact<{
  ticketId: Scalars['String'];
  message: MessageTicketInput;
  documents?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;


export type AddMessageTicketMutation = { __typename: 'Mutation', addMessageTicket: { __typename: 'Ticket', id: string, category: TicketCategoryEnum, ticketNumber: string, status: TicketStatusEnum, createdAt: string, finishedAt?: string | null, isRead: boolean, canBeReopened: boolean, customerApprovalDate?: string | null, cancelledAt?: string | null, messages: Array<{ __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null }>, activities: Array<{ __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null }>, building?: { __typename: 'Building', id: string, number: string, name?: string | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, unit?: { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } } | null, metadata: { __typename: 'TicketMetadata', mission?: { __typename: 'TicketMission', kind: MissionKindRestrictedEnum } | null } } };

export type ApproveTicketMutationVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type ApproveTicketMutation = { __typename: 'Mutation', approveTicket: { __typename: 'Ticket', id: string, category: TicketCategoryEnum, ticketNumber: string, status: TicketStatusEnum, createdAt: string, finishedAt?: string | null, isRead: boolean, canBeReopened: boolean, customerApprovalDate?: string | null, cancelledAt?: string | null, messages: Array<{ __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null }>, activities: Array<{ __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null }>, building?: { __typename: 'Building', id: string, number: string, name?: string | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, unit?: { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } } | null, metadata: { __typename: 'TicketMetadata', mission?: { __typename: 'TicketMission', kind: MissionKindRestrictedEnum } | null } } };

export type CreateTicketMutationVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  request: CreateTicketInput;
  documents?: InputMaybe<Array<Scalars['Upload']> | Scalars['Upload']>;
}>;


export type CreateTicketMutation = { __typename: 'Mutation', createTicket: { __typename: 'Ticket', id: string } };

export type GetTicketQueryVariables = Exact<{
  ticketId: Scalars['String'];
}>;


export type GetTicketQuery = { __typename: 'Query', ticket: { __typename: 'Ticket', id: string, category: TicketCategoryEnum, ticketNumber: string, status: TicketStatusEnum, createdAt: string, finishedAt?: string | null, isRead: boolean, canBeReopened: boolean, customerApprovalDate?: string | null, cancelledAt?: string | null, messages: Array<{ __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null }>, activities: Array<{ __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null }>, building?: { __typename: 'Building', id: string, number: string, name?: string | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, unit?: { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } } | null, metadata: { __typename: 'TicketMetadata', mission?: { __typename: 'TicketMission', kind: MissionKindRestrictedEnum } | null } } };

export type GetTicketsQueryVariables = Exact<{
  accountUuid: Scalars['EncodedID'];
  status?: InputMaybe<Array<TicketStatusEnum> | TicketStatusEnum>;
  category?: InputMaybe<Array<TicketCategoryEnum> | TicketCategoryEnum>;
  createdDateFrom?: InputMaybe<Scalars['String']>;
  createdDateTo?: InputMaybe<Scalars['String']>;
  ticketNumber?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Array<TicketSourceEnum> | TicketSourceEnum>;
  isRead?: InputMaybe<Scalars['Boolean']>;
  first?: InputMaybe<Scalars['Int']>;
  before?: InputMaybe<Scalars['Cursor']>;
  after?: InputMaybe<Scalars['Cursor']>;
  sortBy?: InputMaybe<Array<SortByType> | SortByType>;
}>;


export type GetTicketsQuery = { __typename: 'Query', tickets: { __typename: 'TicketConnection', totalCount?: number | null, pageInfo: { __typename: 'PageInfo', startCursor?: string | null, endCursor?: string | null, hasPreviousPage?: boolean | null, hasNextPage?: boolean | null }, edges: Array<{ __typename: 'TicketNode', node: { __typename: 'Ticket', id: string, category: TicketCategoryEnum, ticketNumber: string, status: TicketStatusEnum, createdAt: string, finishedAt?: string | null, isRead: boolean, canBeReopened: boolean, customerApprovalDate?: string | null, cancelledAt?: string | null, messages: Array<{ __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null }>, activities: Array<{ __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null }>, building?: { __typename: 'Building', id: string, number: string, name?: string | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, unit?: { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } } | null, metadata: { __typename: 'TicketMetadata', mission?: { __typename: 'TicketMission', kind: MissionKindRestrictedEnum } | null } } }> } };

export type UpdateIsReadTicketMutationVariables = Exact<{
  ticketId: Scalars['String'];
  isRead: Scalars['Boolean'];
}>;


export type UpdateIsReadTicketMutation = { __typename: 'Mutation', updateIsReadTicket: { __typename: 'Ticket', id: string, category: TicketCategoryEnum, ticketNumber: string, status: TicketStatusEnum, createdAt: string, finishedAt?: string | null, isRead: boolean, canBeReopened: boolean, customerApprovalDate?: string | null, cancelledAt?: string | null, messages: Array<{ __typename: 'TicketMessage', content: string, source?: TicketSourceEnum | null, createdBy: TicketCreatorEnum, createdAt: string, documents?: Array<{ __typename: 'Document', id: string, hashFile: string, mimeType?: string | null, originalFilename?: string | null, category: FileCategoryEnum, createdAt?: string | null }> | null, associate?: { __typename: 'Manager', id: string, email: string, firstName: string, lastName: string, branch?: { __typename: 'Branch', commercialName: string } | null } | null }>, activities: Array<{ __typename: 'TicketActivity', createdAt: string, activityType: TicketActivityEnum, metadata?: { __typename: 'ActivityMetadata', categoryAfter?: TicketCategoryEnum | null } | null }>, building?: { __typename: 'Building', id: string, number: string, name?: string | null, address: { __typename: 'Address', address1?: string | null, address2?: string | null, city?: string | null, zipCode?: string | null, countryCode?: CountryCodeEnum | null } } | null, unit?: { __typename: 'Unit', id: string, number: string, coOwnershipByLawsId?: string | null, shareBase?: number | null, fractionalShares?: number | null, situation: { __typename: 'UnitSituation', floor?: string | null, property?: string | null, stairs?: string | null, door?: string | null }, description: { __typename: 'UnitDescription', freeLabeling?: string | null, entityType?: PropertyTypeEnum | null, surface?: { __typename: 'UnitDescriptionSurface', liveable?: number | null, carrezLaw?: number | null, garden?: number | null } | null, totalRooms?: { __typename: 'UnitDescriptionRooms', liveable?: number | null, commercial?: number | null } | null } } | null, metadata: { __typename: 'TicketMetadata', mission?: { __typename: 'TicketMission', kind: MissionKindRestrictedEnum } | null } } };
